<template>
    <div class="container-fluid" id="dvcrud">
        <div class="row">
            <export-excel style="display: none;" id="btexportarexcel"
                                    :data   = "lstitensexportar"
                                    :fields = "json_fields"
                                    type    = "xls"
                                    name    = "itensnota.xls">
                                </export-excel>            
            <consultafornecedores></consultafornecedores>
			<consultaprodutos v-bind:idtabela="vidtabela" v-bind:showprtabela="vshowprtabela" v-bind:filtrotipo="tipopropesquisa"></consultaprodutos>			
            <div class="col-md-12">
                <breadcrumb v-bind:bcitens="itensbc" v-bind:mtdcancelar="mtdcancelaredicao"></breadcrumb>
            </div>
            <div class="col-md-12">
                <div id="pnlista" class="card" style="display: none;">
                    <div class="card-header"><span id="titlista">LISTAGEM DE {{ itensbc.item1.titulo }}</span>
                        <router-link to="/">
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                        </router-link>
                    </div>
                    <div class="card-body" style="padding: 10px;">
                        <div class="row">
                            <div class="col-sm-2 col-md-2 col-lg-2">
                                <label for="ednumeropesq">Número:</label>
                                <input id="ednumeropesq" type="text" class="form-control form-control-sm" v-model="pnumero" @keyup="mtdlimpar_listagem()" v-mask="'###########'">
                            </div>
                            <div class="col-sm-12 col-md-5 col-lg-5">
                                <span class="lblselect2">Fornecedor:</span>
                                <select id="cbfornecedorpesq" data-placeholder="Selecione um fornecedor" data-allow-clear="true"
                                        style="width:100%;" v-model="pidfornecedor">
                                </select>
                            </div>                           
                            <div class="col-sm-12 col-md-3 col-lg-3">
                                <span class="lblselect2">Filial:</span>
                                <select id="cbfilialpesq" data-placeholder="Selecione uma opção" data-allow-clear="true"
                                        style="width:100%;" v-model="pidfilial">
                                </select>
                            </div>                            
							<div class="col-sm-12 col-md-2 col-lg-2">
								<label for="cbfiltroperiodo">Período:</label>
								<select class="form-control form-control-sm" id="cbfiltroperiodo" v-model="pfiltroperiodo" v-bind="selecionaperiodo" @change="mtdlimpar_listagem()">
									<option value="0">Não</option>
									<option value="1">Sim</option>
								</select>
							</div>
							<div class="col-sm-12 col-md-2 col-lg-2">
								<label for="eddtini">De:</label>
								<div class="input-group">
									<date-picker id="eddtini" v-model="pdtini" :config="options" class="form-control form-control-sm" v-bind:disabled="hab_desab_periodo" @change="mtdlimpar_listagem()"></date-picker>
									<div class="input-group-append">
										<span class="input-group-text"><i class="fa fa-calendar"></i></span>
									</div>								
								</div>
							</div>
							<div class="col-sm-12 col-md-2 col-lg-2">
								<label for="eddtfim">até:</label>
								<div class="input-group">
									<date-picker id="eddtfim" v-model="pdtfim" :config="options" class="form-control form-control-sm" v-bind:disabled="hab_desab_periodo" @change="mtdlimpar_listagem()"></date-picker>
									<div class="input-group-append">
										<span class="input-group-text"><i class="fa fa-calendar"></i></span>
									</div>																			
								</div>
							</div>
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <label for="cblistar">Efetivadas:</label>
                                <select class="form-control form-control-sm" id="cblistar" v-model="pefetivadas" @change="mtdlimpar_listagem()">
                                    <option value="0">Não</option>
                                    <option value="1">Sim</option>
                                    <option value="2" selected="true">Todas</option>
                                </select>
                            </div>                                                                                    
                            <div class="col-6 col-sm-6 col-md-2 col-lg-2">
                                <label for="cbqtdreg">Registros:</label>
                                <select name="cbqtdreg" class="form-control form-control-sm" id="cbqtdreg" v-model="pqtdregistros" @change="mtdlimpar_listagem()">
                                    <option value="10">10</option>
                                    <option value="20">20</option>
                                    <option value="30">30</option>
                                    <option value="40">40</option>
                                    <option value="50">50</option>
                                    <option value="99999999999">Todos</option>
                                </select>
                            </div>
                            <div class="col-6 col-sm-6 col-md-2 col-lg-2">
                                <button type="button" id="btlistar" class="btn btn-primary btn-sm btn-block" @click.prevent="mtdexecutapesquisa()"><i class="fa fa-search"></i> Listar</button>
                            </div>                            
                            <div class="col-6 col-sm-6 col-md-2 col-lg-2">
                                <!-- <button type="button" class="btn btn-green btn-sm btn-block" @click.prevent="mtdmanifesto()" style="margin-top: 20px;"><i class="fa fa-certificate"></i> Manifestação</button> -->
                                <div class="dropdown">
                                <button type="button" class="btn btn-green btn-sm btn-block dropdown-toggle" style="margin-top: 20px;" data-toggle="dropdown">
                                    <i class="fa fa-navicon"></i> Outras
                                </button>
                                <input
                                    type="file" 
                                    id="ipselecionararquivo"
                                    accept=".xml" 
                                    @change="mtdselecionararquivoxml" 
                                    style="display: none;"
                                    ref="if_selecionarquivo"
                                >                                 
                                <div class="dropdown-menu">                                    
                                    <a class="dropdown-item" href="#" @click.prevent="mtdmanifesto()"><i class="fa fa-certificate"></i> Manifestação</a>
                                    <a class="dropdown-item" href="#" @click="$refs.if_selecionarquivo.click()"><i class="fa fa-file-code-o"></i> Importar arquivo NF-e</a>
                                </div>
                                </div>                                                
                            </div>                                                        
                            <div class="col-md-12" style="margin-top: 10px;">
                                <vue-bootstrap4-table
                                        :rows="lstnotas"
                                        :columns="columns"
                                        :config="config"
                                        :classes="classes">
                                    <template slot="empty-results">
                                        <div class="col-md-12 text-center">Sem dados para visualização</div>
                                    </template>    
                                    <!-- ícones de ordenação da table -->
                                    <template slot="sort-asc-icon">
                                        <i class="fa-icones-ordenacao fa fa-sort-asc"></i>
                                    </template>
                                    <template slot="sort-desc-icon">
                                        <i class="fa-icones-ordenacao fa fa-sort-desc"></i>
                                    </template>
                                    <template slot="no-sort-icon">
                                        <i class="fa-icones-ordenacao fa fa-unsorted"></i>
                                    </template>                                    
                                    <!--  -->                                                                    
                                    <template slot="opcoes" slot-scope="item">
                                        <button type="button" class="btn btn-primary btn-sm" @click.prevent="mtdmostrarmenu(item.row)" style="width: 35px;">
											<i class="fa fa-navicon"></i>
										</button>                                        
                                    </template>
                                    <template slot="slot_detalhes" slot-scope="item">
                                        <i @click.prevent="mtddetalhesnota(item.row)" class="fa fa-info-circle icon-detalhes" title="Detalhes da Nota"></i>
                                    </template>                                    
                                    <template slot="slot_numero" slot-scope="item">
                                        {{ item.row.numero }}
                                    </template>                                    
                                    <template slot="slot_situacao" slot-scope="item">
                                        <span v-if="parseInt(item.row.situacao) === 0" class="badge badge-pill badge-primary" style="background: #646dd4; float: left;">Em edição</span>
                                        <span v-else class="badge badge-pill badge-primary" style="background: #5a956a; float: left;">Efetivada</span>
                                        <span v-if="parseInt(item.row.atualizada) === 1" style="color: #f82b54; float: left; margin-top: -4px; margin-left: 7px;" title="Atualização de valores já processada."><i class="fa fa-check-circle-o"></i></span>
                                    </template>
                                    <template slot="slot_conferida" slot-scope="item">
                                        <span v-if="parseInt(item.row.conferida) === 1" title="Conferência finalizada"><i class="fa fa-check-square-o" style="color: #5a956a; font-weight: 600; font-size: 18px;"></i></span>
                                        <span v-else-if="parseInt(item.row.confiniciada) === 1" title="Conferência iniciada"><i class="fa fa-qrcode" style="color: rgb(84 70 70); font-weight: 600; font-size: 18px;"></i></span>
                                        <span></span>
                                    </template>                                                                         
                                    <template slot="slot_vtotvtotal" slot-scope="item">
                                        <span class="text-black-50" style="font-weight: 700;">{{ mtdformatavalordecimal(parseFloat(item.row.vtotvtotal) - (parseFloat(item.row.vtotdesc)) + parseFloat(item.row.vtotvipi) + parseFloat(item.row.vst) + parseFloat(item.row.vtotvfrete) + parseFloat(item.row.vtotvoutros), 2) }}</span>
                                    </template>                                                                        
                                </vue-bootstrap4-table>
                            </div>
                            <div class="col-md-12">
                                <ul class="list-group">
                                    <li class="list-group-item d-flex justify-content-between align-items-center" style="padding: 10px;">
                                        <span>Totalizadores <span class="badge badge-info badge-pill">{{lstnotas.length}}</span></span>
                                        <span class="badge badge-info badge-pill text-right bdg-qtd-reg-info" style="background-color: #5A956A;">{{mtdformatavalordecimal(parseFloat(totalnotas), 2)}}</span>                                        
                                        <!-- Registros
                                        <span class="badge badge-info badge-pill text-right bdg-qtd-reg-info">{{lstnotas.length}}</span> -->
                                    </li>
                                </ul>                                
                            </div>
                        </div>
                    </div>
                    <div class="card-footer" style="padding: 10px;">
                        <div class="row">                            
                            <div class="col-8 col-sm-8 col-md-10 col-lg-10" id="dvpaginacao">
                                <v-pagination
                                        v-model="pagina_atual"
                                        :page-count="pqtd_paginas"
                                        :classes="bootstrapPaginationClasses">
                                </v-pagination>
                            </div>
                            <div class="col-4 col-sm-4 col-md-2 col-lg-2">
                                <button type="button" class="btn btn-success btn-sm btn-block" @click.prevent="mtdnovo()"><i class="fa fa-file"></i> Novo</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div id="pncadastro" class="card" style="display:none;">
                    <div class="card-header"><span>{{itensbc.item2.titulo}}</span>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click.prevent="mtdcancelaredicao()"><span aria-hidden="true">&times;</span></button>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-sm-12 col-md-4 col-lg-2">
                                <label for="edidfornecedor">*Fornecedor:</label>
                                <div class="input-group">
                                    <input type="text" class="form-control form-control-sm" id="edidfornecedor" v-model="vidfornecedor" v-bind:disabled="parseInt(opcrud) !== 1" maxlength="11" v-on:blur="mtdlocalizarfornecedor(vidfornecedor)">
                                    <div class="input-group-append">
                                        <a href="#" class="btn btn-info btn-sm btn-grupo-pesq" role="button" @click.prevent="mtdconsultarfornecedor()"><i class="fa fa-search" style="padding-top: 3px;"></i></a>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-12 col-md-12 col-lg-3 col-xl-4">
                                <label for="ednomefornecedor">Nome do fornecedor:</label>
                                <input type="text" class="form-control form-control-sm" id="ednomefornecedor" v-model="vnomefornecedor"
                                    data-bv-group=".group" maxlength="50" disabled/>
                            </div>
							<div class="col-sm-12 col-md-3 col-lg-3">
								<span class="lblselect2">*Filial:</span>
								<select id="cbfilial" data-placeholder="Selecione uma filial" v-model="vidfilial" v-bind:disabled="parseInt(opcrud) !== 1" data-allow-clear="true" style="width:100%;">
								</select>
							</div>
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <label for="ednumeronota">*Nº Nota:</label>
                                    <input type="text" class="form-control form-control-sm" id="ednumeronota" v-model="vnumero"
                                        v-bind:disabled="parseInt(opcrud) !== 1" maxlength="11" v-mask="'###########'">
                            </div>
                            <div class="col-12 col-sm-2 col-md-2 col-lg-2 col-xl-1">
                                <label for="cbtipofrete">Frete:</label>
                                <select class="form-control form-control-sm" id="cbtipofrete" v-model="vtipofrete" v-bind:disabled="ativadesativa">
                                    <option value="0">CIF</option>
                                    <option value="1">FOB</option>
                                </select>
                            </div>                            
							<div class="col-sm-12 col-md-3 col-lg-2">
								<label for="eddtemissao">*Dt. Emissão:</label>
								<div class="input-group">
									<date-picker id="eddtemissao" v-model="vdtemissao" :config="options"
										class="form-control form-control-sm" v-bind:disabled="ativadesativa"></date-picker>
									<div class="input-group-append">
										<span class="input-group-text"><i class="fa fa-calendar"></i></span>
									</div>										
								</div>
							</div>
							<div class="col-sm-12 col-md-3 col-lg-2">
								<label for="eddtentrada">*Dt. Entrada:</label>
								<div class="input-group">
									<date-picker id="eddtentrada" v-model="vdtentrada" :config="options"
										class="form-control form-control-sm" v-bind:disabled="ativadesativa"></date-picker>
									<div class="input-group-append">
										<span class="input-group-text"><i class="fa fa-calendar"></i></span>
									</div>										
								</div>
							</div>
                            <div class="col-12 col-sm-2 col-md-2 col-lg-2 col-xl-2">
                                <label for="cbtiponota">Tipo:</label>
                                <select class="form-control form-control-sm" id="cbtiponota" v-model="vtipo" v-bind="camposnf" v-bind:disabled="ativadesativa">
                                    <option value="0">Nota Fiscal</option>
                                    <option value="1">Pedido</option>
                                </select>
                            </div>                                                                                    
                            <div class="col-sm-12 col-md-2 col-lg-1 col-xl-1">
                                <label for="edmodelo">Modelo:</label>
                                <input type="text" class="form-control form-control-sm" id="edmodelo" v-model="vmodelo"
                                    v-bind:disabled="hab_desab_camposnf" maxlength="2" v-mask="'##'">
                            </div>
                            <div class="col-sm-12 col-md-2 col-lg-1 col-xl-1">
                                <label for="edserie">Série:</label>
                                <input type="text" class="form-control form-control-sm" id="edserie" v-model="vserie"
                                    v-bind:disabled="hab_desab_camposnf" maxlength="3" v-mask="'###'">
                            </div>
                            <div class="col-sm-12 col-md-4 col-lg-4">
                                <label for="ednaturezaoperacao">Natureza da operação:</label>
                                <input type="text" class="form-control form-control-sm" id="ednaturezaoperacao" v-model="vnaturezaoperacao"
                                    v-bind:disabled="hab_desab_camposnf" maxlength="100">
                            </div>
                            <div class="col-sm-12 col-md-6 col-lg-6">
                                <label for="edchaveacesso">Chave de acesso:</label>
                                <input type="text" class="form-control form-control-sm" id="edchaveacesso" v-model="vchaveacesso"
                                    v-bind:disabled="hab_desab_camposnf" maxlength="100">
                            </div>
                            <div v-if="parseInt(opcrud) < 3" class="col-sm-12 col-md-4 col-lg-3 col-xl-2" style="margin-top: 20px;">
                                <button type="button" class="btn btn-primary btn-sm btn-block" @click.prevent="mtdadcionaritem()"><i class="fa fa-plus"></i> Adicionar ítem</button>
                            </div>                                                        
                        </div>
                        <div class="row" style="margin-top: 15px;">
							<div class="col-md-12">
                                <ul class="nav nav-tabs" role="tablist">
                                    <li class="nav-item">
                                        <a class="nav-link active" data-toggle="tab" href="#dvitens">Ítens da nota</a>
                                    </li>
								    <li class="nav-item">
                                        <a class="nav-link" data-toggle="tab" href="#dvobservacoes">Observações</a>
                                    </li>																		
                                </ul>
								<div class="tab-content border-left border-right border-bottom" style="padding-top: 15px; padding-bottom: 15px;">
									<div id="dvitens" class="container-fluid tab-pane active">
                                        <div class="row">
                                            <div class="col-md-12" style="margin-top: 10px;">
                                                <vue-bootstrap4-table
                                                        :rows="lstitensnota"
                                                        :columns="columnsitens"
                                                        :config="config"
                                                        :classes="classes">
                                                    <template slot="empty-results">
                                                        <div class="col-md-12 text-center">Sem dados para visualização</div>
                                                    </template>
                                                    <!-- ícones de ordenação da table -->
                                                    <template slot="sort-asc-icon">
                                                        <i class="fa-icones-ordenacao fa fa-sort-asc"></i>
                                                    </template>
                                                    <template slot="sort-desc-icon">
                                                        <i class="fa-icones-ordenacao fa fa-sort-desc"></i>
                                                    </template>
                                                    <template slot="no-sort-icon">
                                                        <i class="fa-icones-ordenacao fa fa-unsorted"></i>
                                                    </template>                                    
                                                    <!--  -->                                                    
                                                    <template slot="opcoes" slot-scope="item">
                                                        <button type="button" class="btn btn-info btn-sm btn-opcrud ajt-btn" @click.prevent="mtdalteraritemnota(item.row)" v-bind:disabled="parseInt(opcrud) === 3"><i class="fa fa-edit"></i></button>
                                                        <button type="button" class="btn btn-danger btn-sm btn-opcrud ajt-btn" @click.prevent="mtdexcuiritem(item.row)" v-bind:disabled="parseInt(opcrud) === 3"><i class="fa fa-trash"></i></button>
                                                    </template>
                                                    <template slot="id_item" slot-scope="item">
                                                        {{item.row.item}}
                                                    </template>
                                                    <template slot="slot_prcompra" slot-scope="item">
                                                        {{ mtdformatavalordecimal(parseFloat(item.row.prcompra), 3) }}
                                                    </template>
                                                    <template slot="slot_desconto" slot-scope="item">
                                                        {{ mtdformatavalordecimal(parseFloat(item.row.vdesconto), 3) }}
                                                    </template>
                                                    <template slot="slot_total" slot-scope="item">
                                                        {{ mtdformatavalordecimal(parseFloat(item.row.vvtotal), 3) }}
                                                    </template>
                                                    <template slot="slot_precos" slot-scope="item">
                                                        <ul class="list-group">
                                                            <li v-for="(tabela, indexf) in item.row.tabelas" v-bind:key="indexf" class="list-group-item d-flex justify-content-between align-items-center" style="padding: 2px; font-size:10px;">
                                                                <span class="lblforma">{{tabela.desctabela}}</span>
                                                                <span class="lblforma" style="font-weight: bold;">{{formatavalores(parseFloat(tabela.prtabela), '')}}</span>
                                                            </li>
                                                        </ul>                                        
                                                    </template>                                                                                                        
                                                </vue-bootstrap4-table>
                                            </div>                                            
										</div>
									</div>
									<div id="dvobservacoes" class="container-fluid tab-pane">
										<div class="row">
                                            <div class="col-sm-12">
                                                <textarea class="form-control center" rows="5" id="txtobservacoes" v-model="vobservacoes" v-bind:disabled="ativadesativa"></textarea>
                                            </div>											
										</div>
									</div>                                    
								</div>                                                                        
							</div>

                            <div class="col-sm-12" style="margin-top: 15px;">
                                <div class="card" id="dvtotalizadores">
                                    <div class="card-body">
                                        <div class="row">
                                            <div class="col-md-12" style="margin-bottom: 10px;">
                                                <div class="card">
                                                    <div class="card-body text-center" style="padding: 5px;">
                                                        <h6 id="tittotalizadores" style="margin-top: 5px;">TOTAIS DA NOTA</h6>
                                                        <button type="button" @click.prevent="mtdalterartotalizadores()" title="Editar totalizadores"
                                                            class="btn btn-info btn-sm"
                                                            style="font-size: 10px; float: right; margin-top: -22px;">                                                            
                                                            <i class="fa fa-edit"></i>
                                                        </button>                                                        
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-sm-12 col-md-3 col-lg-3">
                                                <ul class="list-group">
                                                    <a class="list-group-item lstdettot">Total ICMS <span class="badge badge-info bdg-totais">{{ mtdformatavalordecimal(vtotvicms, 2) }}</span></a>                                                    
                                                    <a class="list-group-item lstdettot">Total IPI<span class="badge badge-info bdg-totais">{{ mtdformatavalordecimal(vtotvipi, 2) }}</span></a>
                                                </ul>
                                            </div>
                                            <div class="col-sm-12 col-md-3 col-lg-3">
                                                <ul class="list-group">
                                                    <a class="list-group-item lstdettot">Total Frete <span class="badge badge-info bdg-totais">{{ mtdformatavalordecimal(vtotvfrete, 2) }}</span></a>                                                    
                                                    <a class="list-group-item lstdettot">Total Outros<span class="badge badge-info bdg-totais">{{ mtdformatavalordecimal(vtotvoutros, 2) }}</span></a>
                                                </ul>                                                
                                            </div>
                                            <div class="col-sm-12 col-md-3 col-lg-3">
                                                <ul class="list-group">                                                    
                                                    <a class="list-group-item lstdettot">Total PIS <span class="badge badge-info bdg-totais">{{ mtdformatavalordecimal(vtotvpis, 2) }}</span></a>
                                                    <a class="list-group-item lstdettot">Total COFINS <span class="badge badge-info bdg-totais">{{ mtdformatavalordecimal(vtotvcofins, 2) }}</span></a>
                                                </ul>
                                            </div>
                                            <!-- <div class="col-sm-12 col-md-3 col-lg-3">
                                                <ul class="list-group">                                                                                                        
                                                    <a class="list-group-item lstdettot">Total ST <span class="badge badge-info bdg-totais" style="background-color: #5A956A;">{{ mtdformatavalordecimal(vtotst, 2) }}</span></a>                                                    
                                                    <a class="list-group-item lstdettot">Total do Custo <span class="badge badge-info bdg-totais" style="background-color: #f82b54;">{{ mtdformatavalordecimal(vtotvcusto, 2) }}</span></a>                                                    
                                                </ul>
                                            </div> -->
                                            <div class="col-sm-12 col-md-3 col-lg-3">
                                                <ul class="list-group">                                                                                                        
                                                    <a class="list-group-item lstdettot">Total ST <span class="badge badge-info bdg-totais" style="background-color: #5A956A;">{{ mtdformatavalordecimal(vtotst, 2) }}</span></a>                                                    
                                                    <a class="list-group-item lstdettot">Total dos produtos <span class="badge badge-info bdg-totais" style="background-color: #727cf5;">{{ mtdformatavalordecimal(vtotvtotal, 2) }}</span></a>                                                    
                                                </ul>
                                            </div>                                            
                                            <div class="col-sm-12 col-md-9 col-lg-9 text-center">
                                            </div>                                            
                                            <div class="col-sm-12 col-md-3 col-lg-3">
                                                <ul class="list-group">                                                    
                                                    <a class="list-group-item lstdettot">Total da Nota <span class="badge badge-info bdg-totais" style="background-color: #5A956A;">{{ mtdformatavalordecimal(parseFloat(vtotvtotal) - parseFloat(vtotdesc) + parseFloat(vtotvipi) + parseFloat(vtotst) + parseFloat(vtotvfrete) + parseFloat(vtotvoutros), 2) }}</span></a>                                                    
                                                </ul>
                                            </div>                                                    
                                        </div>
                                    </div>
                                </div>
                            </div>                            
                        </div>                        
                    </div>
                    <div class="card-footer">
                        <div class="row">
                            <div class="col-sm-8">
                                <h5 style="font-size: 16px; color: #545b62; margin-top: 5px;"><strong>Campos com asterisco(*) devem ser informados</strong>.</h5>
                            </div>
                            <div class="col-sm-2">
                                <button id="btgravar" v-if="(opcrud == 1)" type="button" @click.prevent="mtdgravar()"
                                        v-bind:disabled="validou" class="btn btn-primary btn-sm"
                                        style="width:100%; margin-bottom:10px;"><i class="fa fa-check"></i> Gravar
                                </button>
                                <button id="btgravar" v-else-if="(opcrud == 2)" type="button" @click.prevent="mtdgravar()"
                                        v-bind:disabled="validou" class="btn btn-primary btn-sm"
                                        style="width:100%; margin-bottom:10px;"><i class="fa fa-check"></i> Alterar
                                </button>
                                <button id="btgravar" v-else-if="(opcrud == 3)" type="button" @click.prevent="mtdgravar()"
                                        v-bind:disabled="validou" class="btn btn-primary btn-sm"
                                        style="width:100%; margin-bottom:10px;"><i class="fa fa-check"></i> Excluir
                                </button>
                            </div>
                            <div class="col-sm-2">
                                <button type="button" @click.prevent="mtdcancelaredicao()" class="btn btn-secondary btn-sm" style="width:100%">
                                    <i class="fa fa-close"></i> Cancelar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div id="pnconferencia" class="card" style="display:none;">
                    <div class="card-header"><span>{{itensbc.item2.titulo}}</span>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click.prevent="mtdcancelarconf()"><span aria-hidden="true">&times;</span></button>
                    </div>
                    <div class="card-body" style="padding: 10px;">
                        <span v-if="!vachouPro" class="badge badge-info badge-pill text-center bdg-alerta" style="width: 100% !important;">{{vmsgPro}}</span>
                        <span v-else class="badge badge-info badge-pill text-center bdg-success" style="width: 100% !important;">{{vmsgPro}}</span>
                        <span v-if="vfinalizado" class="badge badge-info badge-pill text-center bdg-finalizado" style="width: 100% !important;">CONFERÊNCIA FINALIZADA</span>

                        <div class="row">
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <label for="edvicodpro">Produto:</label>
                                <div class="input-group mb-3">
                                    <input type="text" class="form-control form-control-sm" id="edvicodpro" title="F2 pesquisar produto" v-on:keyup.13="submitProd()"
                                        v-model="vicodpro" placeholder="Pesquisar..." v-bind:disabled="ativadesativacod" autocomplete="off">
                                    <div class="input-group-append">
                                        <a href="#" class="btn btn-info btn-sm btn-grupo-pesq" role="button" @click.prevent="mtddefinemultiplicador()" title="Define o multiplicador"><i class="fa fa-calculator" style="padding-top: 3px;"></i></a>
                                    </div>                                        
                                </div>
                            </div>
                            <div class="col-sm-12 col-md-6 col-lg-6">
                                <label for="eddescpro">Descrição do produto:</label>
                                <input type="text" v-model="videscpro" class="form-control form-control-sm" id="eddescpro" disabled
                                    style="text-transform: uppercase; font-weight: bold;">
                            </div>
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <label for="edmult">Multiplicador:</label>
                                <input type="text" v-model="vmultiplicador" class="form-control form-control-sm" id="edmult" disabled
                                    style="text-transform: uppercase; font-weight: bold; text-align: center;">
                            </div>                            
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <label for="edqtdfalta">Qtd. Falta:</label>
                                <input type="text" v-model="vqtdfalta" class="form-control form-control-sm" id="edqtdfalta" disabled
                                    style="text-transform: uppercase; font-weight: bold; text-align: center;">
                            </div>							                               
                        </div>
                    </div>

                    <div class="col-md-12" style="margin-top: 10px;">
                        <vue-bootstrap4-table
                            :rows="lstitensnotas"
                            :columns="columnsconf"
                            :config="config"
                            :classes="classes">

                            <template slot="empty-results">
                                <div class="col-md-12 text-center">Sem dados para visualização</div>
                            </template>
                            <template slot="status_s" slot-scope="item">
                                <span v-if="item.row.situacao === 1" title="Status"><i class="fa fa-check-square-o" style="color: rgb(90, 149, 106); font-weight: 600; font-size: 18px;"></i></span>
                                <span v-else title="Status" style="color: rgb(248, 43, 84); font-weight: 600; font-size: 18px;"><i class="fa fa-check-circle-o"></i></span>
                            </template>
                        </vue-bootstrap4-table>
                    </div>

                    <div class="col-md-12" style="margin-bottom: 15px;">
                        <ul class="list-group">
                        <li class="list-group-item d-flex justify-content-between align-items-center" style="padding: 10px;">
                            Total de itens                            
                            <span class="badge badge-info badge-pill text-right bdg-qtd-reg-info" style="width: 182px !important;">{{lstitensnotas.length}}</span>
                        </li>
                        </ul>
                    </div>

					<div class="card-footer" style="padding: 10px;">
						<div class="row">
							<div class="col-4 col-sm-4 col-md-2 col-lg-2">
								<button type="button" class="btn btn-secondary btn-sm btn-block" @click.prevent="mtdcancelarconf()"><i class="fa fa-close"></i> Cancelar</button>
							</div>               
							<div class="col-4 col-sm-4 col-md-2 col-lg-2">
								<button type="button" id="btngravar" class="btn btn-success btn-sm btn-block" v-bind:disabled="temItens" @click.prevent="mtdgravarconf()"><i class="fa fa-file"></i> Gravar</button>
							</div>
						</div>
					</div>
                </div>
            </div>
        </div>
        <!-- Modal do menu -->
		<div class="modal fade" id="mdmenunotafornecedor">
			<div class="modal-dialog modal-sm modal-dialog-centered">
			<div class="modal-content">
				<div class="modal-body">
					<div class="row">
						<div class="col-md-12">
							<ul class="list-group" style="cursor: pointer;">
								<li class="list-group-item text-center active" style="font-size: 12px;">
                                    <span class="font-weight-bold">{{ notamenu.numero }}</span><br>
                                    <span style="font-weight: 400;">{{notamenu.nomefornecedor}}</span>
                                </li>
								<li class="list-group-item list-group-item-action font-weight-bold" style="color: #6c757d;" @click.prevent="mtdalterar(notamenu)" data-dismiss="modal"><i class="fa fa-edit"></i> ALTERAR</li>
								<li class="list-group-item list-group-item-action font-weight-bold" style="color: #6c757d;" @click.prevent="mtdexcluir(notamenu)" data-dismiss="modal"><i class="fa fa-trash"></i> EXCLUIR</li>
								<!-- <li v-if="notamenu.xml !== ''" class="list-group-item list-group-item-action font-weight-bold" style="color: #6c757d;" @click.prevent="mtdimprimirdanfe(notamenu.numero)" data-dismiss="modal"><i class="fa fa-print"></i> IMPRIMIR DANFE</li>								 -->
                                <li class="list-group-item list-group-item-action font-weight-bold" style="color: #6c757d;" @click.prevent="mtddetalhesnota(notamenu)" data-dismiss="modal"><i class="fa fa-info-circle"></i> DETALHES</li>
                                <li v-if="parseInt(notamenu.conferida) === 0 && parseInt(notamenu.situacao) === 0" class="list-group-item list-group-item-action font-weight-bold" style="color: #6c757d;" @click.prevent="mtdconferencia(notamenu)" data-dismiss="modal"><i class="fa fa-refresh"></i> CONFERÊNCIA</li>
								<li v-if="parseInt(notamenu.situacao) === 0" class="list-group-item list-group-item-action font-weight-bold" style="color: #6c757d;" @click.prevent="mtdefetivarnota(notamenu)" data-dismiss="modal"><i class="fa fa-check"></i> EFETIVAR</li>
                                <li v-if="parseInt(notamenu.situacao) === 1 && parseInt(notamenu.atualizada) === 0" class="list-group-item list-group-item-action font-weight-bold" style="color: #6c757d;" @click.prevent="mtdrotinaatualizacoes(notamenu)" data-dismiss="modal"><i class="fa fa-refresh"></i> ATUALIZAÇÕES</li>
							</ul>
						</div>
					</div>
				</div>
				<div class="modal-footer" style="padding: 5px;">
					<div class="container-fluid">
						<div class="row">
							<div class="col-md-12 text-center">
								<button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal" style="width: 150px;"><i class="fa fa-close"></i> Cancelar</button>
							</div>
						</div>					
					</div>
				</div>				        
			</div>
			</div>
		</div> 
        <!-- Modal de edição do ítem -->
        <div class="modal fade" id="mdedicaoitem" tabindex="-1" aria-labelledby="mdltitulo" aria-hidden="true">
			<div class="modal-dialog modal-xl modal-dialog-scrollable modal-dialog-centered">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title" id="mdltitulo"><i class="fa fa-edit"></i> Edição de item</h5>
						<button type="button" class="close" data-dismiss="modal" aria-label="Close">
						<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="modal-body">
						<div class="row">
							<div class="col-sm-12 col-md-3 col-lg-3">
								<label for="edidprodutoedicao">*Produto:</label>
								<div class="input-group" style="z-index: 1;">
									<input type="text" class="form-control form-control-sm" id="edidprodutoedicao" v-bind:disabled="parseInt(vopitem) === 2" v-model="vcoddigedicao" maxlength="20" v-on:blur="mtdlocalizarproduto(vcoddigedicao, 0)" v-on:keyup.13="mtdlocalizarproduto(vcoddigedicao, 0)" style="text-transform: uppercase;">
									<div class="input-group-append">
										<a href="#" class="btn btn-info btn-sm btn-grupo-pesq" role="button" @click.prevent="mtdconsultarproduto(0, [])"><i class="fa fa-search" style="padding-top: 3px;"></i></a>
									</div>
								</div>
							</div>
							<div class="col-sm-12 col-md-6 col-lg-6">
								<label for="eddescricaoprodutoedicao">Descrição do produto:</label>
								<input type="text" class="form-control form-control-sm" id="eddescricaoprodutoedicao" v-model="vdescricaoprodutoedicao" maxlength="100" style="font-weight: bold;" disabled>								
							</div>
							<div class="col-sm-12 col-md-1 col-lg-1">
								<label for="edundprodutoedicao">Und:</label>
								<input type="text" class="form-control form-control-sm" id="edundprodutoedicao" v-model="vundprodutoedicao" data-bv-group=".group" maxlength="2" disabled style="font-weight: bold;"/>
							</div>
							<div class="col-sm-12 col-md-2 col-lg-2">
								<label for="edqtditemedicao">*Quantidade:</label>
								<money type="text" class="form-control form-control-sm" id="edqtditemedicao" 
                                    v-model="vqtditemedicao" v-bind="money3" @keyup.native="mtdcalculaperc"
                                    data-bv-group=".group" style="text-align:right;"></money>
							</div>
							<div class="col-sm-12 col-md-2 col-lg-2">
								<label for="edprcompra">*Pr. Compra:</label>
								<money type="text" class="form-control form-control-sm input-money" id="edprcompra" 
                                    v-model="vprcompra" v-bind="money3" v-bind:value="calculavaloresitem" @keyup.native="mtdcalculaperc"
                                    data-bv-group=".group" style="text-align:right;">
                                </money>
							</div>
							<div class="col-sm-12 col-md-2 col-lg-2">
								<label for="edvdesconto">Desconto($):</label>
								<money type="text" class="form-control form-control-sm input-money" id="edvdesconto" 
                                    v-model="vvdesconto" v-bind="money3" v-bind:value="calculavaloresitem" @keyup.native="mtdcalculaperc"
                                    data-bv-group=".group" style="text-align:right;">
                                </money>
							</div>														
							<div class="col-sm-12 col-md-3 col-lg-3">
								<span class="lblselect2">*Estoque:</span>
								<select id="cbestoqueedicao" data-placeholder="Selecione um estoque" v-model="videstoqueedicao" data-allow-clear="true" style="width:100%;">
								</select>
							</div>	
                            <div class="col-sm-12 col-md-3 col-lg-3">
								<span class="lblselect2">*CFOP ({{ vidcfop }}):</span>
								<select id="cbcfopedicao" data-placeholder="Selecione um cfop" v-model="vidcfop" data-allow-clear="true" style="width:100%;">
								</select>
							</div>														
						</div>
                        <div class="row" style="margin-top: 15px;">
                            <div class="col-md-12">
                                <ul class="nav nav-tabs" role="tablist">
                                    <li class="nav-item">
                                        <a class="nav-link active" data-toggle="tab" href="#dvcusto">Composição de custo</a>
                                    </li>
                                    <li v-show="vhabilitaedicaotabelas" class="nav-item">
                                        <a class="nav-link" data-toggle="tab" href="#dvprecos">Composição de preços de venda</a>
                                    </li>
                                    <li v-show="vhabilitaedicaoclasses" class="nav-item">
                                        <a class="nav-link" data-toggle="tab" href="#dvclasses">Classes de impostos</a>
                                    </li>                                    
                                </ul>
                                <div class="tab-content border-left border-right border-bottom" style="padding-top: 15px; padding-bottom: 15px;">
                                    <div id="dvcusto" class="container tab-pane active">
										<div class="row">
											<div class="col-sm-12 col-md-2 col-lg-2">
												<label for="edpicms">ICMS(%):</label>
												<money type="text" class="form-control form-control-sm" id="edpicms" 
                                                    v-model="vpicms" v-bind="[money3, calculavaloresitem]" @keyup.native="mtdcalculaperc" 
                                                    data-bv-group=".group" style="text-align:right;">
                                                </money>
											</div>
											<div class="col-sm-12 col-md-2 col-lg-2">
												<label for="edvicms">ICMS($):</label>
												<money type="text" class="form-control form-control-sm input-money" id="edvicms"
                                                    v-model="vvicms" v-bind="[money3, calculavaloresitem]" @keyup.native="mtdcalculavalor" 
                                                    data-bv-group=".group" style="text-align:right;">
                                                </money>
											</div>
											<div class="col-sm-12 col-md-2 col-lg-2">
												<label for="edpipi">IPI(%):</label>
												<money type="text" class="form-control form-control-sm" id="edpipi" 
                                                    v-model="vpipi" v-bind="[money3, calculavaloresitem]" @keyup.native="mtdcalculaperc"
                                                    data-bv-group=".group" style="text-align:right;">
                                                </money>
											</div>
											<div class="col-sm-12 col-md-2 col-lg-2">
												<label for="edvipi">IPI($):</label>
												<money type="text" class="form-control form-control-sm input-money" id="edvipi" 
                                                    v-model="vvipi" v-bind="[money3, calculavaloresitem]" @keyup.native="mtdcalculavalor"
                                                    data-bv-group=".group" style="text-align:right;">
                                                </money>
											</div>
											<div class="col-sm-12 col-md-2 col-lg-2">
												<label for="edpfrete">FRETE(%):</label>
												<money type="text" class="form-control form-control-sm" id="edpfrete" v-model="vpfrete" 
                                                    v-bind="[money3, calculavaloresitem]" @keyup.native="mtdcalculaperc"
                                                    data-bv-group=".group" style="text-align:right;">
                                                </money>
											</div>
											<div class="col-sm-12 col-md-2 col-lg-2">
												<label for="edvfrete">FRETE($):</label>
												<money type="text" class="form-control form-control-sm input-money" id="edvfrete" 
                                                    v-model="vvfrete" v-bind="[money3, calculavaloresitem]" @keyup.native="mtdcalculavalor"
                                                    data-bv-group=".group" style="text-align:right;">
                                                </money>
											</div>																						
										</div>
										<div class="row">
											<div class="col-sm-12 col-md-2 col-lg-2">
												<label for="edpoutros">OUTROS(%):</label>
												<money type="text" class="form-control form-control-sm" id="edpoutros" 
                                                    v-model="vpoutros" v-bind="[money3, calculavaloresitem]" @keyup.native="mtdcalculaperc"
                                                    data-bv-group=".group" style="text-align:right;">
                                                </money>
											</div>
											<div class="col-sm-12 col-md-2 col-lg-2">
												<label for="edvoutros">OUTROS($):</label>
												<money type="text" class="form-control form-control-sm input-money" id="edvoutros" 
                                                    v-model="vvoutros" v-bind="[money3, calculavaloresitem]" @keyup.native="mtdcalculavalor"
                                                    data-bv-group=".group" style="text-align:right;">
                                                </money>
											</div>
											<div class="col-sm-12 col-md-2 col-lg-2">
												<label for="edvst">ST($):</label>
												<money type="text" class="form-control form-control-sm input-money" id="edvst" 
                                                    v-model="vvicmsst" v-bind="[money3, calculavaloresitem]" @keyup.native="mtdcalculavalor"
                                                    data-bv-group=".group" style="text-align:right;" title="Valor da substituição deve ser unitário">
                                                </money>
											</div>                                            
											<div class="col-sm-12 col-md-2 col-lg-2">
												<label for="edppis">PIS(%):</label>
												<money type="text" class="form-control form-control-sm" id="edppis" 
                                                    v-model="vppis" v-bind="[money3, calculavaloresitem]" @keyup.native="mtdcalculaperc" 
                                                    data-bv-group=".group" style="text-align:right;">
                                                </money>
											</div>
											<div class="col-sm-12 col-md-2 col-lg-2">
												<label for="edvpis">PIS($):</label>
												<money type="text" class="form-control form-control-sm input-money" id="edvpis" 
                                                    v-model="vvpis" v-bind="[money3, calculavaloresitem]" @keyup.native="mtdcalculavalor"
                                                    data-bv-group=".group" style="text-align:right;">
                                                </money>
											</div>
											<div class="col-sm-12 col-md-2 col-lg-2">
												<label for="edpcofins">COFINS(%):</label>
												<money type="text" class="form-control form-control-sm" id="edpcofins" 
                                                    v-model="vpcofins" v-bind="[money3, calculavaloresitem]" @keyup.native="mtdcalculaperc" 
                                                    data-bv-group=".group" style="text-align:right;">
                                                </money>
											</div>
											<div class="col-sm-12 col-md-2 col-lg-2">
												<label for="edvcofins">COFINS($):</label>
												<money type="text" class="form-control form-control-sm input-money" id="edvcofins" 
                                                    v-model="vvcofins" v-bind="[money3, calculavaloresitem]" @keyup.native="mtdcalculavalor"
                                                    data-bv-group=".group" style="text-align:right;">
                                                </money>
											</div>											
										</div>
                                        <div class="row">
                                            <div class="col-md-2">
                                            </div>
                                            <div class="col-sm-12 col-md-2 col-lg-2" style="padding-top: 25px;">
                                                <div class="custom-control custom-switch" style="position: absolute; left: 15px;">
                                                    <input type="checkbox" class="custom-control-input" id="swcalcularprvendamedio" 
                                                    name="swcalcularprvendamedio" v-model="vcalcularprvendamedio">
                                                    <label class="custom-control-label" for="swcalcularprvendamedio">Informar Pr. Venda</label>
                                                </div>						                                
                                            </div>    
                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                <label for="edprvendamedio">Pr. Venda(média):</label>
                                                <div class="input-group" style="z-index: 1;">
                                                    <money type="text" class="form-control form-control-sm input-money" id="edprvendamedio" v-model="vprvendamedio" v-bind="money" data-bv-group=".group" style="text-align:right;" v-bind:disabled="!vcalcularprvendamedio"></money>
                                                    <div class="input-group-append" style="height: 31px;">
                                                        <button class="btn btn-info btn-sm" v-bind:disabled="!vcalcularprvendamedio" title="Informar a margem(%)" @click.prevent="mtddefinirmargemprvenda()" style="border-top-left-radius: 0px!important; border-bottom-left-radius: 0px!important;"><i class="fa fa-percent"></i></button>
                                                    </div>           
                                                </div>   
                                            </div>							
                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                <label for="edprcusto">Pr. Custo:</label>
                                                <money type="text" class="form-control form-control-sm input-money" id="edprcusto" v-model="vprcusto" v-bind="money3" data-bv-group=".group" style="text-align:right;" disabled></money>
                                            </div>
                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                <label for="edvtotal">Total Item:</label>
                                                <money type="text" class="form-control form-control-sm input-money" id="edvtotal" v-bind="money" v-model="vvtotal" data-bv-group=".group" style="text-align:right;" disabled></money>
                                            </div>							                            
                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                <label for="edvtotalcusto">Total Custo:</label>
                                                <money type="text" class="form-control form-control-sm input-money-red" id="edvtotalcusto" v-model="vvtotalcusto" v-bind="money3" data-bv-group=".group" style="text-align:right;" disabled></money>
                                            </div>
                                        </div>                                        
                                    </div>
                                    <div v-show="vhabilitaedicaotabelas" id="dvprecos" class="container tab-pane fade">
                                        <div class="row">
                                            <template v-if="parseInt(voptabela) === 2">
                                                <div class="col-sm-12 col-md-6 col-lg-6">
                                                    <span class="lblselect2">Tabela:</span>
                                                    <select id="cbtabelapreco" v-model="vidtabelapreco" v-bind:disabled="habdestab"
                                                            data-placeholder="Selecione uma tabela" data-allow-clear="true" style="width:100%;">
                                                    </select>
                                                </div>
                                            </template>
                                            <template v-else>
                                                <div class="col-sm-12 col-md-8 col-lg-8">
                                                    <span class="lblselect2">Tabela:</span>
                                                    <select id="cbtabelapreco" v-model="vidtabelapreco" v-bind:disabled="habdestab"
                                                            data-placeholder="Selecione uma tabela" data-allow-clear="true" style="width:100%;">
                                                    </select>
                                                </div>
                                            </template>
                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                <label for="edmrgtabela">Mrg(%):</label>
                                                <money type="text" class="form-control form-control-sm" id="edmrgtabela"
                                                        v-model="vmrgtabela" v-bind="money"  
                                                        data-bv-group=".group" style="text-align:right;">
                                                </money>
                                            </div>
                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                <label for="edvltabela">Valor:</label>
                                                <div class="input-group" style="z-index: 1;">                                                
                                                    <money type="text" class="form-control form-control-sm" id="edvltabela"
                                                            v-model="vvltabela" v-bind="money" 
                                                            data-bv-group=".group" style="text-align:right; background: honeydew; color:darkgreen; font-weight:bold;">
                                                    </money>
                                                    <div class="input-group-append" style="height: 31px;">
                                                        <button class="btn btn-primary" title="Visualizar imposto sobre valor" @click.prevent="mtdvisualizarimpostovalor()" style="border-top-left-radius: 0px!important; border-bottom-left-radius: 0px!important;"><i class="fa fa-dollar"></i></button>
                                                    </div>                                                    
                                                </div>
                                            </div>         
                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                <label for="edcomissaotabela">Comissão(%):</label>
                                                <money type="text" class="form-control form-control-sm" id="edcomissaotabela"
                                                        v-model="vcomissaotabela" v-bind="money" 
                                                        data-bv-group=".group" style="text-align:right;">
                                                </money>
                                            </div>
                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                <label for="eddescontotabela">Qtd. Mínima:</label>
                                                <money type="text" class="form-control form-control-sm" id="eddescontotabela"
                                                        v-model="vqtdmintabela" v-bind="money" 
                                                        data-bv-group=".group" style="text-align:right;">
                                                </money>
                                            </div>
                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                <label for="edqtdmintabela">Desconto %:</label>
                                                <money type="text" class="form-control form-control-sm" id="edqtdmintabela"
                                                        v-model="vdescontotabela" v-bind="money" 
                                                        data-bv-group=".group" style="text-align:right;">
                                                </money>
                                            </div> 
                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                <label for="edvldescpromocional">Desc. promocional(%):</label>
                                                <div class="input-group" style="z-index: 1;">
                                                    <money type="text" class="form-control form-control-sm" id="edvldescpromocional"
                                                        v-model="vvldescpromocional" v-bind="money" v-bind:disabled="ativadesativa"
                                                        data-bv-group=".group" style="text-align:right; background: honeydew; color:darkgreen; font-weight:bold;">
                                                    </money>
                                                    <div class="input-group-append" style="height: 31px;">
                                                        <button class="btn btn-primary" title="Informar o valor para calcular o percentual" @click.prevent="mtdinformarvalordescpromocional()" style="border-top-left-radius: 0px!important; border-bottom-left-radius: 0px!important;"><i class="fa fa-dollar"></i></button>
                                                    </div>                                                             
                                                </div>
                                            </div> 
                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                <label for="edqtdmintabela">Pr. auxiliar($):</label>
                                                <money type="text" class="form-control form-control-sm" id="edqtdmintabela" title="Este preço é utilizado apenas para definir o valor de tabela para visualização na impressão/catalogo de produtos"
                                                        v-model="vvlvizu" v-bind="money" v-bind:disabled="ativadesativa"
                                                        data-bv-group=".group" style="text-align:right;">
                                                </money>
                                            </div>                                                  
                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                <button v-if="parseInt(voptabela) === 1" type="button" id="btinctabela" class="btn btn-info btn-sm"
                                                        @click.prevent="mtdgravartabela()" 
                                                        style="width:100%; margin-top: 21px;"><i class="fa fa-plus-circle"></i>
                                                    Incluir
                                                </button>
                                                <button v-else type="button" id="btalttabela" class="btn btn-secondary btn-sm"
                                                        @click.prevent="mtdgravartabela()" v-bind:disabled="ativadesativa"
                                                        style="width:100%; margin-top: 21px;"><i class="fa fa-check"></i>
                                                    Salvar
                                                </button>                                                 
                                            </div>
                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                <button v-if="parseInt(voptabela) === 2" type="button" id="btcancelartabela" class="btn btn-secondary btn-sm"
                                                        @click.prevent="mtdcancelartabela()"
                                                        style="width:100%; margin-top: 21px;"><i class="fa fa-undo"></i>
                                                    Cancelar
                                                </button>                                                        
                                            </div>                                            
                                            <div v-if="lstTabelasPrecos.length > 0" class="col-lg-12">
                                                <div class="table-responsive">
                                                    <table id="tblistatbpro" class="table table-bordered table-sm table-hover" style="margin-top: 10px">
                                                        <thead class="thead-light">
                                                        <tr>
                                                            <th width="280">Tabela:</th>
                                                            <th width="100">Valor:</th>
                                                            <th width="100">Mrg(%):</th>
                                                            <th width="100">Com.(%):</th>
                                                            <th width="100">Qtd. Min.:</th>
                                                            <th width="100">Pr. aux. ($):</th>
                                                            <th width="100">Desc. %:</th>
                                                            <th width="100">Desc. Promo:</th>
                                                            <th width="35px" style="text-align: center;">Exc:</th>
                                                        </tr>
                                                        </thead>
                                                        <tbody id="lsttabelaspro">
                                                            <tr v-for="(tabela, index) in lstTabelasPrecos" v-bind:key="index">
                                                                <td width="150px">{{ tabela.desctabela }}</td>
                                                                <td width="100px" style="text-align: right; font-weight: bold;">{{
                                                                    formatavalores(tabela.prtabela) }}
                                                                </td>
                                                                <td width="100px" style="text-align: right;">{{
                                                                    formatavalores(tabela.mrglucro) }}
                                                                </td>
                                                                <td width="100px" style="text-align: right;">{{
                                                                    formatavalores(tabela.pcomissao) }}
                                                                </td>
                                                                <td width="100px" style="text-align: right;">{{
                                                                    formatavalores(tabela.qtdminima) }}
                                                                </td>
                                                                <td width="100px" style="text-align: right;">{{
                                                                    formatavalores(tabela.vlvisualiza) }}
                                                                </td>
                                                                <td width="100px" style="text-align: right;">{{
                                                                    formatavalores(tabela.desconto) }}
                                                                </td>
                                                                <td v-if="parseFloat(tabela.vldescpromocional) > 0" width="120px" style="text-align: right; color: #0acf97; font-weight: bold;">
                                                                    {{ formatavalores(tabela.vldescpromocional) }}% (${{ formatavalores(parseFloat(tabela.prtabela) - (tabela.prtabela * parseFloat(tabela.vldescpromocional) / 100)) }})
                                                                </td>                                                                        
                                                                <td v-else width="120px">
                                                                </td>
                                                                <td width="100px" class="center" style="text-align: center;">
                                                                    <a class="btn btn-secondary btn-sm btn-opcrud ajt-btn" href="#"
                                                                    v-bind:disabled="ativadesativa"
                                                                    @click.prevent="mtdalterartabela(tabela)"><i class="fa fa-edit"></i></a>
                                                                    <a class="btn btn-danger btn-sm btn-opcrud ajt-btn" href="#"
                                                                    v-bind:disabled="ativadesativa"
                                                                    @click.prevent="mtddeletatabela(index)"><i class="fa fa-trash"></i></a>                                                                            
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                            <div class="col-md-10">                                                
                                            </div>
                                            <div v-if="lstTabelasPrecos.length > 0" class="col-md-2">                                                
                                                <button type="button" class="btn btn-green btn-sm btn-block" @click.prevent="mtdsalvartabelasdeprecos()">
                                                    <i class="fa fa-money"></i> Salvar preços
                                                </button>                                                
                                            </div>                                            
                                        </div>    
                                    </div>
                                    <div v-show="vhabilitaedicaoclasses" id="dvclasses" class="container tab-pane fade">
                                        <div class="row">
                                            <div class="col-sm-12 col-md-5 col-lg-5" id="dvclasse">
                                                <span class="lblselect2">Classe:</span>
                                                <select id="cbclasse" data-placeholder="Selecione uma opção"
                                                    v-model="vidclasse" v-bind:disabled="ativadesativa"
                                                    data-allow-clear="true" style="width:100%;">
                                                </select>
                                            </div>                                                            
                                            <div class="col-sm-12 col-md-5 col-lg-5" id="dvfilialclasse">
                                                <span class="lblselect2">Filial:</span>
                                                <select id="cbfilialclasse" data-placeholder="Selecione uma opção"
                                                    v-model="vidfilialclasse" v-bind:disabled="ativadesativa"
                                                    data-allow-clear="true" style="width:100%;">
                                                </select>
                                            </div>
                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                <button type="button" id="btincclasse" class="btn btn-info btn-sm"
                                                    v-bind:disabled="ativadesativa"
                                                    style="width:100%; margin-top: 22px;" @click.prevent="mtdincluirclasse()"><i class="fa fa-plus-circle"></i>
                                                    Incluir
                                                </button>
                                            </div>
                                            <div class="col-lg-12">
                                                <div class="table-responsive">
                                                    <table id="tblistaclasses" class="table table-bordered table-sm table-hover" style="margin-top: 10px">
                                                        <thead class="thead-light">
                                                            <tr>
                                                                <th width="300">Classe:</th>
                                                                <th width="300">Filial:</th>
                                                                <th width="35px" style="text-align: center;">Exc:</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody id="lstclassespro">
                                                            <tr v-for="(classe, index) in lstClassesProduto" v-bind:key="index">
                                                                <td width="300px">{{ classe.descclasse }}</td>
                                                                <td width="300px">{{ classe.fantasia }}</td>
                                                                <td width="35px" class="center" style="text-align: center;">
                                                                    <a class="btn btn-danger btn-sm btn-opcrud ajt-btn" href="#"
                                                                    v-bind:disabled="ativadesativa"
                                                                    @click.prevent="mtdexcluirclasse(index)"><i class="fa fa-trash"></i></a>
                                                                </td>                                                                                    
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                            <div class="col-md-10">                                                
                                            </div>
                                            <div v-if="lstClassesProduto.length > 0" class="col-md-2">                                                
                                                <button type="button" class="btn btn-green btn-sm btn-block" @click.prevent="mtdsalvarclasses()">
                                                    <i class="fa fa-check"></i> Salvar classes
                                                </button>                                                
                                            </div>                                            
                                        </div>    
                                    </div>
                                </div>                                
                            </div>
                        </div>
					</div>
					<div class="modal-footer">						
						<button type="button" class="btn btn-primary btn-sm" @click.prevent="mtdgravaritem()"><i class="fa fa-check"></i> Confirmar</button>
						<button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal"><i class="fa fa-close"></i> Cancelar</button>
					</div>
				</div>
			</div>
        </div>
		<!-- Modal para status -->
		<div class="modal fade" id="mdstatusaxios" data-backdrop="static" data-keyboard="false" tabindex="1" aria-hidden="true">
			<div class="modal-dialog modal-sm modal-dialog-centered">
				<div class="modal-content">
					<div class="modal-body text-center">
						<div class="d-flex justify-content-center" style="margin-bottom: 15px;">
							<div class="spinner-border text-info" style="width: 3rem; height: 3rem;" role="status">
								<span class="sr-only"></span>
							</div>
						</div>      
						<span style="font-weight: 500; color: #666666;">{{ statusaxios }}</span>
					</div>
				</div>
			</div>
		</div>        
        <!-- Modal do Manifesto do Destinatário MD-e -->
        <div class="modal fade" id="mdmanifesto" tabindex="-1" aria-labelledby="mdlmanifesto" aria-hidden="true">
			<div class="modal-dialog modal-xl modal-dialog-scrollable modal-dialog-centered">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title" id="mdlmanifesto"><i class="fa fa-certificate"></i> Manifestação do Destinatário MD-e</h5>
						<button type="button" class="close" data-dismiss="modal" aria-label="Close">
						<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="modal-body">
						<div class="row">
							<div class="col-sm-12 col-md-4 col-lg-4">
								<span class="lblselect2">*Filial:</span>
								<select id="cbfilialmanifesto" data-placeholder="Selecione uma filial" v-model="midfilialmanifesto" data-allow-clear="true" style="width:100%;">
								</select>
							</div>
                            <div class="col-sm-4 col-md-3 col-lg-3">
                                <label for="cbperiodomanifesto">Listar notas:</label>
                                <select name="cbopfiltro" class="form-control form-control-sm" id="cbperiodomanifesto" v-model="mperiodomanifesto">
                                    <option value="0">Mês atual</option>
                                    <option value="1">2 últimos meses</option>
                                    <option value="2">3 últimos meses</option>
                                    <option value="3">Todas</option>
                                </select>
                            </div>
                            <div class="col-4 col-sm-4 col-md-2 col-lg-2">
                                <button type="button" class="btn btn-success btn-sm btn-block" @click.prevent="mtdlistarnotasmanifesto()" style="margin-top: 20px;"><i class="fa fa-search"></i> Consultar</button>
                            </div>                                        
                            <div class="col-4 col-sm-4 col-md-3 col-lg-3">
                                <button type="button" class="btn btn-primary btn-sm btn-block btn-purple" @click.prevent="mtdconsultardocumentos()" style="margin-top: 20px;"><i class="fa fa-cloud-download"></i> Sincronizar com a SEFAZ</button>
                            </div>                                                                                                                                                            
						</div>
                        <div class="row">
                            <div class="col-lg-12">
                                <div class="table-responsive">
                                    <table id="tblistatbpro" class="table table-bordered table-sm table-hover" style="margin-top: 10px">
                                        <thead class="thead-dark">
                                        <tr>
                                            <th>Chave:</th>
                                            <th width="700">Nome:</th>
                                            <th width="150">CNPJ:</th>
                                            <th width="100">IE:</th>
                                            <th width="180">Emissão:</th>
                                            <th width="100">Valor:</th>
                                            <th width="100">Status:</th>
                                            <th width="70px" style="text-align: center;">Ações:</th>
                                        </tr>
                                        </thead>
                                        <tbody v-if="lstnotasmanifesto.length > 0">
                                            <tr v-for="(nota, index) in lstnotasmanifesto" v-bind:key="index" style="font-size: 12px;">
                                                <td>{{nota.chnfe}}</td>
                                                <td width="700px" style="font-weight: 500;">{{nota.xnome !== "" ? nota.xnome.toUpperCase(): ""}}</td>
                                                <td width="150px">{{mtdformatardoc(nota.cnpj)}}</td>
                                                <td width="100px">{{nota.ie}}</td>
                                                <td width="180px">{{mtdformatardata(nota.dhemi)}}</td>
                                                <td width="100px" style="text-align: right; font-weight: 500;">{{mtdformatavalordecimal(parseFloat(nota.vnf), 2)}}</td>            
                                                <td v-if="parseInt(nota.status) === 0" width="100px" class="text-center"><span class="badge badge-primary badge-pill">PENDENTE</span></td>
                                                <td v-else width="100px" class="text-center"><span class="badge badge-secondary badge-pill" style="background-color: #5A956A;">MANIFESTADA</span></td>
                                                <td width="35px" class="center" style="text-align: center;">
                                                    <div class="dropdown">
                                                        <button type="button" class="btn btn-primary btn-opcrud dropdown-toggle" data-toggle="dropdown">
                                                            <i class="fa fa-navicon"></i>
                                                        </button>
                                                        <div class="dropdown-menu">
                                                        <a class="dropdown-item" href="#" v-if="parseInt(nota.status) === 0" @click.prevent="mtdchamartelamanifestacao(nota)"><i class="fa fa-certificate"></i> Manifestar</a>
                                                        <a class="dropdown-item" href="#" v-if="parseInt(nota.status) > 0" @click.prevent="mtddownloadxml(nota)"><i class="fa fa-download"></i> Download xml</a>                                                            
                                                        <a class="dropdown-item" href="#" v-if="parseInt(nota.status) > 0 && nota.xml !== ''" @click.prevent="mtdimprimirdanfe(nota)"><i class="fa fa-print"></i> Visualizar DANFE</a>                                                            
                                                        <a class="dropdown-item" href="#" v-if="parseInt(nota.status) > 0 && nota.xml !== ''" @click.prevent="mtdentradapeloxml(nota.chnfe, '')"><i class="fa fa-archive"></i> Dar entrada da nota</a>
                                                        </div>
                                                    </div>                                                        
                                                </td>
                                            </tr>
                                        </tbody>                                        
                                    </table>
                                </div>
                                <div v-if="lstnotasmanifesto.length === 0" class="col-md-12 text-center rounded-bottom border-bottom border-left border-right" style="padding: 5px; margin-top: -16px;">
                                    <span>Sem dados para visualização</span>
                                </div>                                
                            </div>                            
                        </div>
					</div>
					<div class="modal-footer">						
						<button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal" style="width: 100px;"><i class="fa fa-sign-out"></i> Sair</button>
					</div>
				</div>
			</div>
        </div>
        <!-- Modal manifestar nf -->
        <div class="modal fade" id="mdmanifestarnfe">
            <div class="modal-dialog modal-dialog-centered modal-sm">
                <div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title" id="mdlmanifesto" style="font-size: 14px;"><i class="fa fa-certificate"></i> Manifestação do Destinatário</h5>
						<button type="button" class="close" data-dismiss="modal" aria-label="Close">
						    <span aria-hidden="true">&times;</span>
						</button>
					</div>                    
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-md-12 text-center">
                                <div class="alert alert-primary" role="alert">
                                    <h6 style="color: #666666; font-weight: 600; font-size: 12px;">{{notamanifestar.xnome}}</h6>
                                    <h6 style="color: #666666; font-weight: 600; font-size: 9px;">{{notamanifestar.chnfe}}</h6>
                                </div>                                                                
                            </div>                            
                            <div class="col-md-12">
                                <label for="cbtpmanifestacao">Manifestação:</label>
                                <select name="cbopfiltro" class="form-control form-control-sm" id="cbtpmanifestacao" v-model="mtpevento">
                                    <option value="210200">Confirmação da operação</option>
                                    <option value="210210">Ciência da Operação</option>
                                    <option value="210220">Desconhecimento da Operação</option>
                                    <option value="210240">Operação não Realizada</option>
                                    <option value="1">Corrigir status</option>
                                </select>
                            </div>
                            <div v-if="mtpevento === '210220' || mtpevento === '210240'" class="col-md-12">
                                <label for="txtxjust">Motivo:</label>
                                <textarea class="form-control center" rows="5" id="txtxjust" v-model="mxjust" maxlength="255"></textarea>
                            </div>
                        </div>
                    </div>           
                    <div class="modal-footer">
                        <button type="button" class="btn btn-primary btn-sm" @click.prevent="mtdconfirmamanifesto()"><i class="fa fa-check"></i> Manifestar</button>
                        <button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal"><i class="fa fa-sign-out"></i> Cancelar</button>
                    </div>                
                </div>
            </div>
        </div>
        <!-- Modal para pré-visualização da NF -->
        <div class="modal fade" id="mdprevisualizacaonf" tabindex="-1" aria-labelledby="mdlprevisualizacaonf" aria-hidden="true">
			<div class="modal-dialog modal-xl modal-dialog-scrollable modal-dialog-centered">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title" id="mdlprevisualizacaonf"><i class="fa fa-tv"></i> Pré-visualização da NF-e</h5>
						<button type="button" class="close" data-dismiss="modal" aria-label="Close">
						<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="modal-body">
						<div class="row">
                            <div class="col-sm-12 col-md-12 col-lg-4 col-xl-4">
                                <label for="edpfornecedorv">Fornecedor:</label>
                                <input type="text" class="form-control form-control-sm text-uppercase" id="edpfornecedorv" v-bind:value="pnotaentrada.idfornecedor+' - '+pnotaentrada.nomefornecedor"
                                    data-bv-group=".group" disabled/>
                            </div>
                            <div class="col-sm-12 col-md-12 col-lg-2 col-xl-2">
                                <label for="edpnnfv">Número NF-e:</label>
                                <input type="text" class="form-control form-control-sm text-right font-weight-bold text-secondary" id="edpnnfv" v-model="pnotaentrada.nnf"
                                    data-bv-group=".group" disabled/>
                            </div>
                            <div class="col-sm-12 col-md-12 col-lg-2 col-xl-2">
                                <label for="edpdhemiv">Emissão:</label>
                                <input type="text" class="form-control form-control-sm text-right" id="edpdhemiv" v-model="pnotaentrada.dhemi"
                                    data-bv-group=".group" disabled/>
                            </div>
                            <div class="col-sm-12 col-md-12 col-lg-2 col-xl-2">
                                <label for="edpmodv">Modelo:</label>
                                <input type="text" class="form-control form-control-sm text-right" id="edpmodv" v-model="pnotaentrada.mod"
                                    data-bv-group=".group" disabled/>
                            </div>
                            <div class="col-sm-12 col-md-12 col-lg-2 col-xl-2">
                                <label for="edpseriev">Série:</label>
                                <input type="text" class="form-control form-control-sm text-right" id="edpseriev" v-model="pnotaentrada.serie"
                                    data-bv-group=".group" disabled/>
                            </div>
                            <div class="col-sm-12 col-md-12 col-lg-4 col-xl-4">
                                <label for="edpnatopv">Natureza da operação:</label>
                                <input type="text" class="form-control form-control-sm text-uppercase" id="edpnatopv" v-model="pnotaentrada.natop"
                                    data-bv-group=".group" disabled/>
                            </div>
                            <div class="col-sm-12 col-md-12 col-lg-4 col-xl-4">
                                <label for="edpchnfev">Chave de acesso:</label>
                                <input type="text" class="form-control form-control-sm text-center font-weight-bold text-secondary" id="edpchnfev" v-model="pnotaentrada.chnfe"
                                    data-bv-group=".group" disabled/>
                            </div>
							<div class="col-sm-12 col-md-4 col-lg-4">
								<span class="lblselect2">Estoque dos itens:</span>
								<select id="cbestoquemanifesto" data-placeholder="Selecione um estoque" v-model="midestoquemanifesto" data-allow-clear="true" style="width:100%;">
								</select>
							</div>                            
						</div>
                        <div class="row">
                            <div class="col-lg-12">
                                <div class="table-responsive">
                                    <table id="tblistatbpro" class="table table-bordered table-sm table-hover" style="margin-top: 10px">
                                        <thead class="thead-dark">
                                        <tr>
                                            <th width="30">Item:</th>
                                            <th width="100">Codigo:</th>
                                            <th width="300">Descrição:</th>
                                            <th width="40">Und:</th>
                                            <th width="50">NCM:</th>
                                            <th width="40">CFOP:</th>
                                            <th width="100">Vl. Unitário:</th>
                                            <th width="50">Qtd:</th>                                            
                                            <th width="100">Vl. Descto:</th>
                                            <th width="100">Vl. Total:</th>
                                            <th width="100">Cód. Barras</th>
                                            <th width="350">Produto vinculado:</th>
                                            <th width="30">Und:</th>
                                            <th width="30">Fator:</th>
                                            <th width="70px" style="text-align: center;">Ações:</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(item, index) in pnotaentrada.itens" v-bind:key="index" style="font-size: 12px;">
                                                <td class="text-center">{{item.item}}</td>
                                                <td>{{item.cprod}}</td>
                                                <td>{{item.xprod}}</td>
                                                <td>{{item.ucom}}</td>
                                                <td>{{item.ncm}}</td>
                                                <td>{{item.cfop}}</td>
                                                <td style="text-align: right;">{{mtdformatavalordecimal(parseFloat(item.vuncom), 3)}}</td>
                                                <td>{{item.qcom}}</td>
                                                <td style="text-align: right;">{{mtdformatavalordecimal(parseFloat(item.vdesc), 3)}}</td>
                                                <td style="text-align: right; font-weight: 500;">{{mtdformatavalordecimal(parseFloat(item.vprod) - parseFloat(item.vdesc), 3)}}</td> 
                                                <td>{{item.cean}}</td>                                                   
                                                <template v-if="parseInt(item.idproduto) > 0">
                                                    <td><i class="fa fa-chain" style="color: #f82b54; font-size: 14px;" title="Item vinculado"></i>	<strong>{{item.idproduto}}</strong> - {{item.descricaoproduto}}</td>
                                                    <td>{{item.und}}</td>
                                                    <td>{{item.fator}}</td>
                                                </template>
                                                <template v-else>
                                                    <td v-if="parseInt(item.dadoscadastro) === 0"><i class="fa fa-info-circle" style="color: #4250f2; font-size: 14px;" title="Verificar dados para cadastro automatizado"></i></td>
                                                    <td v-else><i class="fa fa-check" style="color: #74A82A; font-size: 14px;" title="Dados prontos para o cadastro automatizado"></i></td>
                                                    <td></td>
                                                    <td></td>
                                                </template>
                                                <td width="35px" class="center" style="text-align: center;">
                                                    <div class="dropdown">
                                                        <button type="button" class="btn btn-primary btn-opcrud dropdown-toggle" data-toggle="dropdown">
                                                            <i class="fa fa-navicon"></i>
                                                        </button>
                                                        <div class="dropdown-menu">
                                                            <a v-if="parseInt(item.idproduto) > 0" class="dropdown-item" href="#" @click.prevent="mtdremovervinculo(item)"><i class="fa fa-eraser"></i> Remover vínculo</a>
                                                            <a v-if="parseInt(item.idproduto) > 0" class="dropdown-item" href="#" @click.prevent="mtdtelaedicaofator(item)"><i class="fa fa-refresh"></i> Alterar fator</a>
                                                            <a v-if="parseInt(item.idproduto) === 0" class="dropdown-item" href="#" @click.prevent="mtdconsultarproduto(1, item)"><i class="fa fa-chain"></i> Vincular</a>
                                                            <a v-if="parseInt(item.idproduto) === 0" class="dropdown-item" href="#" @click.prevent="mtdtelaedicaoitem(item)"><i class="fa fa-edit"></i> Editar dados para cadastro</a>
                                                        </div>
                                                    </div>                                                        
                                                </td>
                                            </tr>
                                        </tbody>                                        
                                    </table>
                                </div>
                            </div>
                        </div>
					</div>
                    <div class="modal-footer">
                        <div class="container-fluid">
                            <div class="row">
                                <div class="col-md-5">
                                    <div class="custom-control custom-switch">
                                        <input type="checkbox" class="custom-control-input" id="swvinculartodos" 
                                        name="swvinculartodos" v-model="pvinculartodos" title="Vincula todos os códigos iguais encontrados na NF ao mesmo produto">
                                        <label class="custom-control-label" for="swvinculartodos">Vincular semelhantes</label>
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <button type="button" class="btn btn-info btn-sm btn-block" @click.prevent="mtdcadastroautomatizadoprodutos()"><i class="fa fa-archive"></i> Cadastrar produtos</button>                                                        
                                </div>
                                <div class="col-md-2">
                                    <button type="button" class="btn btn-primary btn-sm btn-block" @click.prevent="mtdincluirnotamanifesto(pnotaentrada)"><i class="fa fa-check"></i> Confirmar entrada</button>                                                        
                                </div>                            
                                <div class="col-md-2">
                                    <button type="button" class="btn btn-secondary btn-sm btn-block" data-dismiss="modal"><i class="fa fa-sign-out"></i> Cancelar</button>                                
                                </div>
                            </div>                       
                        </div> 
                    </div>					
				</div>
			</div>
		</div>
        <!-- Modal para alteração do fator -->
        <div class="modal fade" id="mdalteracaofator">
            <div class="modal-dialog modal-sm modal-dialog-centered">
                <div class="modal-content">                
                    <div class="modal-header">
                        <h4 class="modal-title"><i class="fa fa-edit"></i> Alteração de fator</h4>
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>                
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-md-12 text-center">
                                <div class="alert alert-primary" role="alert">
                                    <span style="color: #666666; font-weight: 600;">{{pitemfator.idproduto}} - {{pitemfator.descricaoproduto}}</span>
                                </div>                                                                
                            </div>                            
                            <div class="col-md-12">
                                <label for="edfatoralteracao">Fator:</label>
                                <input type="number" class="form-control form-control-sm" id="edfatoralteracao" v-model="pfator" min="1" max="999" maxlength="3">                                
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-primary btn-sm" @click.prevent="mtdalterarfator()"><i class="fa fa-check"></i> Confirmar</button>
                        <button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal"><i class="fa fa-sign-out"></i> Cancelar</button>
                    </div>                    
                </div>
            </div>
        </div>
        <!-- Modal para edição dos dados do item -->
        <div class="modal fade" id="mdalteracaodadositem">
            <div class="modal-dialog modal-xl modal-dialog-centered">
                <div class="modal-content">                
                    <div class="modal-header">
                        <h4 class="modal-title"><i class="fa fa-edit"></i> Alteração do item para cadastro automatizado</h4>
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>                
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <label for="edcprodedicao">Código:</label>
                                <input type="text" class="form-control form-control-sm" id="edcprodedicao" v-model="aitemedicao_cprod" disabled/>
                            </div>
                            <div class="col-sm-12 col-md-8 col-lg-8">
                                <label for="edxprodedicao">*Descrição:</label>
                                <input type="text" v-model="aitemedicao_xprod"
                                       class="form-control form-control-sm" id="edxprodedicao" maxlength="50">
                            </div>
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <label for="edceanedicao">Cód. Barras:</label>
                                <input type="text" class="form-control form-control-sm" id="edceanedicao" v-model="aitemedicao_cean" disabled/>
                            </div>                            
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <span class="lblselect2">*Unidade:</span>
                                <select id="cbunidadeedicao" v-model="aitemedicao_ucom"
                                        data-placeholder="Selecione uma unidade" data-allow-clear="true" style="width:100%;">
                                </select>
                            </div>
                            <div class="col-sm-12 col-md-3 col-lg-3">
                                <span class="lblselect2">*Marca:</span>
                                <select id="cbmarcaedicao" v-model="aitemedicao_idmarca"
                                        data-placeholder="Selecione uma marca" data-allow-clear="true" style="width:100%;">
                                </select>
                            </div>
                            <div class="col-sm-12 col-md-3 col-lg-3">
                                <span class="lblselect2">*Grupo:</span>
                                <select id="cbgrupoedicao" v-model="aitemedicao_idgrupo"
                                        data-placeholder="Selecione um grupo" data-allow-clear="true" style="width:100%;">
                                </select>
                            </div>
                            <div class="col-sm-12 col-md-3 col-lg-3">
                                <span class="lblselect2">*Subgrupo:</span>
                                <select id="cbsubgrupoedicao" v-model="aitemedicao_idsubgrupo"
                                        data-placeholder="Selecione um subgrupo" data-allow-clear="true" style="width:100%;">
                                </select>
                            </div>                                                                                    
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-primary btn-sm" @click.prevent="mtdconfirmaredicaoitem()"><i class="fa fa-check"></i> Confirmar</button>
                        <button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal"><i class="fa fa-sign-out"></i> Cancelar</button>
                    </div>                    
                </div>
            </div>
        </div>
		<!-- Modal para efetivação da nota -->
		<div class="modal fade" id="mdefetivarnota">
			<div class="modal-dialog modal-lg modal-dialog-centered">
			<div class="modal-content">      
				<div class="modal-header">
					<h4 class="modal-title"><i class="fa fa-money"></i> Efetivação da nota</h4>
					<button type="button" class="close" data-dismiss="modal">&times;</button>
				</div>
				<div class="modal-body">
					<div v-if="vhabrelacaopedcompra==true" class="row">
						<div class="col-sm-12 col-md-4 col-lg-2">
							<label>Nr. Nota:</label>
							<input type="text" class="form-control form-control-sm" v-bind:value="notaefetivar.numero" disabled style="font-weight: bold; text-align: center;">
						</div>						
						<div class="col-sm-12 col-md-8 col-lg-2">
							<label>Fornecedor:</label>
							<input type="text" class="form-control form-control-sm" v-model="notaefetivar.nomefornecedor" disabled style="font-weight: bold;">
						</div>
                        <div class="col-sm-12 col-md-8 col-lg-2">
							<label>Pedido compra:</label>
							<input type="number" class="form-control form-control-sm" v-model="vcodpedcompra" style="font-weight: bold;">
						</div>
						<div class="col-sm-12 col-md-6 col-lg-3">
							<label for="edvlefetivar">Valor da nota:</label>
							<money type="text" class="form-control form-control-sm" id="edvlefetivar" v-bind:value="notaefetivar.vtotvtotal - notaefetivar.vtotdesc + notaefetivar.vtotvipi + notaefetivar.vst + notaefetivar.vtotvfrete + notaefetivar.vtotvoutros" disabled v-bind="money" data-bv-group=".group" style="color: #5A956A; font-weight: bold; text-align:right;"></money>
						</div>						
						<div class="col-sm-12 col-md-6 col-lg-3">
							<label for="eddtefetivacao">Dt. Efetivação:</label>
							<div class="input-group">
								<date-picker id="eddtefetivacao" v-model="edtefetivacao" :config="options" class="form-control form-control-sm"></date-picker>
								<div class="input-group-append">
									<span class="input-group-text"><i class="fa fa-calendar"></i></span>
								</div>										
							</div>
						</div>																													 
					</div>
                    <div v-else class="row">
						<div class="col-sm-12 col-md-4 col-lg-2">
							<label>Nr. Nota:</label>
							<input type="text" class="form-control form-control-sm" v-bind:value="notaefetivar.numero" disabled style="font-weight: bold; text-align: center;">
						</div>						
						<div class="col-sm-12 col-md-8 col-lg-4">
							<label>Fornecedor:</label>
							<input type="text" class="form-control form-control-sm" v-model="notaefetivar.nomefornecedor" disabled style="font-weight: bold;">
						</div>
						<div class="col-sm-12 col-md-6 col-lg-3">
							<label for="edvlefetivar">Valor da nota:</label>
							<money type="text" class="form-control form-control-sm" id="edvlefetivar" v-bind:value="notaefetivar.vtotvtotal - notaefetivar.vtotdesc + notaefetivar.vtotvipi + notaefetivar.vst + notaefetivar.vtotvfrete + notaefetivar.vtotvoutros" disabled v-bind="money" data-bv-group=".group" style="color: #5A956A; font-weight: bold; text-align:right;"></money>
						</div>						
						<div class="col-sm-12 col-md-6 col-lg-3">
							<label for="eddtefetivacao">Dt. Efetivação:</label>
							<div class="input-group">
								<date-picker id="eddtefetivacao" v-model="edtefetivacao" :config="options" class="form-control form-control-sm"></date-picker>
								<div class="input-group-append">
									<span class="input-group-text"><i class="fa fa-calendar"></i></span>
								</div>										
							</div>
						</div>																													 
					</div>
                    <div class="row">
                        <div class="col-md-12">
                            <div class="card" style="margin-top: 15px;">
                                <div class="card-header card-in text-center" style="padding: 5px;">GERAÇÃO DE PARCELAS</div>
                                <div class="card-body" style="padding: 10px;">
                                    <div class="row">                        
                                        <div class="col-sm-2 col-md-2 col-lg-2">
                                            <label for="edqtdtitulosgerar">Parcelas:</label>
                                            <input id="edqtdtitulosgerar" type="number" class="form-control form-control-sm" v-model="eqtdtitulosgerar" min="1" max="99">
                                        </div>
                                        <div class="col-sm-2 col-md-2 col-lg-2">
                                            <label for="edintervaloparcelas">Intervalo:</label>
                                            <input id="edintervaloparcelas" type="number" class="form-control form-control-sm" v-model="eintervaloparcelas" min="0" maxlength="11">
                                        </div>
                                        <div  class="col-sm-4 col-md-4 col-lg-4">
                                            <span class="lblselect2">Tipo de cobrança:</span>
                                            <select id="cbtipocobrancagerar" data-placeholder="Selecione um tipo de cobrança" v-model="eidtipocobrancagerar" data-allow-clear="true" style="width:100%;">
                                            </select>
                                        </div>                                        
                                        <div class="col-sm-2 col-md-2 col-lg-2">
                                            <label for="edcodigoauxiliargerar">Cód. Auxiliar:</label>
                                            <input id="edcodigoauxiliargerar" type="text" class="form-control form-control-sm" v-model="ecodigoauxiliargerar" maxlength="20">
                                        </div>
                                        <div class="col-sm-12 col-md-12 col-lg-2">
                                            <button type="button" class="btn btn-primary btn-sm btn-block" style="margin-top: 20px;" @click.prevent="mtdgerartitulos()"><i class="fa fa-refresh"></i> Gerar</button>
                                        </div>                                        
                                    </div>
                                </div>
                            </div>            
                        </div>
                    </div>
					<div class="row">
						<div v-show="lsttitulosefetivar.length > 0" class="col-lg-12">
							<div class="table-responsive">
								<table class="table table-bordered table-sm table-hover" style="margin-top: 10px">
									<thead class="thead-light">
									<tr>
										<th width="35px" style="text-align: center;"></th>
										<th width="80">Nr. título:</th>
										<th width="80">Vencimento:</th>
                                        <th width="200">Fornecedor:</th>
										<th width="100">Tipo de cobrança:</th>
                                        <th width="80">Cód. Auxiliar:</th>
										<th width="80">Valor:</th>															
									</tr>
									</thead>
									<tbody>
                                        <tr v-for="(titulo, index) in lsttitulosefetivar" v-bind:key="index">
                                            <td width="35px" class="center" style="text-align: center;">
                                                <a class="btn btn-primary btn-sm btn-opcrud ajt-btn" href="#"
                                                v-bind:disabled="ativadesativa"
                                                @click.prevent="mtdalterartitulo(titulo)"><i class="fa fa-edit"></i></a>
                                            </td>												
                                            <td width="80px">{{ titulo.codtit }}</td>
                                            <td width="80px">{{ titulo.dtventit }}</td>
                                            <td width="200px">{{ titulo.nomefornecedor }}</td>
                                            <td width="100px">{{ titulo.descricaocob }}</td>
                                            <td width="80px">{{ titulo.codauxiliar }}</td>
                                            <td width="80px" style="text-align: right;">
                                                <strong>{{ mtdformatavalordecimal(titulo.vltit, 2) }}</strong>
                                            </td>                                                       												
                                        </tr>
									</tbody>
								</table>
							</div>
							<div class="col-md-12" style="padding-left: 0px; padding-right: 0px;">
								<ul class="list-group">
									<li class="list-group-item d-flex justify-content-between align-items-center" style="padding: 10px;">
										<span style="color: #666666; font-weight: bold;">Soma do títulos</span>
										<span class="badge badge-info badge-pill text-right bdg-qtd-reg-info" style="width: 165px; background-color: #727cf5;">{{mtdformatavalordecimal(parseFloat(etotaltitulos), 2)}}</span>
									</li>
								</ul>
							</div>							
						</div>						                                   
					</div>						
				</div>       
				<div class="modal-footer">
					<button type="button" class="btn btn-primary btn-sm" @click.prevent="mtdconfirmarefetivacao()"><i class="fa fa-check"></i> Confirmar</button>
					<button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal"><i class="fa fa-close"></i> Cancelar</button>
				</div>        
			</div>
			</div>
		</div>
		<!-- Modal para alteração da parcela -->
		<div class="modal fade" id="mdalterartitulo">
			<div class="modal-dialog modal-dialog-centered">
			<div class="modal-content">
				<div class="modal-header">
					<h4 class="modal-title"><i class="fa fa-edit"></i> Alteração do título</h4>
					<button type="button" class="close" data-dismiss="modal">&times;</button>
				</div>				 
				<div class="modal-body">
					<div class="row">
						<div class="col-md-4">
							<label>Nr. título:</label>
							<input type="text" class="form-control form-control-sm" v-model="ecodtit" disabled style="font-weight: bold;">
						</div>
						<div class="col-sm-12 col-md-4 col-lg-4">
							<label for="eddtventit">Dt. Vencimento:</label>
							<div class="input-group">
								<date-picker id="eddtventit" v-model="edtventit" :config="options" class="form-control form-control-sm"></date-picker>
								<div class="input-group-append">
									<span class="input-group-text"><i class="fa fa-calendar"></i></span>
								</div>										
							</div>
						</div>                        
						<div class="col-sm-12 col-md-4 col-lg-4">
							<label for="edvltit">Valor:</label>
							<money type="text" class="form-control form-control-sm" id="edvltit" v-model="evltit" v-bind="money" data-bv-group=".group" style="text-align:right;"></money>
						</div>
                        <div class="col-md-12">
                            <span class="lblselect2">Fornecedor:</span>
                            <select id="cbfornecedor" data-placeholder="Selecione um fornecedor" data-allow-clear="true"
                                    style="width:100%;" v-model="eidfornecedor">
                            </select>
                        </div>                        
                        <div class="col-md-4">
                            <label>Cód. Auxiiar:</label>
                            <input type="text" id="edcodauxiliar" class="form-control form-control-sm" v-model="ecodigoauxiliar">
                        </div>                        
						<div  class="col-sm-8 col-md-8 col-lg-8">
							<span class="lblselect2">Tipo de cobrança:</span>
							<select id="cbtipocobranca" data-placeholder="Selecione um tipo de cobrança" v-model="eidtipocobranca" data-allow-clear="true" style="width:100%;">
							</select>
						</div>
						<div v-show="parseInt(etipocobranca) === 1" class="col-sm-12 col-md-12 col-lg-12" style="padding-top: 15px;">
							<div class="card">
								<div class="card-header card-in text-center" style="padding: 5px;">DADOS DO CHEQUE</div>
								<div class="card-body" style="padding: 10px;">
									<div class="row">
										<div class="col-md-4">
											<label>Nr. Cheque:</label>
											<input type="text" id="ednumerocheque" class="form-control form-control-sm" v-model="enumerocheque">
										</div>
										<div  class="col-sm-12 col-md-8 col-lg-8">
											<span class="lblselect2">Banco:</span>
											<select id="cbbanco" data-placeholder="Selecione um banco" v-model="eidbanco" data-allow-clear="true" style="width:100%;">
											</select>
										</div>
										<div class="col-md-4">
											<label>Agência:</label>
											<input type="text" id="edagencia" class="form-control form-control-sm" v-model="eagencia">
										</div>
										<div class="col-md-4">
											<label>Conta:</label>
											<input type="text" id="edconta" class="form-control form-control-sm" v-model="econta">
										</div>
										<div class="col-md-4">
											<label>Praça:</label>
											<input type="text" id="edpraca" class="form-control form-control-sm" v-model="epraca">
										</div>
										<div class="col-md-12">
											<label>Emitente:</label>
											<input type="text" id="edemitente" class="form-control form-control-sm" v-model="eemitente">
										</div>
										<div class="col-md-5">
											<label for="edfone1">CNPJ/CPF:</label>
											<input type="text" v-model="ecnpjcpf"
												class="form-control form-control-sm" id="edcnpjcpf" 
												v-mask="['###.###.###-##', '##.###.###/####-##']">
										</div>
										<div  class="col-md-7">
											<span class="lblselect2">Situação do cheque:</span>
											<select id="cbsituacaocheque" data-placeholder="Selecione uma situação" v-model="eidsituacaocheque" data-allow-clear="true" style="width:100%;">
											</select>
										</div>																																																	
									</div>
								</div>
							</div>
						</div>																														
					</div>
				</div>        
				<div class="modal-footer" style="padding: 5px;">
					<button type="button" class="btn btn-primary btn-sm" @click.prevent="mtconfirmaralteracaotitulo()"><i class="fa fa-check"></i> Confirmar</button>
					<button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal"><i class="fa fa-close"></i> Cancelar</button>
				</div>        
			</div>
			</div>
		</div>
        <!-- Modal manifestar nf -->
        <div class="modal fade" id="mdatualizacoes">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title" id="mdlmanifesto" style="font-size: 14px;"><i class="fa fa-refresh"></i> Atualizações da Nota</h5>
						<button type="button" class="close" data-dismiss="modal" aria-label="Close">
						    <span aria-hidden="true">&times;</span>
						</button>
					</div>                    
                    <div class="modal-body">
                        <div class="row">    
                            <div class="col-md-12">
                                <div class="alert alert-primary" role="alert">
                                    <div class="row">
                                        <div class="col-md-12 text-center">
                                            <h6 style="color: #666666; font-weight: 600; font-size: 14px;">{{notaatualizar.fantasiafilial}}</h6>
                                        </div>                             
                                        <div class="col-md-12">                                               
                                            <h6 style="color: #666666; font-weight: 600; font-size: 14px;">FORNECEDOR: {{notaatualizar.nomefornecedor}}</h6>
                                            <h6 style="color: #666666; font-weight: 600; font-size: 14px;">NÚMERO: {{notaatualizar.numero}}</h6>
                                        </div>
                                    </div>
                                </div>                                                                                              
                            </div>                                                        
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <div class="custom-control custom-switch">
                                    <input type="checkbox" class="custom-control-input" id="swcatzsomentecusto" name="swcatzsomentecusto" v-model="vatzsomentecusto">
                                    <label class="custom-control-label" for="swcatzsomentecusto">Atualizar somente custo</label>
                                </div>						                                
                            </div>                            
                            <div class="col-md-4" style="padding-top: 5px;">
                                <span style="font-weight: 500;">Tipo de atualização:</span>
                            </div>                              
                            <div class="col-md-8">
                                <select class="form-control form-control-sm" id="cbtipoatualizacao" v-model="atipoatualizacao" style="width: 100%;" v-bind:disabled="vatzsomentecusto">
                                    <option value="0">Margem em relação aos preços de venda</option>
                                    <option value="1">Preços de venda em relação a margem</option>
                                    <option value="2">Preços de venda por margem</option>
                                </select>                                            
                            </div>
                            <div v-show="parseInt(atipoatualizacao) === 2" class="col-md-4" style="padding-top: 10px;">
                                <span style="font-weight: 500;">Fator(%):</span>
                            </div>                            
							<div v-show="parseInt(atipoatualizacao) === 2" class="col-sm-12 col-md-4 col-lg-4" style="padding-top: 10px;">
                                <!-- <label for="edfatorajuste">Fator(%):</label> -->
                                <money type="text" class="form-control form-control-sm" id="edfatorajuste" v-model="fatorajuste"
                                        v-bind="money" data-bv-group=".group" style="text-align:right;"></money>
                            </div>                                                                                                    
                        </div>
                    </div>           
                    <div class="modal-footer">
                        <button type="button" class="btn btn-primary btn-sm" @click.prevent="mtdconfirmaatualizacao()"><i class="fa fa-check"></i> Atualizar</button>
                        <button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal"><i class="fa fa-sign-out"></i> Cancelar</button>
                    </div>                
                </div>
            </div>
        </div> 
        <!-- Modal para visualizar detalhes da Nota -->
        <div class="modal fade" id="mddetalhesnf" tabindex="-1" aria-labelledby="mdldetalhesnf" aria-hidden="true">
			<div class="modal-dialog modal-xl modal-dialog-scrollable modal-dialog-centered">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title" id="mdldetalhesnf"><i class="fa fa-info-circle"></i> Detalhes da Nota</h5>
						<button type="button" class="close" data-dismiss="modal" aria-label="Close">
						<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="modal-body">
						<div class="row">
                            <div class="col-sm-12 col-md-12 col-lg-4 col-xl-4">
                                <label for="edpfornecedordet">Fornecedor:</label>
                                <input type="text" class="form-control form-control-sm text-uppercase" id="edpfornecedor" v-bind:value="detnota.idfornecedor+' - '+detnota.nomefornecedor"
                                    data-bv-group=".group" disabled/>
                            </div>
                            <div class="col-sm-12 col-md-12 col-lg-2 col-xl-2">
                                <label for="edpnnf">Número NF-e:</label>
                                <input type="text" class="form-control form-control-sm text-right font-weight-bold text-secondary" id="edpnnf" v-model="detnota.numero"
                                    data-bv-group=".group" disabled/>
                            </div>
                            <div class="col-sm-12 col-md-12 col-lg-2 col-xl-2">
                                <label for="edpdhemi">Emissão:</label>
                                <input type="text" class="form-control form-control-sm text-right" id="edpdhemi" v-model="detnota.dtemissao"
                                    data-bv-group=".group" disabled/>
                            </div>
                            <div class="col-sm-12 col-md-12 col-lg-2 col-xl-2">
                                <label for="edpmod">Modelo:</label>
                                <input type="text" class="form-control form-control-sm text-right" id="edpmod" v-model="detnota.modelo"
                                    data-bv-group=".group" disabled/>
                            </div>
                            <div class="col-sm-12 col-md-12 col-lg-2 col-xl-2">
                                <label for="edpserie">Série:</label>
                                <input type="text" class="form-control form-control-sm text-right" id="edpserie" v-model="detnota.serie"
                                    data-bv-group=".group" disabled/>
                            </div>
                            <div class="col-sm-12 col-md-12 col-lg-4 col-xl-4">
                                <label for="edpnatop">Natureza da operação:</label>
                                <input type="text" class="form-control form-control-sm text-uppercase" id="edpnatop" v-model="detnota.naturezaoperacao"
                                    data-bv-group=".group" disabled/>
                            </div>
                            <div class="col-sm-12 col-md-12 col-lg-6 col-xl-6">
                                <label for="edpchnfe">Chave de acesso:</label>
                                <input type="text" class="form-control form-control-sm text-center font-weight-bold text-secondary" id="edpchnfe" v-model="detnota.chaveacesso"
                                    data-bv-group=".group" disabled/>
                            </div>
                            <div class="col-sm-12 col-md-12 col-lg-2 col-xl-2">
								<label for="edtotalnotadet">Total Nota:</label>
								<money type="text" class="form-control form-control-sm input-money" id="edtotalnotadet" 
                                    v-model="detnota.vtotvtotal" v-bind="money"
                                    data-bv-group=".group" style="text-align:right;" disabled>
                                </money>                                
                            </div>
                            <!-- <div class="col-sm-12 col-md-12 col-lg-2 col-xl-2">
                                <button v-if="parseInt(detnota.conferida) === 0" type="button" class="btn btn-primary btn-sm btn-block" style="margin-top: 20px;" @click.prevent="mtddefinirconferida(detnota)" ><i class="fa fa-check-square-o"></i> Conferida</button>
                                <button v-else type="button" class="btn btn-primary btn-sm btn-block" style="margin-top: 20px;" @click.prevent="mtddefinirconferida(detnota)">À conferir</button>
                            </div>                             -->
						</div>
                        <div class="row">
                            <div class="col-lg-12">                                
                                <div class="table-responsive">
                                    <table id="tblistatbpro" class="table table-bordered table-sm table-hover" style="margin-top: 10px">
                                        <thead class="thead-dark">
                                        <tr>
                                            <th width="30">Item:</th>
                                            <th width="100">Codigo:</th>
                                            <th width="300">Descrição:</th>
                                            <th width="100">Referência:</th>
                                            <th width="40">Und:</th>
                                            <th width="40">IPI(%):</th>
                                            <th width="100">Pr. Compra:</th>
                                            <th width="100">Pr. Custo:</th>
                                            <th width="50">Qtd:</th>                                            
                                            <th width="100">Vl. Descto:</th>
                                            <th width="100">Vl. Total:</th>
                                            <th width="100">Local.:</th>
                                            <th width="100">Estoque:</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(item, index) in detnota.itens" v-bind:key="index" style="font-size: 12px;">
                                                <td class="text-center">{{item.item}}</td>
                                                <td>{{item.coddig}}</td>
                                                <td>{{item.descricao}}</td>
                                                <td>{{item.referencia}}</td>
                                                <td>{{item.und}}</td>
                                                <td style="text-align: right;">{{mtdformatavalordecimal(parseFloat(item.vpipi), 2)}}</td>
                                                <td style="text-align: right;">{{mtdformatavalordecimal(parseFloat(item.prcompra), 3)}}</td>
                                                <td style="text-align: right;">{{mtdformatavalordecimal(parseFloat(item.vprcusto), 3)}}</td>
                                                <td style="text-align: right;">{{item.qtditem}}</td>
                                                <td style="text-align: right;">{{mtdformatavalordecimal(parseFloat(item.vdesconto), 3)}}</td>
                                                <td style="text-align: right; font-weight: 500;">{{mtdformatavalordecimal(parseFloat(item.vvtotal), 3)}}</td>                                                    
                                                <td>{{item.localizacao}}</td>
                                                <td>{{item.descestoque}}</td>
                                            </tr>
                                        </tbody>                                        
                                    </table>
                                </div>
                            </div>
                        </div>
					</div>
                    <div class="modal-footer">
                        <!-- <button type="button" class="btn btn-primary btn-sm" style="width: 150px;" @click.prevent="mtdexportarexcel()"><i class="fa fa-upload"></i> Exportar itens</button> -->
                        <button type="button" class="btn btn-secondary btn-sm" style="width: 150px;" data-dismiss="modal"><i class="fa fa-sign-out"></i> Sair</button>
                    </div>					
				</div>
			</div>
		</div>    
        
           <!-- Atribuir margem para preço de venda na composição do custo -->
        <div class="modal fade" id="mdatribuirmargem" tabindex="-1">
            <div class="modal-dialog modal-sm modal-dialog-centered">
                <div class="modal-content">                        
                    <div class="modal-header">
                        <i class="fa fa-percent" style="margin-top: 8px; margin-right: 7px"></i><h4 class="modal-title" style="color: #fff;">Atribuir margem</h4>
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>                
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-12">
                                <label for="edaprcusto">Pr. Custo:</label>
                                <money type="text" class="form-control form-control-sm" id="edaprcusto" v-model="vprcusto"
                                        v-bind="money" data-bv-group=".group" style="text-align:right; font-weight: bold;" disabled></money>
                            </div>                             
                            <div class="col-12">
                                <label for="edamargem">Margem(%):</label>
                                <money type="text" class="form-control form-control-sm" id="edamargem" v-model="amargem"
                                        v-bind="money" data-bv-group=".group" style="text-align:right;" @change.native="mtdcalculamargemprvendamedio()"></money>
                            </div>                          
                            <div class="col-12">
                                <label for="edavalor">Valor:</label>
                                <money type="text" class="form-control form-control-sm" id="edavalor" v-model="avalor"
                                        v-bind="money" data-bv-group=".group" style="text-align:right; font-weight: bold;" disabled></money>
                            </div>                                                                                                                                                                                                                                  
                        </div>
                    </div>                                            
                    <div class="modal-footer">
                        <button type="button" class="btn btn-primary btn-sm" @click.prevent="mtdaplicarvalorprvenda()" style="width: 100px;"><i class="fa fa-check"></i> Aplicar</button>                        
                        <button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal" style="width: 100px;"><i class="fa fa-close"></i> Cancelar</button>
                    </div>                          
                </div>
            </div>
        </div>   

        <!-- Modal para alteração de totalizadores -->
        <div class="modal fade" id="mdlalterartotalizadores" tabindex="-1" role="dialog">
            <div class="modal-dialog modal-sm modal-dialog-centered" role="document">
                <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Alteração de totalizadores</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="col-sm-12 col-md-12 col-lg-12">
                            <label for="cbtotalizadoraplicar">Tipo de produto:</label>
                            <select class="form-control form-control-sm" id="cbtotalizadoraplicar" v-model="ttotalizadoraplicar">
                                <option value="0">Total ICMS</option>
                                <option value="1">Total frete</option>
                                <option value="2">Total PIS</option>
                                <option value="3">Total IPI</option>
                                <option value="4">Total Outros</option>
                                <option value="5">Total COFINS</option>
                                <option value="6">Total ST</option>
                            </select>
                        </div>                            
                        <div class="col-sm-12 col-md-12 col-lg-12">
                            <label for="edvaloraplicar">Valor:</label>
                            <money type="text" class="form-control form-control-sm input-money" id="edvaloraplicar" 
                                v-model="tvaloraplicar" v-bind="money" data-bv-group=".group" style="text-align:right;">
                            </money>
                        </div>                    
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-primary btn-sm" @click.prevent="mtddistribuirtotalizador()"><i class="fa fa-check"></i> Confirmar</button>
                    <button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal"><i class="fa fa-close"></i> Cancelar</button>
                </div>
                </div>
            </div>
        </div>
        
        <!-- Modal Define o multiplicador da conferência -->
        <div class="modal fade" id="mddefinemultiplicador">
            <div class="modal-dialog modal-dialog-centered modal-sm">
                <div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title" id="mdlmanifesto" style="font-size: 14px;"><i class="fa fa-calc"></i> Definir multiplicador</h5>
						<button type="button" class="close" data-dismiss="modal" aria-label="Close">
						    <span aria-hidden="true">&times;</span>
						</button>
					</div>                    
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-12">
                                <label for="edmultiplicadoredicao">Multiplicador:</label>
                                <money type="text" class="form-control form-control-sm" id="edmultiplicadoredicao" v-model="vmultiplicadoredicao" data-bv-group=".group" min="1" style="text-align:right;"></money>
                            </div>                            
                        </div>
                    </div>           
                    <div class="modal-footer">
                        <button type="button" class="btn btn-primary btn-sm" @click.prevent="mtdconfirmamultiplicador()"><i class="fa fa-check"></i> Confirmar</button>
                        <button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal"><i class="fa fa-sign-out"></i> Cancelar</button>
                    </div>                
                </div>
            </div>
        </div> 
        
        <!-- Visualiza o imposto sobre o valor -->
        <div class="modal fade" id="mdimpostovalor" tabindex="-1">
            <div class="modal-dialog modal-sm modal-dialog-centered">
                <div class="modal-content">                        
                    <div class="modal-header">
                        <i class="fa fa-dollar" style="margin-top: 8px; margin-right: 7px"></i><h4 class="modal-title" style="color: #fff;">Imposto sobre o valor</h4>
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>                
                    <div class="modal-body">
                        <div class="row"> 
                            <div class="col-12">
                                <label for="edivalorbase">Valor base:</label>
                                <div class="input-group" style="z-index: 1;">
                                    <money type="text" class="form-control form-control-sm" id="edivalorbase" v-model="ivalorbase"
                                            v-bind="money" data-bv-group=".group" style="text-align:right;"></money>
                                    <div class="input-group-append" style="height: 31px;">
                                        <button class="btn btn-primary" title="Atualizar cálculo" @click.prevent="mtdcalculavalorimpostoclasse()" style="border-top-left-radius: 0px!important; border-bottom-left-radius: 0px!important;"><i class="fa fa-refresh"></i></button>
                                    </div>                                            
                                </div>
                            </div>
                            <div class="col-12">
                                <span class="lblselect2">Classe:</span>
                                <select id="cbiclasse" data-placeholder="Selecione uma opção"
                                    v-model="iidclasse"
                                    data-allow-clear="true" style="width:100%;">
                                </select>
                            </div>                            
                            <div class="col-12">
                                <label for="edivalorimposto">Imposto:</label>
                                <input type="text" class="form-control form-control-sm text-info" id="edivalorimposto"
                                    v-bind:value="mtdformatavalordecimal(parseFloat(ivalorimposto), 2)"
                                    data-bv-group=".group" style="text-align:right;" disabled>
                            </div>                            
                            <div class="col-12">
                                <label for="edvalorcomimposto">Valor com imposto:</label>
                                <money type="text" class="form-control form-control-sm" id="edvalorcomimposto" v-model="ivalorcomimposto"
                                        v-bind="money" data-bv-group=".group" style="text-align:right; font-weight: bold;" disabled></money>
                            </div>                                                                                                                                                                                                                                  
                        </div>
                    </div>                                            
                    <div class="modal-footer">
                        <button type="button" class="btn btn-primary btn-sm" @click.prevent="mtdselecionavalorbase()" style="width: 100px;"><i class="fa fa-check"></i> Ok</button>                        
                        <button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal" style="width: 100px;"><i class="fa fa-close"></i> Cancelar</button>
                    </div>                          
                </div>
            </div>
        </div>     
        
         <!-- Informar o valor para calcular o percentual da margem de desconto promocional -->
         <div class="modal fade" id="mdinformarvalordescpromocional" tabindex="-1">
            <div class="modal-dialog modal-sm modal-dialog-centered">
                <div class="modal-content">                        
                    <div class="modal-header">
                        <i class="fa fa-percent" style="margin-top: 8px; margin-right: 7px"></i><h4 class="modal-title" style="color: #fff; font-size: 12px; margin-top: 5px;">Calcular percentual do descto promocional</h4>
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>                
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-12">
                                <label for="edvalorsemdescpromocional">Valor sem desc. promocional:</label>
                                <money type="text" class="form-control form-control-sm" id="edvalorsemdescpromocional" v-model="avalorsemdescpromocional"
                                        v-bind="money" data-bv-group=".group" style="text-align:right; font-weight: bold;" disabled></money>
                            </div>                            
                            <div class="col-12">
                                <label for="edvalorcomdescpromocional">Valor com desc. promocional:</label>
                                <money type="text" class="form-control form-control-sm" id="edvalorcomdescpromocional" v-model="avalorcomdescpromocional"
                                        v-bind="money" data-bv-group=".group" style="text-align:right; font-weight: bold;" @change.native="mtdcalcularvalordescpromocional()"></money>
                            </div>                             
                            <div class="col-12">
                                <label for="edamargem">Percentual do desconto(%):</label>
                                <money type="text" class="form-control form-control-sm" id="edamargem" v-model="amargemdescpromocional"
                                        v-bind="money" data-bv-group=".group" style="text-align:right;" disabled></money>
                            </div>                                                                                                                                                                                                                                  
                        </div>
                    </div>                                            
                    <div class="modal-footer">
                        <button type="button" class="btn btn-primary btn-sm" @click.prevent="mtdaplicarpercentualdescpromocional()" style="width: 100px;"><i class="fa fa-check"></i> Aplicar</button>                        
                        <button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal" style="width: 100px;"><i class="fa fa-close"></i> Cancelar</button>
                    </div>                          
                </div>
            </div>
        </div>  
    </div>
</template>
<script>
    import BreadCrumb from '../components/cmpbreadcrumb.vue'
    import VueBootstrap4Table from 'vue-bootstrap4-table'
    import vPagination from 'vue-plain-pagination'
	import ConsultarFornecedores from '../components/cmpconsultarfornecedores.vue'
	import ConsultarProdutos from '../components/cmpconsultarprodutos.vue'
    import * as moment from 'moment'
    import util from '../utilitarios/util.js'
    import { useSound } from '@vueuse/sound'
    import conferenciaSfx from '@/assets/conferencia.mp3'

    export default {
        name: 'cadnotasfornecedores',
        components:{
            VueBootstrap4Table,
            vPagination,
            'breadcrumb' 			: BreadCrumb,
			'consultafornecedores'  : ConsultarFornecedores,
			'consultaprodutos'  	: ConsultarProdutos,
        },
        data: function() {
            return {
                statusaxios         : '',
                lstnotas            : [],
                lstitensexportar    : [],
                pnumero             : '',
                pidfornecedor       : null,
                pidfilial           : null,
                pfiltroperiodo      : 1,
                hab_desab_periodo   : false,
				pdtini       		: util.DataAtual(true),
                pdtfim       		: util.DataAtual(true),
                pefetivadas         : 2,                 
                pqtdregistros       : 10,
                pqtd_paginas        : 1,
                pagina_atual        : 1,
                pqtd_total_registros: 0,
                origempesqpro       : 0,
                totalnotas          : 0, 
                
                //menu
                notamenu            : [],

                //variáveis do crud
                ativadesativaCodFor     : false,
                ativadesativanumeronota : false,
                hab_desab_camposnf  : true,                
                opcrud              :  0,
                vidfornecedor       : '',
                vnomefornecedor     : '',
                vidfilial           : null,
                vformulacustopro    : '',
                vnumero             : '',
                vserie              : '',
                vmodelo             : '',
                vnaturezaoperacao   : '',
                vchaveacesso        : '',
                vxml                : '',
                vobservacoes        : '',
                vtipofrete          : 0,
                vtipo               : 0,
                vdtemissao          : util.DataAtual(true, false),
                vdtentrada          : util.DataAtual(true, false),
                vtotvicms           : 0,
                vtotvipi            : 0,
                vtotvfrete          : 0,
                vtotvoutros         : 0,
                vtotbcst            : 0,
                vtotst              : 0,
                vtotvpis            : 0,
                vtotvcofins         : 0,
                vtotvtotal          : 0,
                vtotvcusto          : 0,
                vtotdesc            : 0,

                lstitensnota        : [],

                //variáveis do manifesto
                mdtini              : moment().format('01/MM/YYYY'),
                mdtfim              : moment().endOf('month').format('DD/MM/YYYY'),
                lstnotasmanifesto   : [],
                midfilialmanifesto  : null,
                midestoquemanifesto : null,
                mformulacustomanifesto: '',
                mperiodomanifesto   : 0,

                notamanifestar      : [],
                mtpevento           : '210200',
                mxjust              : '',


                //variável para habilitação dos campos
				ativadesativa       : true,
				
				//variáveis de edição do item
				vshowprtabela			: false,//oculta a visualização do preço do produto na listagem
				vidtabela				: 1,//informo somente pq o componente exige
                tipopropesquisa         : '',
                vidcfop                 : null,
                vcstitem                : '',
                vcstpiscofins           : '',
                idcfopleg               : 0,
                desccefopleg            : '',
                vopitem					: 0,
                iditemalt               : 0,//somente para alteração							
                iditem                  : 0,
				vidprodutoedicao    	: '',
				vcoddigedicao			: '',
				vdescricaoprodutoedicao : '',
				vundprodutoedicao		: '',
				vqtditemedicao			: 1,
				videstoqueedicao		: null,
				vfracionadoedicao		: 0,
                vreferencia             : '',
				vprcompra				: 0,
				vvdesconto				: 0,
				vpicms					: 0,
				vvicms					: 0,
				vpipi					: 0,
				vvipi					: 0,
				vpfrete					: 0,
				vvfrete					: 0,
				vpoutros				: 0,
				vvoutros				: 0,
				vppis					: 0,
				vvpis					: 0,
				vpcofins				: 0,
                vvcofins				: 0,
                vpmvast                 : 0,
                vvbcst                  : 0,
                vpicmsst                : 0,
                vvicmsst                : 0,
                vcalcularprvendamedio   : false,

				vprvendamedio			: 0,
				vprcusto				: 0,
                vvtotal					: 0,
                vvtotalcusto            : 0,

                //tabelas de preços
                vhabilitaedicaotabelas  : false,
                //classes
                vhabilitaedicaoclasses  : false,

                //vincular pedido de compra a nota de entrada
                vhabrelacaopedcompra    : false,


                // tabelas preco
                habdestab               : false,
                voptabela               : 1,
                vidtabelapreco          : null,
                lstTabelasPrecos        : [],
                vmrgtabela              : 0,
                vvltabela               : 0,
                vvlnf                   : 0,
                vcomissaotabela         : 0,
                vqtdmintabela           : 0,
                vdescontotabela         : 0,   
                vvlvizu                 : 0,
                vvldescpromocional      : 0,

                //variáveis para atruibuir percentual do desconto promocional
                avalorsemdescpromocional : 0,
                avalorcomdescpromocional : 0,
                amargemdescpromocional   : 0,  

                //classes
				lstClassesProduto	    : [],
                vidclasse               : null,
                vidfilialclasse         : null,                

                //variáveis para pré-visualização da nfe
                pitemvincular           : [],
                pnotaentrada            : [],
                pvinculartodos          : true,

                //variáveis de alteração do fator
                pitemfator              : [],
                pfator                  : 1,

                //variáveis para edição dos itens para cadastro automatizado
                aitemedicao_item        : 0,
                aitemedicao_cprod       : '',
                aitemedicao_xprod       : '',
                aitemedicao_cean        : '',
                aitemedicao_ucom        : null,
                aitemedicao_idmarca     : null,
                aitemedicao_idgrupo     : null,
                aitemedicao_idsubgrupo  : null,

                //listagem de produtos a cadastrar
                lstprodutoscadastrar    : [],

                //variáveis para efetivação
                notaefetivar            : [],
                lstformasefetivar       : [],
                edtefetivacao           : util.DataAtual(true, false),
                lsttitulosefetivar      : [],
                eqtdtitulosgerar        : 1,
                eintervaloparcelas      : 30,
                ecodigoauxiliargerar    : '',
                eidtipocobrancagerar    : null,
                etipocobrancagerar      : 0,
                vcodpedcompra           : '',
                

                //variáveis para atualizações
                vatzsomentecusto        : true,
                notaatualizar           : [],
                atipoatualizacao        : 0,
                fatorajuste             : 0,

                etotaltitulos           : 0,

                ecodtit                 : '',
                edtventit               : '',
                evltit                  : 0,
                eidfornecedor           : null,
                eidtipocobranca         : null,
                etipocobranca           : 0,
                edescricaocob           : '',
                enumerocheque           : '',
                eidbanco                : null,
                eagencia                : '',
                econta                  : '',
                epraca                  : '',
                eemitente               : '',
                ecnpjcpf                : '',
                eidsituacaocheque       : null,
                ecodigoauxiliar         : '',
                ///////////////////////////

                //alteração de totalizadores
                ttotalizadoraplicar     : 0,
                tvaloraplicar           : 0,

                detnota                 : [],

                //campos para conferência
                cfidfornecedor          : null,
                cfidfilial              : null,
                cfnumeronf              : null,
                lstitensnotas           : [],
                lstcodigos              : [],
                ativadesativa           : false,

                vmultiplicadoredicao    : 1,

                ativadesativacod        : true,
                vicodpro                : null,
                videscpro               : '',
                vmultiplicador          : 1,
                vqtdfalta               : 0,
                vachouPro               : false,
                vmsgPro                 : '',
                vfaltaitens             : true,
                vfinalizado             : false,

                //variáveis do calculo do imposto sobre o valor
                ivalorbase              : 0,
                iidclasse               : null,
                iclasse                 : [],
                ivalorimposto           : 0,
                ivalorcomimposto        : 0,                

                //exportar itens da nota para o rillsoft label creator
                lstitensexportar         : [],
                json_fields: {
							'ORDEM'			: 'item',
                            'CODIGO'        : 'coddig',
                            'DESCRICAO'     : 'descricao',
							'MARCA'         : 'descmarca',
							'LOCALIZACAO'   : 'localizacao',
                            'REFERENCIA'    : 'referencia',                            							
                            'VALOR'     	: 'vprvendamedio',
                            'QTDETIQUETAS'  : 'qtditem'
                }, 
                json_meta: [
                    [
                        {
                            'key': 'charset',
                            'value': 'utf-8'
                        }
                    ]
                ],                               

                options: {
                    format           : 'DD/MM/YYYY',
                    useCurrent       : false,
                    locale           : 'pt-BR'
                },				
				money				: {
                    decimal         : ',',
                    thousands       : '.',
                    prefix          : '',//aqui colocar o cifrão se for necessário
                    precision       : 2,
                    masked          : false
                },
				money3				: {
                    decimal         : ',',
                    thousands       : '.',
                    prefix          : '',//aqui colocar o cifrão se for necessário
                    precision       : 3,
                    masked          : false
                },                
                bootstrapPaginationClasses: {
                    ul: 'pagination pagination-sm',
                    li: 'page-item',
                    liActive: 'active',
                    liDisable: 'disabled',
                    button: 'page-link'
                },
                itensbc : {
                    item1 : {
                        titulo : 'NOTAS DE FORNECEDORES',
                        ativo  : false
                    },
                    item2 : {
                        titulo : '',
                        ativo  : false
                    }
                },
                columns: [
                    {
                        label: 'Opções',
                        name : 'opcoes',
                        row_text_alignment: "text-center",
                        column_text_alignment: "text-center",
                        row_classes: "def-col-opcoes",
                        sort: false
                    },
                    {
                        label: "",
                        name: "situacao",
                        sort: false,
                        initial_sort : false,
                        slot_name: "slot_detalhes",
                        row_classes: "def-col-detalhes",
                        row_text_alignment: "text-center",
                        column_text_alignment: "text-center"                        
                    },
                    {
                        label: "Situação",
                        name: "situacao",
                        sort: true,
                        slot_name: "slot_situacao",
                        row_classes: "def-col-situacao",
                    },
                    {
                        label: "Conf.",
                        name: "conferida",
                        sort: true,
                        slot_name: "slot_conferida",
                        row_classes: "def-col-conferida",
                    },                                        
                    {
                        label: "Número",
                        name: "numero",
                        sort: true,
                        initial_sort : true,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',                        
                        slot_name: "slot_numero",
                        row_classes: "def-col-cod",
                    },
                    {
                        label: "Fornecedor",
                        name: "nomefornecedor",
                        initial_sort : false,
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "Filial",
                        name: "fantasiafilial",
                        initial_sort : false,
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "Nr. compra",
                        name: "codpedcompra",
                        sort: true,
                        initial_sort : true,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',                        
                        row_classes: "def-col-cod",
                    },
                    {
                        label: "Emissão",
                        name: "dtemissao",
                        initial_sort : false,
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "Total da Nota",
                        name: "vtotvtotal",
                        sort: true,
                        initial_sort : false,
                        slot_name: "slot_vtotvtotal",
                        row_classes: "def-col-vtotvtotal",
                        row_text_alignment: "text-right",
                        column_text_alignment: "text-left"                        
                    }
                ],
                columnsitens: [
                    {
                        label: 'Opções',
                        name : 'opcoes',
                        row_text_alignment: "text-center",
                        column_text_alignment: "text-center",
                        row_classes: "def-col-opcoes",
                        sort: false
                    },
                    {
                        label: "Item",
                        name: "item",
                        sort: true,
                        initial_sort : true,//acrescentar isso na coluna que for iniciar ordenado
                        slot_name: "id_item",
                        row_classes: "def-col-item",
                    },                    
                    {
                        label: "Código",
                        name: "coddig",
                        sort: true,
                        slot_name: "id_f",
                        row_classes: "def-col-cod",
                    },
                    {
                        label: "Descrição",
                        name: "descricao",                        
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "Und",
                        name: "und",                        
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "Referência",
                        name: "referencia",                        
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "Pr. Compra",
                        name: "prcompra",
                        sort: true,
                        slot_name: "slot_prcompra",
                        row_classes: "def-col-valores",
                        row_text_alignment: "text-right",
                        column_text_alignment: "text-left"                        
                    },                    
                    {
                        label: "Qtd",
                        name: "qtditem",                        
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "Descto($)",
                        name: "vdesconto",
                        sort: true,
                        slot_name: "slot_desconto",
                        row_classes: "def-col-valores",
                        row_text_alignment: "text-right",
                        column_text_alignment: "text-left"                        
                    },
                    {
                        label: "Total",
                        name: "vvtotal",
                        sort: true,
                        slot_name: "slot_total",
                        row_classes: "def-col-valores",
                        row_text_alignment: "text-right",
                        column_text_alignment: "text-left"                        
                    },                    
                    {
                        label: "Estoque",
                        name: "descestoque",
                        sort: true,
                        row_classes: "def-col-estoque",
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"                        
                    },                    
                    {
                        label: "Preços",
                        name: "precos",
                        initial_sort : false,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left",
                        slot_name: "slot_precos",
                        row_classes: "def-col-slot-precos-nf-for"
                    }  
                ],
				columnsconf: [
					{
						label: "Código",
						name: "coddig",
						sort: true,
						slot_name: "id_f",
						row_classes: "def-col-cod",
					},          						
					{
						label: "Descrição",
						name: "descricao",
						initial_sort : true,
						initial_sort_order: 'asc',
						sort: true,
						row_text_alignment: "text-left",
						column_text_alignment: "text-left"
                    },
                    {
                        label: "Marca",
                        name: "descmarca",
                        initial_sort : true,
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left",
                        row_classes: "def-col-marca"
                    },
                    {
                        label: "Unidade",
                        name: "und",
                        initial_sort : false,
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-center",
                        column_text_alignment: "text-center",
                        row_classes: "def-col-und"
                    },
                    {
                        label: "Qtd.",
                        name: "qtditem",
                        initial_sort : false,
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-center",
                        column_text_alignment: "text-center",
                        slot_name: "qtd_p",
                        column_classes: "def-col-qtd"
                    },           
                    {
                        label: "Qtd. Conf.",
                        name: "qtdconf",
                        initial_sort : false,
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-center",
                        column_text_alignment: "text-center",
                        slot_name: "qtd_c",
                        column_classes: "def-col-qtdconf"
                    },
                    {
                        label: "Qtd. Falta",
                        name: "qtdfalta",
                        initial_sort : false,
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-center",
                        column_text_alignment: "text-center",
                        slot_name: "qtd_f",
                        column_classes: "def-col-qtdfalta"
                    },
                    {
                        label: "Status",
                        name: "situacao",
                        initial_sort : false,
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-center",
                        column_text_alignment: "text-center",
                        slot_name: "status_s",
                        column_classes: "def-col-status"
                    },                              
                ],                                
                config: {
                    pagination: false,
                    pagination_info: false,
                    card_mode: false,
                    global_search: {
                        visibility: false,
                    },
                    show_refresh_button : false,
                    show_reset_button : false
                },
                classes: {
                    table: "table-bordered table-striped table-sm"
                }
            }
        },
        methods:{
            mtddefinirmargemprvenda(){
                $('#mdatribuirmargem').modal('show');                
            },
            mtdcalculamargemprvendamedio(){
                let vlmrg   = parseFloat(this.vprcusto) * parseFloat(this.amargem) / 100;
                this.avalor = (parseFloat(this.vprcusto) + vlmrg).toFixed(2);
            },
            mtdaplicarvalorprvenda(){
                this.vprvendamedio = this.avalor;
                this.vmargemprcusto= this.amargem;
                $('#mdatribuirmargem').modal('hide');                
            },
			mtdmostrarmenu(nota){				
				this.notamenu = nota;
				$('#mdmenunotafornecedor').modal('show');
			},             
            mtdformatardoc(doc){
                return util.formatacpfcnpj(doc);
            },
            formatavalores:function (val) {
                return util.formatarvalor(val, '');
            },            
			mtdformatavalordecimal(valor, digitos){
				return util.formatavalordecimais(valor, digitos);
            },
			mtdformatadatagravar(dtformatar){
				let strret = dtformatar.replace(/\D/g, "");
				return strret.substring(0,2)+'/'+strret.substring(2,4)+'/'+strret.substring(4);
			},            
			mtdformatarzeros(str, length){
				return util.formatarzeros(str, length);
			},            
            mtdformatardata(datastr){
                let dtretstr = util.formatadatahrdb(datastr);
                return dtretstr.replace("T", " ");
            },    
            mtdselect2_def(){
                let vself = this;
                let sqliniusuario = parseInt(vself.utodasfiliais) === 0 ? 'select f.codfil, f.fantasia from tbfiliaisusuario fu left join tbfiliais f on f.codfil=fu.idfilial ' : 'select codfil, fantasia from tbfiliais ';
                let sqlfimusuario = parseInt(vself.utodasfiliais) === 0 ? 'where upper(f.fantasia) like upper("%@@%") and fu.idusuario='+vself.$store.state.usuario.id 		 : 'where upper(fantasia) like upper("%@@%")';

                //define métodos ao sair dos campos
                $("#edmrgtabela").blur(function(){
                    vself.mtdcalculaprtabela();
                });
                $("#edvltabela").blur(function(){
                    vself.mtdcalculamrgtabela();
                });  

				//selects da consulta
				$("#cbfilialpesq").select2({
					id: function (e) {return e.codfil},
					ajax: {						
						url: vself.$store.state.configpaths.pathselect2sql,						
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q		: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								sqlini	: sqliniusuario,
								sqlfim	: sqlfimusuario,
								cpid	: 'codfil',
								cpdesc	: 'fantasia'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.pidfilial = $("#cbfilialpesq").val();
					vself.mtdlimpar_listagem();
				});                
                $("#cbfornecedorpesq").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbfornecedores',
								c1: 'id',
								c2: 'nomerazaosocial'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 1,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
                    vself.pidfornecedor = $("#cbfornecedorpesq").val();
                    vself.mtdlimpar_listagem();
                });                                
				$("#cbfilial").select2({
					id: function (e) {return e.codfil},
					ajax: {						
						url: vself.$store.state.configpaths.pathselect2sql,						
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q		: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								sqlini	: sqliniusuario,
								sqlfim	: sqlfimusuario,
								cpid	: 'codfil',
								cpdesc	: 'fantasia'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
                    vself.vidfilial = $("#cbfilial").val();
                    let loader      = vself.$loading.show();
                    let filtro      = ' and f.codfil='+vself.vidfilial;
                    let parametros  = [
                        {parametro: 'op',           valor : 'listagem'},
                        {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                        //{parametro: 'diretoriocertificados', valor : vself.$store.state.configpaths.pathcertificados+vself.$store.state.filialpadrao.idcliente},
                        {parametro: 'filtro',       valor : filtro},
                        {parametro: 'limit',        valor : 1},
                        {parametro: 'offset',       valor : 0},
                    ];
                    let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadfiliais.php');
                    retorno.then(function (response) {
                        loader.hide();
                        vself.vformulacustopro = response.data[0].formulacustoproduto;
                    }).catch(function (response) {
                        loader.hide();
                    });
				});                
				$("#cbfilialmanifesto").select2({
					id: function (e) {return e.codfil},
					ajax: {						
						url: vself.$store.state.configpaths.pathselect2sql,						
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q		: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								sqlini	: sqliniusuario,
								sqlfim	: sqlfimusuario,
								cpid	: 'codfil',
								cpdesc	: 'fantasia'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
                    vself.lstnotasmanifesto     = [];
                    vself.midfilialmanifesto    = $("#cbfilialmanifesto").val();
                    let loader      = vself.$loading.show();
                    let filtro      = ' and f.codfil='+vself.midfilialmanifesto;
                    let parametros  = [
                        {parametro: 'op',           valor : 'listagem'},
                        {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                        //{parametro: 'diretoriocertificados', valor : vself.$store.state.configpaths.pathcertificados+vself.$store.state.filialpadrao.idcliente},
                        {parametro: 'filtro',       valor : filtro},
                        {parametro: 'limit',        valor : 1},
                        {parametro: 'offset',       valor : 0},
                    ];
                    let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadfiliais.php');
                    retorno.then(function (response) {
                        loader.hide();
                        vself.mformulacustomanifesto = response.data[0].formulacustoproduto;
                    }).catch(function (response) {
                        loader.hide();
                    });                    
                });                               
                $("#cbestoqueedicao").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbestoques',
								c1: 'id',
								c2: 'descricao'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.videstoqueedicao = $("#cbestoqueedicao").val();
                });
                $("#cbcfopedicao").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbcfops',
								c1: 'id',
								c2: 'descricao'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.vidcfop = $("#cbcfopedicao").val();
                });
                $("#cbestoquemanifesto").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbestoques',
								c1: 'id',
								c2: 'descricao'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.midestoquemanifesto = $("#cbestoquemanifesto").val();
                });
                $("#cbunidadeedicao").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbunidades',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.aitemedicao_ucom = $("#cbunidadeedicao").val();
                });
                $("#cbmarcaedicao").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbmarcas',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.aitemedicao_idmarca = $("#cbmarcaedicao").val();
                });
                $("#cbgrupoedicao").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbgrupos',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.aitemedicao_idgrupo = $("#cbgrupoedicao").val();
                });
                $("#cbsubgrupoedicao").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbsubgrupos',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.aitemedicao_idsubgrupo = $("#cbsubgrupoedicao").val();
                });            
				$("#cbtipocobrancagerar").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbtiposcobranca',
								c1: 'id',
								c2: 'descricao'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.eidtipocobrancagerar = $("#cbtipocobrancagerar").val();
                    if (vself.eidtipocobrancagerar != null) {
                        let loader      = vself.$loading.show();
                        let parametros  = [
                            {parametro: 'op',           valor : 'listagem'},
                            {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                            {parametro: 'filtro',       valor : ' and id='+vself.eidtipocobrancagerar},
                            {parametro: 'limit',        valor : 1},
                            {parametro: 'offset',       valor : 0},
                        ];
                        let retorno          = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadtiposcobranca.php');
                        retorno.then(function (response) {
                            vself.etipocobrancagerar = parseInt(response.data[0].tipo); 
                            loader.hide();
                        }).catch(function (response) {
                            loader.hide();
                        });
                    } else {//quando limpa seleção
                        vself.etipocobrancagerar = 0;
                    }					
                });                
                $("#cbfornecedor").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbfornecedores',
								c1: 'id',
								c2: 'nomerazaosocial'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 1,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
                    vself.eidfornecedor = $("#cbfornecedor").val();
                });
                $("#cbtipocobranca").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbtiposcobranca',
								c1: 'id',
								c2: 'descricao'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.eidtipocobranca = $("#cbtipocobranca").val();
                    if (vself.eidtipocobranca != null) {
                        let loader      = vself.$loading.show();
                        let parametros  = [
                            {parametro: 'op',           valor : 'listagem'},
                            {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                            {parametro: 'filtro',       valor : ' and id='+vself.eidtipocobranca},
                            {parametro: 'limit',        valor : 1},
                            {parametro: 'offset',       valor : 0},
                        ];
                        let retorno          = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadtiposcobranca.php');
                        retorno.then(function (response) {
                            vself.etipocobranca = parseFloat(response.data[0].tipo); 
                            loader.hide();
                        }).catch(function (response) {
                            loader.hide();
                        });
                    } else {//quando limpa seleção
                        vself.etipocobranca = 0;
                    }					
				});
                $("#cbbanco").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbbancos',
								c1: 'id',
								c2: 'descricao'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.eidbanco = $("#cbbanco").val();
				});
                $("#cbsituacaocheque").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbsituacoescheques',
								c1: 'id',
								c2: 'descricao'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.eidsituacaocheque = $("#cbsituacaocheque").val();
				});
                //select da tabelela de preços
                $("#cbtabelapreco").select2({
                    id: function (e) {return e.id},
                    ajax: {
                        url: vself.$store.state.configpaths.pathselect2,
                        dataType: 'json',
                        delay: 250,
                        data: function (params) {
                            return {
                                q: params.term,
                                idclientesac : vself.$store.state.filialpadrao.idcliente,
                                tb: 'tbtabelasprecos',
                                c1: 'id',
                                c2: 'descricao'
                            };
                        },
                        processResults: function (data) {
                            return {
                                results: data
                            };
                        },
                        cache: true
                    },
                    minimumInputLength: 0,
                    theme: 'bootstrap',
                    language: "pt-BR",
                    templateResult: util.formatResult,
                    templateSelection: util.formatSelection
                }).change(function () {
                    vself.vidtabelapreco = $("#cbtabelapreco").val();
                    if (vself.vidtabelapreco != null) {
                        let loader      = vself.$loading.show();
                        let parametros  = [
                            {parametro: 'op',           valor : 'listagem'},
                            {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                            {parametro: 'filtro',       valor : ' and id='+vself.vidtabelapreco},
                            {parametro: 'limit',        valor : 1},
                            {parametro: 'offset',       valor : 0},
                        ];
                        let retorno          = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadtabelasprecos.php');
                        retorno.then(function (response) {
                            if (parseInt(vself.voptabela) === 1){
                                vself.vmrgtabela = parseFloat(response.data[0].margem); 
                                vself.mtdcalculaprtabela();                           
                            }
                            loader.hide();
                        }).catch(function (response) {
                            console.log(response);
                            loader.hide();
                        });
                    } else {//quando limpa seleção
                        vself.vmrgtabela = 0;
                        vself.vvlvtabela = 0;
                    }
                });
                
                //selects das classes
                $("#cbclasse").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbclassesimpostos',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.vidclasse = $("#cbclasse").val();
                });                
                $("#cbfilialclasse").select2({
                        id: function (e) {return e.codfil},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbfiliais',
                                    c1: 'codfil',
                                    c2: 'fantasia'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.vidfilialclasse = $("#cbfilialclasse").val();
                });                
                    
                //classe do cálculo do imposto sobre o valor
                $('#mdimpostovalor').on('shown.bs.modal', function(e){
                    vself.ivalorbase = vself.vvltabela === 0 ? 0 : vself.vvltabela;
                    setTimeout(() => {
                        $('#edivalorbase').focus();
                    }, 300);                    
                });                 
                $("#cbiclasse").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbclassesimpostos',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.iidclasse = $("#cbiclasse").val();
                    let loader      = vself.$loading.show();
                    let filtro      = ' and ci.id='+vself.iidclasse;
                    let parametros  = [
                        {parametro: 'op',           valor : 'listagem'},
                        {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                        {parametro: 'filtro',       valor : filtro},
                        {parametro: 'limit',        valor : 99999999999},
                        {parametro: 'offset',       valor : 0},
                    ];
                    let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadclassesimpostos.php');
                    retorno.then(function (response) {
                        loader.hide();                        
                        vself.iclasse        = response.data[0];
                        vself.iclasse.campos = vself.iclasse.lstcampos;
                        vself.mtdcalculavalorimpostoclasse();

                    }).catch(function (response) {
                        vself.iclasse = [];
                        loader.hide();
                    });

                });                

                $('#mdedicaoitem').on('shown.bs.modal', function (e) {
					if (parseInt(vself.vopitem) === 1){
						$('#edidprodutoedicao').focus();
					}else{
						$('#edqtditemedicao').focus();
					}
                });
				$('#mdalteracaofator').on('shown.bs.modal', function (e) {
					$('#edfatoralteracao').focus();
                });
				$('#mdalteracaodadositem').on('shown.bs.modal', function (e) {
					//$('#edfatoralteracao').focus();
                });                                
				$('#mdefetivarnota').on('shown.bs.modal', function (e) {
					$('#eddtefetivacao').focus();
                });                								               
				//campos para faturamento
				$('#mdalterartitulo').on('shown.bs.modal', function (e) {
					$('#eddtventit').focus();
				});	            
                $('#mdatualizacoes').on('shown.bs.modal', function (e) {
					$('#cbtipoatualizacao').focus();
                });
                $('#mdlalterartotalizadores').on('shown.bs.modal', function (e) {                    
					$('#cbtotalizadoraplicar').focus();
                }); 
                $('#mddefinemultiplicador').on('shown.bs.modal', function (e) {                    
					$('#edmultiplicadoredicao').focus();
                }); 
                // $('#mddefinemultiplicador').on('hidden.bs.modal', function (e) {                    
				// 	$('#edvicodpro').focus();
                // });                                 
            },
            mtdlocalizarproduto(coddig, origem){
                let vself           = this;
                vself.origempesqpro = origem;
				if (coddig !== '' && coddig !== null){					
					let loader      = vself.$loading.show();
					let parametros  = [
						{parametro: 'op',               valor : 'listagem'},
						{parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
						{parametro: 'diretorioimagens', valor : vself.$store.state.configpaths.pathimgprodutos+vself.$store.state.filialpadrao.idcliente},
						{parametro: 'filtro',           valor : ''},
						{parametro: 'coddig',           valor : coddig},
						{parametro: 'limit',            valor : 1},
						{parametro: 'offset',           valor : 0},
					];
					let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadprodutos.php');
					retorno.then(function (response) {
						loader.hide();						
						if (response.data.length > 0){
                            let produto = response.data[0];
                            if (parseInt(vself.origempesqpro) === 0){
                                vself.vidprodutoedicao			= produto.id;
                                vself.vdescricaoprodutoedicao 	= produto.descricao;
                                vself.vundprodutoedicao			= produto.und;
                                vself.vfracionadoedicao			= produto.fracionado;
                                vself.vprvendamedio             = produto.prvendamedio;
                                vself.vreferencia               = produto.referencia;
                                vself.lstTabelasPrecos          = produto.tabelas;
                                vself.lstClassesProduto         = produto.classes;
                                vself.$nextTick(function () {
                                    $('#edqtditemedicao').focus();
                                });
                            }else if(parseInt(vself.origempesqpro) === 1){
                                vself.mtdadicionarvinculo(produto);
                            }
						}else{
                            if (parseInt(vself.origempesqpro) === 0){
                                vself.$toastr.w('Código informado não cadastrado no sistema!', 'Atenção!');
                                vself.mtdlimparedicaoitem();
                                $('#edidprodutoedicao').focus();
                            }                          
						}
					}).catch(function (response) {
						loader.hide();
					});
				}else{
                    if (parseInt(vself.origempesqpro) === 0){
                        vself.mtdlimparedicaoitem();
                    }else if(parseInt(vself.origempesqpro) === 1){

                    }                    
				}
            },			
            mtdconsultarproduto(origem, iv){
                this.origempesqpro = origem;
                this.pitemvincular = iv;
                if (parseInt(this.origempesqpro) === 0){
                    if (parseInt(this.vopitem) === 1){
                        let payload = {
                            abrirtela    : true			
                        };
                        this.$store.commit('CONSULTA_PRODUTO_CHANGE',payload);
                        let payloadx = {
                            idproduto    : null			
                        };
                        this.$store.commit('PRODUTO_RETORNO_CHANGE',payloadx);                
                    }
                }else if(parseInt(this.origempesqpro) === 1){
                    let payload = {
                        abrirtela    : true			
                    };
                    this.$store.commit('CONSULTA_PRODUTO_CHANGE',payload);
                    let payloadx = {
                        idproduto    : null			
                    };
                    this.$store.commit('PRODUTO_RETORNO_CHANGE',payloadx);                
                }
			},			
            mtdconsultarfornecedor(){
				if (parseInt(this.opcrud) < 2){
					this.vidfornecedor 	= '';
					this.vnomefornecedor 	= '';
					let payload = {
						abrirtela    : true			
					};
					this.$store.commit('CONSULTA_FORNECEDOR_CHANGE',payload);
					let payloadx = {
						idfornecedor    : null			
					};
					this.$store.commit('FORNECEDOR_RETORNO_CHANGE',payloadx);                
				}
            },
            mtdlocalizarfornecedor(idfornecedor){
				if (idfornecedor !== '' && idfornecedor !== null){
					var vself       = this;
					let loader      = vself.$loading.show();
					let parametros  = [
						{parametro: 'op',               valor : 'listagem'},
						{parametro: 'idclientesac',     valor  : vself.$store.state.filialpadrao.idcliente},
						{parametro: 'filtro',           valor : 'and f.id='+idfornecedor},
						{parametro: 'limit',            valor : 1},
						{parametro: 'offset',           valor : 0},
					];
					let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadfornecedores.php');
					retorno.then(function (response) {
						loader.hide();						
						if (response.data.length > 0){
							let fornecedor = response.data[0];							
							vself.vidfornecedor  			    = fornecedor.id;
							vself.vnomefornecedor 				= fornecedor.nomerazaosocial;
							$('#ednumeronota').focus();
						}else{
							vself.$toastr.w('Código informado não cadastrado no sistema!', 'Atenção!');
							vself.vidfornecedor 	= '';
							vself.vnomefornecedor 	= '';
							$('#edidfornecedor').focus();
						}
					}).catch(function (response) {
						loader.hide();
					});
				}else{
					this.vidfornecedor 	= '';
					this.vnomefornecedor 	= '';
				}
            },            
            mtdfiltropesquisa(){
                let rfiltro = '';
                
                rfiltro = this.pnumero === '' ? '' : ' AND n.numero='+this.pnumero;
                
                if (this.pidfornecedor !== null){
                    rfiltro = rfiltro + ' AND n.idfornecedor='+this.pidfornecedor;
                }                
                
                if (this.pidfilial !== null){
                    rfiltro = rfiltro + ' AND n.idfilial='+this.pidfilial;
                }

				if(parseInt(this.pfiltroperiodo) === 1){
                    rfiltro = rfiltro + ' AND n.dtemissao BETWEEN "' + util.InverterData(this.pdtini) + '" AND "' + util.InverterData(this.pdtfim) + '"';
                }				                
                
                if (parseInt(this.pefetivadas) < 2){
                    rfiltro = rfiltro + ' AND n.situacao='+this.pefetivadas;
                }

                return rfiltro;
            },
            mtdexecutapesquisa(){
                var vself           = this;
                let filtro          = vself.mtdfiltropesquisa();
                this.pagina_atual   = 1;
                let parametros      = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor  : 'qtdregistros'},
                    {parametro: 'filtro',       valor  : filtro}
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadnotasfornecedores.php');
                retorno.then(function (response) {
                    vself.pqtd_total_registros = parseInt(response.data.qtdregistros);
                    let qtdpg                  = Math.ceil(vself.pqtd_total_registros / vself.pqtdregistros);
                    vself.pqtd_paginas         = qtdpg > 0 ? qtdpg : 1;
                    vself.mtdcarreganotas(1);
                }).catch(function (response) {
                    alert('Erro ao consultar registros');
                });
            },
            mtdcarreganotas(ipagina){
                var vself       = this;
                let loader      = this.$loading.show();
                let filtro      = vself.mtdfiltropesquisa();
                let parametros  = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor : 'listagem'},
                    {parametro: 'filtro',       valor : filtro},
                    {parametro: 'limit',        valor : vself.pqtdregistros},
                    {parametro: 'offset',       valor : (parseInt(ipagina) -1) * parseInt(vself.pqtdregistros)},
                ];
                let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadnotasfornecedores.php');
                retorno.then(function (response) {
                    vself.lstnotas   = response.data.notas;
                    vself.totalnotas = response.data.totalnotas;
                    loader.hide();
                }).catch(function (response) {
                    vself.lstnotas = [];
                    vself.totalnotas = 0;
                    loader.hide();
                });
            },
            resetarDados() {
                util.toTop();

                this.vidfornecedor              = '';
                this.vnomefornecedor            = '';
                this.vidfilial                  = this.$store.state.filialpadrao.codfil;
                this.vnumero                    = '';
                this.vtipo                      = 0;
                this.vtipofrete                 = 0;
                this.vmodelo                    = '';
                this.vserie                     = '';
                this.vnaturezaoperacao          = '';
                this.vchaveacesso               = '';
                this.vxml                       = '',
                this.vobservacoes               = '';
                this.vtotvicms                  = 0;
                this.vtotvipi                   = 0;
                this.vtotvfrete                 = 0;
                this.vtotvoutros                = 0;
                this.vtotbcst                   = 0;
                this.vtotst                     = 0;                
                this.vtotvpis                   = 0;
                this.vtotvcofins                = 0;                
                this.vtotvtotal                 = 0;
                this.vtotvcusto                 = 0;
                this.vtotdesc                   = 0;
                this.lstitensnota               = [];
                this.vcalcularprvendamedio      = false;

                this.voptabela                  = 1;
                this.habdestab                  = false;
                

				if (parseInt(this.opcrud) === 1){
					var deffilial  			= new Option(this.$store.state.filialpadrao.fantasia, this.vidfilial, true, true);
                    $('#cbfilial').append(deffilial).trigger('change');	
                }                

            },
            mtddefault(){
                $('#pnlista').hide();
                $('#pnconferencia').hide();
                this.resetarDados();
                $('#pncadastro').fadeIn(700);
                setTimeout(() => {
                    if (parseInt(this.opcrud) === 1) {
                        $('#edidfornecedor').focus();
                    }else if (parseInt(this.opcrud) === 2){
                        $('#edidfornecedor').focus();
                    } else {
                        $('#btgravar').focus();
                    }                
                }, 500); 
            },
            mtdpreparacrud(op) {
                let vself    = this;
                vself.opcrud = op;
                $('.nav-tabs a[href="#dvitens"]').tab('show');
                vself.mtddefault();
            },
            mtdnovo(){
                if (!util.opcaousuario('010Z.010Z.010Z', this.$store.state.perfilusuario)){
                    this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                }else {
                    this.itensbc.item2.titulo = 'INCLUSÃO DE NOTA DE FORNECEDOR';
                    this.itensbc.item1.ativo = true;
                    this.itensbc.item2.ativo = true;
                    this.ativadesativa = false;
                    this.mtdpreparacrud(1);
                }
            },
            mtdcancelaredicao(){
                this.itensbc.item1.ativo = false;
                this.itensbc.item2.ativo = false;
                $('#pncadastro').hide();
                $('#pnconferencia').hide();
                $('#pnlista').fadeIn(700);
                $('#edconteudopesq').focus();
                setTimeout(function(){
                    util.toTop();
                }, 200);
            },
            mtdlimpar_listagem() {
                this.lstnotas = [];
                this.pagina_atual = 1;
                this.filtro = '';
                this.pqtd_total_registros = 0;
                this.pqtd_paginas = 0;
            },
            mtdgravar(){
                let vself = this;
                if (parseInt(vself.opcrud) < 3) {
                    if (parseInt(vself.vtodasfiliais) === 0) {
                    }
                }
                $.confirm({
                    title: 'Confirmação!',
                    content: 'Confirma ' + vself.itensbc.item2.titulo + '?',
                    icon: 'fa fa-question-circle',
                    escapeKey: true,
                    backgroundDismiss: false,
                    escapeKey: 'nao',
                    type: 'dark',
                    typeAnimated: true,
                    buttons: {
                        sim: {
                            text: '<u>S</u>im',
                            keys: ['s', 'S'],
                            btnClass: 'btn-blue',
                            action: function () {
                                $('.btn-blue').prop('disabled', true);
                                vself.mtdregistro();
                            },
                        },
                        nao: {
                            text: '<u>N</u>ão',
                            keys: ['n', 'N'],
                            action: function () {
                                $('#btgravar').focus();
                            }
                        }
                    }
                });
            },
            mtdlocalizaregistro(item){
                var vself       = this;
                let loader      = vself.$loading.show();
                let filtro      = ' AND n.idfornecedor='+item.idfornecedor+' AND n.idfilial='+item.idfilial+' AND n.numero='+item.numero;
                let parametros  = [
                    {parametro: 'op',           valor : 'listagem'},
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'filtro',       valor : filtro},
                    {parametro: 'limit',        valor : 1},
                    {parametro: 'offset',       valor : 0},
                ];
                let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadnotasfornecedores.php');
                retorno.then(function (response) {
                    loader.hide();
                    if (parseInt(response.data.notas[0].situacao) === 1){
                        vself.$toastr.w('Nota já efetivada. Impossível realizar esta operação!', 'Atenção!');
                        vself.mtdcancelaredicao();
                        return;
                    }
                    // if (parseInt(response.data.notas[0].confiniciada) === 1){
                    //     vself.$toastr.w('Conferência já iniciada. Impossível realizar esta operação!', 'Atenção!');
                    //     vself.mtdcancelaredicao();
                    //     return;
                    // }                    
                    if (parseInt(response.data.notas[0].confiniciada) === 1){
                        vself.$toastr.i('Conferência iniciada!', 'Atenção!');
                    }                    
                    vself.mtdigualarcampos(response.data.notas[0]);
                    if (parseInt(vself.opcrud) < 3){
                        $('#eddtemissao').focus();
                    }else{
                        $('#btgravar').focus();
                    }
                }).catch(function (response) {
                    loader.hide();
                });
            },            
            mtdalterar(item){
                if (!util.opcaousuario('010Z.010Z.015Z', this.$store.state.perfilusuario)){
                    this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                }else {
                    this.itensbc.item2.titulo = 'ALTERAÇÃO DE NOTA DE FORNECEDOR';
                    this.itensbc.item1.ativo = true;
                    this.itensbc.item2.ativo = true;
                    this.ativadesativa = false;
                    this.mtdpreparacrud(2);
                    this.mtdlocalizaregistro(item);
                }
            },
            mtdconferencia(item){
                if (!util.opcaousuario('010Z.010Z.028Z', this.$store.state.perfilusuario)){
                   this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                }else {
                    this.itensbc.item2.titulo = 'CONFERÊNCIA';
                    this.itensbc.item1.ativo = true;
                    this.itensbc.item2.ativo = true;
                    this.vicodpro = null;
                    this.videscpro = '';                    
                    this.vqtdfalta = '0';
                    this.vmultiplicador = 1;
                    this.vfinalizado = false;
                    this.vachouPro = false;
                    this.vmsgPro = '';
                    $('#pnlista').hide();
                    $('#pncadastro').hide();
                    $('#pnconferencia').fadeIn(700);                    
                    this.mtdlocalizaritensconf(item);
                }
            },
            mtdlocalizaritensconf(item){
                var vself           = this
                let loader          = this.$loading.show()

                vself.cfidfornecedor = item.idfornecedor
                vself.cfidfilial     = item.idfilial
                vself.cfnumeronf     = item.numero

                let parametros      = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor  : 'listagemconf'},
                    {parametro: 'idfornecedor', valor  : item.idfornecedor},
                    {parametro: 'idfilial',     valor  : item.idfilial},
                    {parametro: 'numero',       valor  : item.numero}
                ]
                let retorno              = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadnotasfornecedores.php')
                retorno.then(function (response) {
                    vself.lstitensnotas      = response.data.itens
                    vself.lstcodigos         = response.data.codigos

                    if(vself.lstitensnotas.length > 0){
                        vself.ativadesativa    = true
                        vself.ativadesativacod = false
                        loader.hide()

                        vself.$nextTick(function () {
                            $("#edvicodpro").focus()
                        })
                    }else{
                        this.$toastr.w('Nenhum registro encontrado!', 'Warning!')             
                    }
                }).catch(function (response) {
                    vself.lstitensnotas    = []
                    vself.lstcodigos       = []
                    loader.hide()
                    vself.ativadesativa    = false
                    vself.ativadesativacod = true
                })                
            },
            mtdativacodpro(){
                setTimeout(() => {
                    this.ativadesativacod = false;                    
                    this.$nextTick(function () {
                        $("#edvicodpro").focus()
                    });                    
                }, 300);                
            },
            submitProd(){
                this.ativadesativacod   = true;
                let cdpro_busca         = null;
                cdpro_busca             = this.vicodpro;
                if (cdpro_busca === null || cdpro_busca === undefined || cdpro_busca === '') {
                    this.limpaCamposPro(this.mtdativacodpro);
                    // this.$nextTick(function () {
                    //     $("#edvicodpro").focus()
                    // });
                    return;
                }else {
                    this.igualaDadosProduto(cdpro_busca)
                }				
            },
            limpaCamposPro(callback) {
                this.ativadesativacod = false;
                this.videscpro        = '';
                this.vqtdfalta        = 0;
                this.vmultiplicador   = 1;
                
                // this.$nextTick(function () {
                //     $("#edvicodpro").focus()
                // });        
                callback();
            },
            mtddefinemultiplicador(){
                this.vmultiplicadoredicao = this.vmultiplicador;
                $('#mddefinemultiplicador').modal('show');
            },
            mtdconfirmamultiplicador(){
                if (parseFloat(this.vmultiplicadoredicao) <= 0){
                    vself.$toastr.w('Fator multiplicador inválido!', 'Atenção!');
                    $('#edmultiplicadoredicao').focus();
                    return;
                }
                this.vmultiplicador = this.vmultiplicadoredicao;
                $('#mddefinemultiplicador').modal('hide');
                setTimeout(function(){
                    $('#edvicodpro').focus();
                }, 300);                                
            },
            igualaDadosProduto(codPro){

                //this.limpaCamposPro()
                this.videscpro        = '';
                this.vqtdfalta        = 0;

                if (codPro != null) {
                    let indxCod        = util.getArrayIndexForKey(this.lstcodigos, 'codigo', codPro)
                    let codPesq        = codPro

                    if(indxCod > 0){
                        codPesq        = this.lstcodigos[indxCod].idproduto
                    }
                    
                    if (util.findValInArray(this.lstitensnotas, 'idproduto', codPesq)) {

                        this.vmsgPro   = ''

                        let indxPro    = util.getArrayIndexForKey(this.lstitensnotas, 'idproduto', codPesq)
                        this.videscpro = this.lstitensnotas[indxPro].descricao
                        this.vqtdfalta = this.lstitensnotas[indxPro].qtdfalta

                        if (parseInt(this.lstitensnotas[indxPro].fracionado) === 0){
                            if (!Number.isInteger(parseFloat(this.vmultiplicador))){
                                this.$toastr.w('Multiplicador não pode ser FRACIONADO!', 'Atenção!');
                                this.vicodpro         = '';
                                this.ativadesativacod = false;
                                $('#edvicodpro').focus();
                                return;
                            }
                        }                        
                        if (parseFloat(this.vmultiplicador) > this.lstitensnotas[indxPro].qtdfalta){
                            this.$toastr.w('Multiplicador não pode ser maior que a quantidade que falta do item!', 'Atenção!');
                            this.vicodpro         = '';
                            this.ativadesativacod = false;
                            $('#edvicodpro').focus();
                            return;                            
                        }
                        if(this.lstitensnotas[indxPro].qtdconf === this.lstitensnotas[indxPro].qtditem) {
                            if(((this.lstitensnotas[indxPro].qtdconf === this.lstitensnotas[indxPro].qtditem) && 
                                (this.lstitensnotas[indxPro].qtdfalta < 0)) || 
                                ((this.lstitensnotas[indxPro].qtdconf === this.lstitensnotas[indxPro].qtditem) && 
                                (this.lstitensnotas[indxPro].qtdfalta <= this.lstitensnotas[indxPro].qtditem))) {

                                //Zerar o qtdfalta   
                                this.lstitensnotas[indxPro].qtdfalta = 0
                            }

                            this.lstitensnotas[indxPro].situacao   = 1
                            this.mtItemConcluidoConf(codPesq)                            
                        }else{
                            //nao tinha essa variável
                            let qtdconta = parseFloat(this.vmultiplicador);//this.lstitensnotas[indxPro].qtdconf;

                            this.lstitensnotas[indxPro].qtdconf    = parseFloat(this.lstitensnotas[indxPro].qtdconf) + qtdconta;
                            this.lstitensnotas[indxPro].qtdfalta   = this.lstitensnotas[indxPro].qtditem - this.lstitensnotas[indxPro].qtdconf;

                            // this.lstitensnotas[indxPro].qtdconf    = ++this.lstitensnotas[indxPro].qtdconf;
                            // this.lstitensnotas[indxPro].qtdfalta   = --this.vqtdfalta;                            

                            if(((parseFloat(this.lstitensnotas[indxPro].qtdconf).toFixed(2) === parseFloat(this.lstitensnotas[indxPro].qtditem).toFixed(2)) && 
                                (parseFloat(this.lstitensnotas[indxPro].qtdfalta) < 0)) || 
                                ((parseFloat(this.lstitensnotas[indxPro].qtdconf).toFixed(2) === parseFloat(this.lstitensnotas[indxPro].qtditem).toFixed(2)) && 
                                (parseFloat(this.lstitensnotas[indxPro].qtdfalta).toFixed(2) <= parseFloat(this.lstitensnotas[indxPro].qtditem).toFixed(2)))) {

                                //Zerar o qtdfalta   
                                this.lstitensnotas[indxPro].qtdfalta = 0
                                this.lstitensnotas[indxPro].situacao = 1

                                this.mtItemConcluidoConf(codPesq)
                            }else{
                                this.play({ id: 'faltando' })
                                this.vachouPro = true
                                this.vmsgPro = 'PRODUTO ( ' + this.vicodpro + ' ) CONFERIDO | FALTA ' + this.lstitensnotas[indxPro].qtdfalta;//this.vqtdfalta                
                            }

                            this.vicodpro = '';
                            // this.$nextTick(function () {
                            //     $("#edvicodpro").focus()                            
                            // })
                            setTimeout(() => {
                                this.limpaCamposPro(this.mtdativacodpro);
                            }, 500);                                      
                        }        
                    }else{
                        this.$toastr.w('Produto não encontrado na lista!', 'Warning!');
                        this.play({ id: 'alerta' });
                        this.vachouPro = false;
                        this.vmsgPro   = 'PRODUTO ( ' + this.vicodpro + ' ) NÃO ENCONTRADO NA LISTA';
                        this.vicodpro  = null;
                        setTimeout(() => {
                            this.limpaCamposPro(this.mtdativacodpro);
                        }, 500);                                  
                        //this.limpaCamposPro(this.mtdativacodpro); 
                    }          
                }
            },
            mtItemConcluidoConf(CodProd){
                this.$toastr.w('Quantidade do produto ' + CodProd + ' atingida!', 'Warning!');
                this.play({ id: 'concluido' });
                this.vachouPro = false;
                this.vicodpro  = null;
                this.videscpro = '';
                this.vqtdfalta = '0';
                this.limpaCamposPro(this.mtdativacodpro);
            },
            mtdgravarconf(){
                let vself          = this;
                let falta_conferir = true;

                for (var i = 0; i < vself.lstitensnotas.length; i++) {									
                    if(vself.lstitensnotas[i]['qtdfalta'] > 0){
                        falta_conferir = false
                        break
                    }				
                }

                if(!falta_conferir){
                    $.confirm({
                        title: 'Confirmação!',
                        content: 'Tem certeza que deseja gravar com pedência de itens conferidos?',
                        icon: 'fa fa-question-circle',
                        escapeKey: true,
                        backgroundDismiss: false,
                        escapeKey: 'nao',
                        type: 'dark',
                        typeAnimated: true,
                        buttons: {
                        sim: {
                            text: '<u>S</u>im',
                            keys: ['s', 'S'],
                            btnClass: 'btn-blue',
                            action: function () {        
                            //Grava com pendencia
                            vself.mtatribuiConfItens()
                            },
                        },
                        nao: {
                            text: '<u>N</u>ão',
                            keys: ['n', 'N'],
                            action: function () {
                            $('#edvicodpro').focus()
                            }
                        }
                        }
                    });
                }else{
                    $.confirm({
                        title: 'Confirmação!',
                        content: 'Confirma finalização da conferência?',
                        icon: 'fa fa-question-circle',
                        escapeKey: true,
                        backgroundDismiss: false,
                        escapeKey: 'nao',
                        type: 'dark',
                        typeAnimated: true,
                        buttons: {
                        sim: {
                            text: '<u>S</u>im',
                            keys: ['s', 'S'],
                            btnClass: 'btn-blue',
                            action: function () {        
                            //Finaliza conferência
                            vself.mtatribuiConfItens()
                            },
                        },
                        nao: {
                            text: '<u>N</u>ão',
                            keys: ['n', 'N'],
                            action: function () {
                            $('#edvicodpro').focus()
                            }
                        }
                        }
                    });
                }
            },
            mtatribuiConfItens(){
                let vself        = this
                let loader       = vself.$loading.show()
                let registroconf = {
                    'idfornecedor'  : vself.cfidfornecedor,
                    'idfilialnf'    : vself.cfidfilial,
                    'numero'        : vself.cfnumeronf,
                    'itensconf'     : vself.lstitensnotas
                };
                let parametros      = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor : 'gravarconferencia'},
                    {parametro: 'registro',     valor : JSON.stringify(registroconf)},
                    {parametro: 'idfilial',     valor : vself.$store.state.filialpadrao.codfil},
                    {parametro: 'idusuario',    valor : vself.$store.state.usuario.id},
                    {parametro: 'codop',        valor : '010Z.010Z.028Z'},                    
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadnotasfornecedores.php')
                retorno.then(function (response) {
                    loader.hide();
                    if ($.isNumeric(response.data)){
                        vself.$toastr.s('Registro processado com sucesso!', 'Informação!')
                        vself.lstitensnotas    = []
                        vself.lstcodigos       = []
                        //vself.limpaCamposPro()
                        vself.ativadesativa    = false
                        vself.ativadesativacod = true
                        vself.vfinalizado      = false
                        vself.vachouPro        = false
                        vself.vmsgPro          = ''

                        vself.pnumero          = vself.cfnumeronf
                        vself.pfiltroperiodo   = 0
                        vself.pefetivadas      = 2

                        vself.pqtd_paginas     = 1
                        vself.mtdcancelaredicao()
                        vself.mtdcarreganotas(1);
                    }else{
                        let tpret = response.data.substring(0,1)
                        switch (tpret) {
                            case 'I':
                                vself.$toastr.w(response.data.substring(4), 'Atenção!')
                                break
                            case 'E': default:
                                vself.$toastr.e(response.data.substring(4), 'Erro!')
                                break
                        }
                    }
                }).catch(function (response) {
                    loader.hide()
                    vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!')
                });
            },
            mtdcancelarconf(){
                let vself = this

                $.confirm({
                    title: 'Confirmação!',
                    content: 'Tem certeza que deseja cancelar a conferência?',
                    icon: 'fa fa-question-circle',
                    escapeKey: true,
                    backgroundDismiss: false,
                    escapeKey: 'nao',
                    type: 'dark',
                    typeAnimated: true,
                    buttons: {
                        sim: {
                            text: '<u>S</u>im',
                            keys: ['s', 'S'],
                            btnClass: 'btn-blue',
                            action: function () {        
                                vself.ativadesativa = false
                                vself.ativadesativacod = true
                                //vself.limpaCamposPro()
                                vself.lstitensnotas = []
                                vself.lstcodigos = []
                                vself.itensbc.item1.ativo = false
                                vself.itensbc.item2.ativo = false
                                vself.vfinalizado         = false
                                vself.vachouPro           = false
                                vself.vmsgPro             = ''

                                $('#pnconferencia').hide()
                                $('#pncadastro').hide()
                                $('#pnlista').fadeIn(700)                                 
                            },
                        },
                        nao: {
                            text: '<u>N</u>ão',
                            keys: ['n', 'N'],
                            action: function () {
                                $('#edvicodpro').focus()
                            }
                        }
                    }
                });        
            },                        
            mtdexcluir(item){
                if (!util.opcaousuario('010Z.010Z.020Z', this.$store.state.perfilusuario)){
                    this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                }else {
                    this.itensbc.item2.titulo = 'EXCLUSÃO DE NOTA DE FORNECEDOR';
                    this.itensbc.item1.ativo = true;
                    this.itensbc.item2.ativo = true;
                    this.ativadesativa = true;
                    this.mtdpreparacrud(3);
                    this.mtdlocalizaregistro(item);
                }
            },
            mtdigualarcampos(registro){
                this.vidfornecedor              = registro.idfornecedor;
                this.vnomefornecedor            = registro.nomefornecedor;
                this.vidfilial                  = registro.idfilial;
                this.vnumero                    = registro.numero;
                this.vtipo                      = registro.tipo;
                this.vtipofrete                 = registro.tipofrete;
                this.vxml                       = registro.xml,
                this.vobservacoes               = registro.observacoes;
                this.vtotvicms                  = registro.vtotvicms;
                this.vtotvipi                   = registro.vtotvipi;
                this.vtotvfrete                 = registro.vtotvfrete;
                this.vtotvoutros                = registro.vtotvoutros;
                this.vtotst                     = registro.vst;
                this.vtotvpis                   = registro.vtotvpis;
                this.vtotvcofins                = registro.vtotvcofins;
                this.vtotvtotal                 = registro.vtotvtotal;
                this.vtotvcusto                 = registro.vtotvcusto;
                this.vtotdesc                   = registro.vtotdesc;
                this.vtotbcst                   = registro.vbcst;
                this.vtotst                     = registro.vst;
                this.lstitensnota               = registro.itens;
                this.iditem                     = this.lstitensnota[this.lstitensnota.length - 1].item;
                var deffilial  			= new Option(registro.fantasiafilial, this.vidfilial, true, true);
                $('#cbfilial').append(deffilial).trigger('change');
                
                setTimeout(() => {
                    if (parseInt(this.vtipo) === 0){
                        this.vmodelo                    = registro.modelo;
                        this.vserie                     = registro.serie;
                        this.vnaturezaoperacao          = registro.naturezaoperacao;
                        this.vchaveacesso               = registro.chaveacesso;                    
                    }
                }, 300);
            },
            mtdregistro(){
                let vself  = this;
                let loader = vself.$loading.show();
                let registrocrud = {
                    'idfornecedor'      : vself.vidfornecedor,
                    'idfilial'          : vself.vidfilial,
                    'numero'            : vself.vnumero,
                    'tipofrete'         : vself.vtipofrete,
                    'dtemissao'         : vself.vdtemissao,
                    'dtentrada'         : vself.vdtentrada,
                    'tipo'              : vself.vtipo,
                    'modelo'            : vself.vmodelo,
                    'serie'             : vself.vserie,
                    'naturezaoperacao'  : vself.vnaturezaoperacao,
                    'chaveacesso'       : vself.vchaveacesso,
                    'xml'               : vself.vxml,
                    'observacoes'       : vself.vobservacoes,
                    'vtotvicms'         : vself.vtotvicms,
                    'vtotvipi'          : vself.vtotvipi,
                    'vtotvfrete'        : vself.vtotvfrete,
                    'vtotvoutros'       : vself.vtotvoutros,
                    'vbcst'             : vself.vtotbcst,
                    'vst'               : vself.vtotst,
                    'vtotvpis'          : vself.vtotvpis,
                    'vtotvcofins'       : vself.vtotvcofins,
                    'vtotvtotal'        : vself.vtotvtotal,
                    'vtotvcusto'        : vself.vtotvcusto,
                    'vtotdesc'          : vself.vtotdesc,
                    'itens'             : vself.lstitensnota
                };
                let parametros      = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor : 'rotinacrud'},
                    {parametro: 'opcrud',       valor : vself.opcrud},
                    {parametro: 'registro',     valor : JSON.stringify(registrocrud)},
                    {parametro: 'idfilial',     valor : vself.$store.state.filialpadrao.codfil},
                    {parametro: 'idusuario',    valor : vself.$store.state.usuario.id},
                    {parametro: 'codop',        valor : parseInt(vself.opcrud) === 1 ? '010Z.010Z.010Z' : parseInt(vself.opcrud) === 2 ? '010Z.010Z.015Z' : '010Z.010Z.020Z'},
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadnotasfornecedores.php');
                retorno.then(function (response) {
                    loader.hide();
                    if ($.isNumeric(response.data)){
                        vself.$toastr.s('Registro processado com sucesso!', 'Informação!');
                        vself.pnumero        = vself.vnumero;
                        vself.pfiltroperiodo = 0;
                        vself.pefetivadas    = 2;

                        let deffilial = new Option($('#cbfilial').select2('data')[0]['text'], vself.vidfilial, true, true);
                        $('#cbfilialpesq').append(deffilial).trigger('change');	                        

                        let deffornecedor = new Option(vself.vnomefornecedor, vself.vidfornecedor, true, true);
                        $('#cbfornecedorpesq').append(deffornecedor).trigger('change');	                                                
                        
                        vself.pqtd_paginas  = 1;
                        vself.mtdcancelaredicao();
                        vself.mtdcarreganotas(1);
                    }else{
                        let tpret = response.data.substring(0,1);
                        switch (tpret) {
                            case 'I':
                                vself.$toastr.w(response.data.substring(4), 'Atenção!');
                                break;
                            case 'E': default:
                                vself.$toastr.e(response.data.substring(4), 'Erro!');
                                break;
                        }
                    }
                }).catch(function (response) {
                    loader.hide();
                    vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!');
                });
			},
			mtdlimparedicaoitem(){
				this.vidprodutoedicao    		= '';
				this.vcoddigedicao				= '';
				this.vdescricaoprodutoedicao 	= '';
				this.vundprodutoedicao			= '';
				this.vqtditemedicao				= 1;
				this.vprcompra					= 0;
				this.vvdesconto					= 0;
				this.vpicms						= 0;
				this.vvicms						= 0;
				this.vpipi						= 0;
				this.vvipi						= 0;
				this.vpfrete					= 0;
				this.vvfrete					= 0;
				this.vpoutros					= 0;
				this.vvoutros					= 0;
                this.vpmvast                    = 0;
                this.vvbcst                     = 0;
                this.vpicmsst                   = 0;
                this.vvicmsst                   = 0;
				this.vppis						= 0;
				this.vvpis						= 0;
				this.vpcofins					= 0;
				this.vvcofins					= 0;
				this.vprvendamedio				= 0;
				this.vprcusto					= 0;
                this.vvtotal					= 0;
                this.vvtotalcusto               = 0;
                this.vcalcularprvendamedio      = false; 
                this.vcstitem                   = '';
                this.vcstpiscofins              = '';
                this.vidcfop                    = null
                $("#cbcfopedicao").val(null).trigger('change');


                //tabelas de preços
                this.vidtabelapreco             = null;
                this.lstTabelasPrecos           = [];
                this.vmrgtabela                 = 0;
                this.vvltabela                  = 0;
                this.vvlnf                      = 0;
                this.vcomissaotabela            = 0;
                this.vqtdmintabela              = 0;
                this.vdescontotabela            = 0; 
                $("#cbtabelapreco").val(null).trigger('change');

                //classes
				this.lstClassesProduto	        = [];
                this.vidclasse                  = null;
                this.vidfilialclasse            = null;
                $("#cbclasse").val(null).trigger('change'); 
                $("#cbfilialclasse").val(null).trigger('change');                                  

				//pega o estoque padrão da filial selecionada
				this.videstoqueedicao			= this.$store.state.filialpadrao.idestoque;
                var defestoque  				= new Option(this.$store.state.filialpadrao.descestoque, this.videstoqueedicao, true, true);
				$('#cbestoqueedicao').append(defestoque).trigger('change');
                $('.nav-tabs a[href="#dvcusto"]').tab('show');
			},			
			mtdadcionaritem(){
				this.mtdlimparedicaoitem();
				this.vopitem = 1;
				$('#mdedicaoitem').modal('show');				
            },
            mtdexcuiritem(item){
                let vself = this;
                if (parseInt(vself.opcrud) < 3){  
                    let indiceitem 		= util.getArrayIndexForKey(vself.lstitensnota, 'item', item.item);
                    vself.lstitensnota.splice(indiceitem, 1);                                
                    vself.vtotvicms                  = vself.vtotvicms   - item.vvicms;
                    vself.vtotvipi                   = vself.vtotvipi    - item.vvipi;
                    vself.vtotvfrete                 = vself.vtotvfrete  - item.vvfrete;
                    vself.vtotvoutros                = vself.vtotvoutros - item.vvoutros;
                    vself.vtotbcst                   = vself.vtotbcst    - item.vvbcst;
                    vself.vtotst                     = vself.vtotst      - item.vvicmsst;
                    vself.vtotvpis                   = vself.vtotvpis    - item.vvpis;
                    vself.vtotvcofins                = vself.vtotvcofins - item.vvcofins;
                    vself.vtotvtotal                 = vself.vtotvtotal  - item.vvtotal;
                    vself.vtotvcusto                 = vself.vtotvcusto  - item.vvtotalcusto;
                    vself.vtotdesc                   = vself.vtotdesc    - item.vdesconto;
                }
            },
            mtdmanifesto(){
                this.midfilialmanifesto     = this.$store.state.filialpadrao.codfil;
                var deffilial  			= new Option(this.$store.state.filialpadrao.fantasia, this.midfilialmanifesto, true, true);
                $('#cbfilialmanifesto').append(deffilial).trigger('change');                

                $('#mdmanifesto').modal('show');
            },
            mtdfiltronotasmanifesto(){
                let filtro  = '';
                let vself   = this;
                switch (parseInt(vself.mperiodomanifesto)){
                    case 0:
                        vself.mdtini              = moment().format('01/MM/YYYY');
                        vself.mdtfim              = moment().endOf('month').format('DD/MM/YYYY');                        
                    break;
                    case 1:
                        vself.mdtini              = moment().endOf('month').format('DD/MM/YYYY');
                        vself.mdtfim              = moment().endOf('month').format('DD/MM/YYYY');
                        vself.mdtini = moment(util.InverterData(vself.mdtini)).subtract(2, 'months');
                        vself.mdtini              = moment(vself.mdtini).format('DD/MM/YYYY');
                    break;                    
                    case 2:
                        vself.mdtini              = moment().endOf('month').format('DD/MM/YYYY');
                        vself.mdtfim              = moment().endOf('month').format('DD/MM/YYYY');
                        vself.mdtini = moment(util.InverterData(vself.mdtini)).subtract(3, 'months');
                        vself.mdtini              = moment(vself.mdtini).format('DD/MM/YYYY');
                    break;                    
                }                
                if (parseInt(vself.mperiodomanifesto) < 3){
                    filtro          = ' and dhemi between "' + util.InverterData(this.mdtini) + ' 00:00:00" and "' + util.InverterData(this.mdtfim) + ' 23:59:59"';
                }
                return filtro;
            },
            mtdlistarnotasmanifesto(){   
                let vself           = this;
                if (vself.midfilialmanifesto === null){
                    vself.$toastr.w('Filial deve ser informada', 'Informação!');
                    $('#cbfilialmanifesto').focus();
                    return;
                }                                             
                let loader          = vself.$loading.show();
                let parametros      = [
                    {parametro: 'idclientesac',         valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',                   valor : 'listarnotasmanifesto'},
                    {parametro: 'filtro',               valor : vself.mtdfiltronotasmanifesto()},
                    {parametro: 'idfilial',             valor : vself.midfilialmanifesto}
                ];                    
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadnotasfornecedores.php');
                retorno.then(function (response) {
                    loader.hide();                                        
                    vself.lstnotasmanifesto = response.data;
                }).catch(function (response) {
                    loader.hide();
                    vself.$toastr.e('Erro ao carregar notas do manifesto. Descrição do erro: '+response.message, 'Erro!');
                });                 
            },
            mtdconsultardocumentos(){
                let vself = this;
                if (vself.midfilialmanifesto === null){
                    vself.$toastr.w('Filial deve ser informada', 'Informação!');
                    $('#cbfilialmanifesto').focus();
                    return;
                }                 
                let loader  = vself.$loading.show();
				vself.statusaxios		= 'Solicitando documentos ao servidor da SEFAZ! Aguarde...';
                $('#mdstatusaxios').modal('show');    
                $("#mdstatusaxios").css("z-index", "9999");            
                let parametros      = [
                    {parametro: 'idclientesac',         valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',                   valor : 'consultardocumentossefaz'},
                    {parametro: 'filtro',               valor : vself.mtdfiltronotasmanifesto()},
                    {parametro: 'idfilial',             valor : vself.midfilialmanifesto},
                    {parametro: 'idclientesac',         valor : vself.$store.state.filialpadrao.idcliente}
                ];                    
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadnotasfornecedores.php');
                retorno.then(function (response) {
                    loader.hide();                                        
                    $('#mdstatusaxios').modal('hide');
                    vself.lstnotasmanifesto = response.data;
                }).catch(function (response) {
                    loader.hide();
                    $('#mdstatusaxios').modal('hide');
                    vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!');
                }); 
            },
            mtdchamartelamanifestacao(nota){
                this.mtpevento      = '210200';
                this.mxjust         = '';
                this.notamanifestar = nota;
                $("#mdmanifestarnfe").css("z-index", "9998");  
                $('#mdmanifestarnfe').modal('show');
            },
            mtdconfirmamanifesto(){
                let vself = this;
                if ((vself.mtpevento === '210220' || vself.mtpevento === '210240') && vself.mxjust === ''){
                    vself.$toastr.w('Motivo deve ser informado', 'Informação!');
                    $('#txtxjust').focus();
                    return;
                }
                $.confirm({
                    title: 'Confirmação!',
                    content: 'Confirma manifestação da NF?',
                    icon: 'fa fa-question-circle',
                    escapeKey: true,
                    backgroundDismiss: false,
                    escapeKey: 'nao',
                    type: 'dark',
                    typeAnimated: true,
                    buttons: {
                        sim: {
                            text: '<u>S</u>im',
                            keys: ['s', 'S'],
                            btnClass: 'btn-blue',
                            action: function () {
                                $('#mdmanifestarnfe').modal('hide');
                                $('.btn-blue').prop('disabled', true);
                                let loader  = vself.$loading.show();
                                let parametros      = [
                                    {parametro: 'idclientesac',         valor  : vself.$store.state.filialpadrao.idcliente},
                                    {parametro: 'op',                   valor : 'manifestarnf'},
                                    {parametro: 'filtro',               valor : vself.mtdfiltronotasmanifesto()},
                                    {parametro: 'idfilial',             valor : vself.midfilialmanifesto},
                                    {parametro: 'idclientesac',         valor : vself.$store.state.filialpadrao.idcliente},
                                    {parametro: 'chnfe',                valor : vself.notamanifestar.chnfe},
                                    {parametro: 'tpevento',             valor : vself.mtpevento},
                                    {parametro: 'xjust',                valor : vself.mxjust},
                                ];                    
                                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadnotasfornecedores.php');
                                retorno.then(function (response) {
                                    loader.hide();
                                    let tpret = response.data.inf.substring(0,1);
                                    switch (tpret) {
                                        case 'I':
                                            vself.$toastr.s(response.data.inf.substring(4), 'Informação!');
                                            break;
                                        case 'E': default:
                                            vself.$toastr.e(response.data.inf.substring(4), 'Erro!');
                                            break;
                                    }                                    
                                    vself.lstnotasmanifesto = response.data.notas;
                                }).catch(function (response) {
                                    loader.hide();
                                    vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!');
                                });
                            },
                        },
                        nao: {
                            text: '<u>N</u>ão',
                            keys: ['n', 'N'],
                            action: function () {
                                
                            }
                        }
                    }
                });                
            },
            mtddownloadxml(nota){
                if (nota.xml !== ''){
                    util.download(nota.xml, nota.chnfe+'-procNFe.xml');
                }else{
                    let vself   = this;
                    let loader  = vself.$loading.show();
                    let parametros      = [
                        {parametro: 'idclientesac',         valor  : vself.$store.state.filialpadrao.idcliente},
                        {parametro: 'op',                   valor : 'downloadnf'},
                        {parametro: 'idfilial',             valor : vself.midfilialmanifesto},
                        {parametro: 'idclientesac',         valor : vself.$store.state.filialpadrao.idcliente},
                        {parametro: 'filtro',               valor : vself.mtdfiltronotasmanifesto()},
                        {parametro: 'chnfe',                valor : nota.chnfe}
                    ];                    
                    let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadnotasfornecedores.php');
                    retorno.then(function (response) {
                        loader.hide();
                        let tpret = response.data.inf.substring(0,1);
                        if (tpret === 'E'){
                            vself.$toastr.e(response.data.substring(4), 'Erro!');
                        }else{
                            let vconteudoarquivo    = response.data.inf;
                            vself.lstnotasmanifesto = response.data.notas;
                            util.download(vconteudoarquivo, nota.chnfe+'-procNFe.xml');                
                        }                     
                    }).catch(function (response) {
                        loader.hide();
                        console.log(response.message);
                        vself.$toastr.w('Impossível comunicar com o servidor da SEFAZ no momento. Tente novamente mais tarde!', 'Atenção!');
                    });   
                }                             
            },
            mtdimprimirdanfe(nota){
				window.open(this.$store.state.configpaths.pathcontrole+'rtimprimirdocnfe.php?idclientesac='+
							this.$store.state.filialpadrao.idcliente+
							'&idf='+nota.idfilial+'&chnfe='+nota.chnfe, '_blank');                
            },
            mtdentradapeloxml(chnfe, arquivoxml){
                let vself            = this;
                vself.pvinculartodos = true;
                let loader           = vself.$loading.show();
                if (arquivoxml === ''){
                    var parametros      = [
                        {parametro: 'idclientesac',         valor  : vself.$store.state.filialpadrao.idcliente},
                        {parametro: 'op',                   valor : 'carregardadosxmlentrada'},
                        {parametro: 'idfilial',             valor : vself.midfilialmanifesto},
                        {parametro: 'chnfe',                valor : chnfe}
                    ];    
                }else{
                    var parametros      = [
                        {parametro: 'idclientesac',         valor  : vself.$store.state.filialpadrao.idcliente},
                        {parametro: 'op',                   valor : 'carregardadosxmlentrada'},
                        {parametro: 'idfilial',             valor : vself.midfilialmanifesto},
                        {parametro: 'chnfe',                valor : ''},
                        {parametro: 'arquivoxml',           valor : arquivoxml}
                    ];                        
                }
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadnotasfornecedores.php');
                retorno.then(function (response) {
                    loader.hide();
                    if ($.isNumeric(response.data.inf)){                        
                        $('#mdmanifesto').modal('hide');

                        vself.midestoquemanifesto    	= vself.$store.state.filialpadrao.idestoque;
                        var defestoque  				= new Option(vself.$store.state.filialpadrao.descestoque, vself.midestoquemanifesto, true, true);
                        $('#cbestoquemanifesto').append(defestoque).trigger('change');
                                        
                        vself.pnotaentrada = response.data.nota;                        
                        $('#mdprevisualizacaonf').modal('show');
                        $('#ipselecionararquivo').val('');
                    }else{
                        let tpret = response.data.inf.substring(0,1);
                        if (tpret === 'E'){
                            vself.$toastr.e(response.data.substring(4), 'Erro!');
                        }else{
                            vself.$toastr.i(response.data.substring(4), 'Informação!');
                        }
                    }                
                }).catch(function (response) {
                    loader.hide();
                    vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!');
                });                
            },
            mtdadicionarvinculo(produto){
                //console.log(this.pitemvincular);
                let vself   = this;
                let loader  = vself.$loading.show();
                let parametros      = [
                    {parametro: 'idclientesac',         valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',                   valor : 'adicionarvinculo'},
                    {parametro: 'idproduto',            valor : produto.id},
                    {parametro: 'idfornecedor',         valor : vself.pnotaentrada.idfornecedor},
                    {parametro: 'codigo',               valor : vself.pitemvincular.cprod}
                ];                    
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadnotasfornecedores.php');
                retorno.then(function (response) {
                    loader.hide();
                    if (parseInt(response.data.st) === 1){
                        if (vself.pvinculartodos){
                            for (let x = 0; x < vself.pnotaentrada.itens.length; x++) {
                                if (vself.pitemvincular.cprod === vself.pnotaentrada.itens[x].cprod){
                                    vself.pnotaentrada.itens[x]['idproduto']        = produto.id;
                                    vself.pnotaentrada.itens[x]['descricaoproduto'] = produto.descricao;
                                    vself.pnotaentrada.itens[x]['und']              = produto.und;
                                    vself.pnotaentrada.itens[x]['fracionado']       = produto.fracionado;
                                    vself.pnotaentrada.itens[x]['fator']            = 1;
                                    vself.pnotaentrada.itens[x]['dadoscadastro']    = 1;                                                        
                                    vself.pnotaentrada.itens[x]['tabelas']          = produto.tabelas;
                                }
                            }
                        }else{
                            let i = util.getArrayIndexForKey(vself.pnotaentrada.itens, 'item', vself.pitemvincular.item);
                            vself.pnotaentrada.itens[i]['idproduto']        = produto.id;
                            vself.pnotaentrada.itens[i]['descricaoproduto'] = produto.descricao;
                            vself.pnotaentrada.itens[i]['und']              = produto.und;
                            vself.pnotaentrada.itens[i]['fracionado']       = produto.fracionado;
                            vself.pnotaentrada.itens[i]['fator']            = 1;
                            vself.pnotaentrada.itens[i]['dadoscadastro']    = 1;
                        }
                    }else{
                        vself.$toastr.e(response.data.inf.substring(4), 'Erro!');
                    }                    
                }).catch(function (response) {
                    loader.hide();
                    vself.$toastr.e('Erro ao tentar remover o vínculo. Descrição do erro: '+response.message, 'Erro!');
                });                
            },
            mtdremovervinculo(item){
                let vself   = this;
                let loader  = vself.$loading.show();
                let parametros      = [
                    {parametro: 'idclientesac',         valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',                   valor : 'removervinculo'},
                    {parametro: 'idproduto',            valor : item.idproduto},
                    {parametro: 'idfornecedor',         valor : vself.pnotaentrada.idfornecedor},
                    {parametro: 'codigo',               valor : item.cprod},
                ];                    
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadnotasfornecedores.php');
                retorno.then(function (response) {
                    loader.hide();
                    if (parseInt(response.data.st) === 1){
                        //let i = util.getArrayIndexForKey(vself.pnotaentrada.itens, 'item', item.item);
                        if (vself.pvinculartodos){
                            for (let x = 0; x < vself.pnotaentrada.itens.length; x++) {
                                if (item.cprod === vself.pnotaentrada.itens[x].cprod){                        
                                    vself.pnotaentrada.itens[x]['idproduto']        = 0;
                                    vself.pnotaentrada.itens[x]['descricaoproduto'] = "";
                                    vself.pnotaentrada.itens[x]['und']              = "";
                                    vself.pnotaentrada.itens[x]['fracionado']       = 0;
                                    vself.pnotaentrada.itens[x]['fator']            = 1;
                                    vself.pnotaentrada.itens[x]['dadoscadastro']    = 0;                     
                                }
                            }   
                        }else{
                            let i = util.getArrayIndexForKey(vself.pnotaentrada.itens, 'item', item.item);
                            vself.pnotaentrada.itens[i]['idproduto']        = 0;
                            vself.pnotaentrada.itens[i]['descricaoproduto'] = "";
                            vself.pnotaentrada.itens[i]['und']              = "";
                            vself.pnotaentrada.itens[i]['fracionado']       = 0;
                            vself.pnotaentrada.itens[i]['fator']            = 1;
                            vself.pnotaentrada.itens[i]['dadoscadastro']    = 0;
                        }
                    }else{
                        vself.$toastr.e(response.data.inf.substring(4), 'Erro!');
                    }                    
                }).catch(function (response) {
                    loader.hide();
                    vself.$toastr.e('Erro ao tentar remover o vínculo. Descrição do erro: '+response.message, 'Erro!');
                });
            },
            mtdtelaedicaofator(item){
                this.pfator         = item.fator;
                this.pitemfator     = item;
                $('#mdalteracaofator').modal('show');
            },
            mtdalterarfator(){                
                let vself   = this;
                if (parseFloat(vself.pfator) <= 0 || vself.pfator === ''){
                    vself.$toastr.w('Fator inválido!', 'Atenção!');
                    $('#edfatoralteracao').focus();
                    return;
                }                
                let loader  = vself.$loading.show();
                let parametros      = [
                    {parametro: 'idclientesac',         valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',                   valor : 'alterarfator'},
                    {parametro: 'idproduto',            valor : vself.pitemfator.idproduto},
                    {parametro: 'idfornecedor',         valor : vself.pnotaentrada.idfornecedor},
                    {parametro: 'codigo',               valor : vself.pitemfator.cprod},
                    {parametro: 'fator',                valor : vself.pfator}
                ];                    
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadnotasfornecedores.php');
                retorno.then(function (response) {
                    loader.hide();
                    if (parseInt(response.data.st) === 1){
                        let i = util.getArrayIndexForKey(vself.pnotaentrada.itens, 'item', vself.pitemfator.item);
                        vself.pnotaentrada.itens[i]['fator']            = vself.pfator;
                    }else{
                        vself.$toastr.e(response.data.inf.substring(4), 'Erro!');
                    }                    
                    $('#mdalteracaofator').modal('hide');
                }).catch(function (response) {
                    loader.hide();
                    vself.$toastr.e('Erro ao tentar alterar fator do ítem. Descrição do erro: '+response.message, 'Erro!');
                    $('#mdalteracaofator').modal('hide');
                });
            },
            mtdtelaedicaoitem(item){                
                let vself                       = this;
                vself.aitemedicao_item          = item.item;
                vself.aitemedicao_cprod         = item.cprod;
                vself.aitemedicao_cean          = item.cean;
                vself.aitemedicao_xprod         = item.xprod;
                vself.aitemedicao_ucom          = item.ucom;
                vself.aitemedicao_idmarca       = item.idmarca;
                vself.aitemedicao_idgrupo       = item.idgrupo;
                vself.aitemedicao_idsubgrupo    = item.idsubgrupo;
                if (parseInt(item.dadoscadastro) === 0){
                    $('#cbunidadeedicao').val(null).trigger('change');
                    $('#cbmarcaedicao').val(null).trigger('change');
                    $('#cbgrupoedicao').val(null).trigger('change');
                    $('#cbsubgrupoedicao').val(null).trigger('change');                    
                }else{
                    var defunidade  = new Option(item.descund, item.ucom, true, true);
                    $('#cbunidadeedicao').append(defunidade).trigger('change');

                    var defmarca    = new Option(item.descmarca, item.idmarca, true, true);
                    $('#cbmarcaedicao').append(defmarca).trigger('change');

                    var defgrupo    = new Option(item.descgrupo, item.idgrupo, true, true);
                    $('#cbgrupoedicao').append(defgrupo).trigger('change');

                    var defsubgrupo = new Option(item.descsubgrupo, item.idsubgrupo, true, true);
                    $('#cbsubgrupoedicao').append(defsubgrupo).trigger('change');                    
                }
                $('#mdalteracaodadositem').modal('show');
            },
            mtdalteraritemnota(item){
                let vself = this;
                vself.vidcfop                   = item.cfop
                vself.vopitem                   = 2;
                vself.vcstitem                  = item.cstitem
                vself.vcstpiscofins             = item.cstpiscofins
                vself.iditemalt                 = item.item;
                vself.vidprodutoedicao          = item.idproduto;
                vself.vcoddigedicao             = item.coddig;
                vself.vdescricaoprodutoedicao   = item.descricao;
                vself.vundprodutoedicao         = item.und;
                vself.vfracionadoedicao         = item.fracionado;
                vself.vreferencia               = item.referencia;
                vself.vqtditemedicao            = parseFloat(item.qtditem);
                vself.vprcompra                 = parseFloat(item.prcompra);
                vself.vvdesconto                = parseFloat(item.vdesconto);
                vself.videstoqueedicao          = parseFloat(item.idestoque);
                vself.vpicms                    = parseFloat(item.vpicms);
                vself.vvicms                    = parseFloat(item.vvicms);
                vself.vpipi                     = parseFloat(item.vpipi);
                vself.vvipi                     = parseFloat(item.vvipi);
                vself.vpfrete                   = parseFloat(item.vpfrete);
                vself.vvfrete                   = parseFloat(item.vvfrete);
                vself.vpoutros                  = parseFloat(item.vpoutros);
                vself.vvoutros                  = parseFloat(item.vvoutros);
                vself.vpmvast                   = parseFloat(item.vpmvast);
                vself.vvbcst                    = parseFloat(item.vvbcst);
                vself.vpicmsst                  = parseFloat(item.vpicmsst);
                vself.vvicmsst                  = parseFloat(item.vvicmsst);
                vself.vppis                     = parseFloat(item.vppis);
                vself.vvpis                     = parseFloat(item.vvpis);
                vself.vpcofins                  = parseFloat(item.vpcofins);
                vself.vvcofins                  = parseFloat(item.vvcofins);
                vself.vprvendamedio             = parseFloat(item.vprvendamedio);
                vself.vcalcularprvendamedio     = parseInt(item.vcalcularprvendamedio)=== 0 ? false : true;
                vself.vprcusto                  = parseFloat(item.vprcusto);
                vself.vvtotal                   = parseFloat(item.vvtotal);
                vself.vvtotalcusto              = parseFloat(item.vvtotalcusto); 

                //variáveis das tabelas de preços
                vself.vidtabelapreco             = null;
                vself.lstTabelasPrecos           = [];
                vself.vmrgtabela                 = 0;
                vself.vvltabela                  = 0;
                vself.vvlnf                      = 0;
                vself.vcomissaotabela            = 0;
                vself.vqtdmintabela              = 0;
                vself.vdescontotabela            = 0;  
                $("#cbtabelapreco").val(null).trigger('change'); 
                //classes
				vself.lstClassesProduto	         = [];
                vself.vidclasse                  = null;
                vself.vidfilialclasse            = null;
                $("#cbclasse").val(null).trigger('change'); 
                $("#cbfilialclasse").val(null).trigger('change');     

                //vself.mtdverificacfop(item.cfop);
                console.log(item)
                
                var defcfop  				= new Option(item.desccefop, vself.vidcfop, true, true);
                $('#cbcfopedicao').append(defcfop).trigger('change');       

                var defestoque  				= new Option(item.descestoque, vself.videstoqueedicao, true, true);
                $('#cbestoqueedicao').append(defestoque).trigger('change');                    
                $('.nav-tabs a[href="#dvcusto"]').tab('show');

				let loader      = vself.$loading.show();
				let parametros  = [
					{parametro: 'op',               valor : 'listagem'},
					{parametro: 'idclientesac',     valor  : vself.$store.state.filialpadrao.idcliente},
					{parametro: 'diretorioimagens', valor : vself.$store.state.configpaths.pathimgprodutos+vself.$store.state.filialpadrao.idcliente},
					{parametro: 'filtro',           valor : ''},
					{parametro: 'coddig',           valor : item.coddig},
					{parametro: 'limit',            valor : 1},
					{parametro: 'offset',           valor : 0},
				];
				let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadprodutos.php');
				retorno.then(function (response) {
					loader.hide();						
					if (response.data.length > 0){
                        vself.lstTabelasPrecos           = response.data[0].tabelas;
                        vself.lstClassesProduto          = response.data[0].classes;
                        $('#mdedicaoitem').modal('show');	
					}else{
						vself.$toastr.e('Erro ao tentar alterar o ítem. Tente novamente mais tarde!', 'Erro!');
					}
				}).catch(function (response) {
					vself.$toastr.e('Erro ao tentar alterar o ítem. Tente novamente mais tarde!', 'Erro!');
					loader.hide();						
				});				
            },
            mtdgravaritem(){
                let vself   = this;                                                              
                if (vself.vcoddigedicao === ''){
                    vself.$toastr.w('Produto deve ser informado!', 'Atenção!');
                    $('#edidprodutoedicao').focus();
                    return;
                }                
                if (parseFloat(vself.vprcompra) <= 0){
                    vself.$toastr.w('Informe um valor válido para o preço de compra!', 'Atenção!');
                    $('#edprcompra').focus();
                    return;
                }
                if (parseFloat(vself.vqtditemedicao) <= 0){
                    vself.$toastr.w('Quantidade inválida!', 'Atenção!');
                    $('#edqtditemedicao').focus();
                    return;
                } 
                if (parseInt(vself.vfracionadoedicao) === 0){
                    if (!Number.isInteger(vself.vqtditemedicao)){
						this.$toastr.w('Quantidade não pode ser FRACIONADA!', 'Atenção!');
						$('#edqtditemedicao').focus();
                        return;
                    }
				}                                
                if (vself.videstoqueedicao === null){
                    vself.$toastr.w('Estoque deve ser informado!', 'Atenção!');
                    $("#cbestoqueedicao").select2('open');
                    return;
                }
                if (parseInt(vself.vopitem) === 1){
                    if (vself.lstitensnota.length === 0){
                        vself.iditem = 1;
                    }else{
                        vself.iditem++;
                    }
                    let itemtmp = {
                        'item'          : vself.iditem,
                        'idproduto'     : vself.vidprodutoedicao,
                        'coddig'        : vself.vcoddigedicao,
                        'descricao'     : vself.vdescricaoprodutoedicao,
                        'und'           : vself.vundprodutoedicao,
                        'qtditem'       : parseFloat(vself.vqtditemedicao),
                        'fracionado'    : vself.vfracionadoedicao, 
                        'prcompra'      : parseFloat(vself.vprcompra),
                        'referencia'    : vself.vreferencia,
                        'vdesconto'     : parseFloat(vself.vvdesconto),
                        'idestoque'     : vself.videstoqueedicao,
                        'descestoque'   : $('#cbestoqueedicao').select2('data')[0]['text'],
                        'cfop'          : vself.vidcfop,
                        'desccefop'     : $('#cbcfopedicao').select2('data')[0]['text'],
                        'cstitem'       : vself.vcstitem, // esse campo vai apenas nos casos de importações 
                        'cstpiscofins'  : vself.vcstpiscofins, // esse tb - guga
                        'vpicms'        : parseFloat(vself.vpicms),
                        'vvicms'        : parseFloat(vself.vvicms),
                        'vpipi'         : parseFloat(vself.vpipi),
                        'vvipi'         : parseFloat(vself.vvipi),
                        'vpfrete'       : parseFloat(vself.vpfrete),
                        'vvfrete'       : parseFloat(vself.vvfrete),
                        'vpoutros'      : parseFloat(vself.vpoutros),
                        'vvoutros'      : parseFloat(vself.vvoutros),
                        'vpmvast'       : parseFloat(vself.vpmvast),
                        'vvbcst'        : parseFloat(vself.vvbcst),
                        'vpicmsst'      : parseFloat(vself.vpicmsst),
                        'vvicmsst'      : parseFloat(vself.vvicmsst),
                        'vppis'         : parseFloat(vself.vppis),
                        'vvpis'         : parseFloat(vself.vvpis),
                        'vpcofins'      : parseFloat(vself.vpcofins),
                        'vvcofins'      : parseFloat(vself.vvcofins),
                        'vprvendamedio' : parseFloat(vself.vprvendamedio),
                        'vcalcularprvendamedio' : vself.vcalcularprvendamedio === false ? 0 : 1,
                        'vprcusto'      : parseFloat(vself.vprcusto),
                        'vvtotal'       : parseFloat(vself.vvtotal),
                        'vvtotalcusto'  : parseFloat(vself.vvtotalcusto),
                        'tabelas'       : vself.lstTabelasPrecos
                    };
                    if (util.findValInArray(vself.lstitensnota, 'idproduto', vself.vidprodutoedicao)){
                        $.confirm({
                            title: 'Confirmação!',
                            content: 'O ítem já está incluso na nota. Deseja continuar e adicioná-lo novamente?',
                            icon: 'fa fa-question-circle',
                            escapeKey: true,
                            backgroundDismiss: false,
                            escapeKey: 'nao',
                            type: 'dark',
                            typeAnimated: true,
                            buttons: {
                                sim: {
                                    text: '<u>S</u>im',
                                    keys: ['s', 'S'],
                                    btnClass: 'btn-blue',
                                    action: function () {
                                        vself.lstitensnota.push(itemtmp);
                                        vself.vtotvicms                  = parseFloat(vself.vtotvicms)   + parseFloat(vself.vvicms);
                                        vself.vtotvipi                   = parseFloat(vself.vtotvipi)    + parseFloat(vself.vvipi);
                                        vself.vtotvfrete                 = parseFloat(vself.vtotvfrete)  + parseFloat(vself.vvfrete);
                                        vself.vtotvoutros                = parseFloat(vself.vtotvoutros) + parseFloat(vself.vvoutros);
                                        vself.vtotbcst                   = parseFloat(vself.vtotbcst)    + parseFloat(vself.vvbcst);
                                        vself.vtotst                     = parseFloat(vself.vtotst)      + parseFloat(vself.vvicmsst);                                        
                                        vself.vtotvpis                   = parseFloat(vself.vtotvpis)    + parseFloat(vself.vvpis);
                                        vself.vtotvcofins                = parseFloat(vself.vtotvcofins) + parseFloat(vself.vvcofins);
                                        vself.vtotvtotal                 = parseFloat(vself.vtotvtotal)  + parseFloat(vself.vvtotal) + parseFloat(vself.vvdesconto);
                                        vself.vtotvcusto                 = parseFloat(vself.vtotvcusto)  + parseFloat(vself.vvtotalcusto);                                        
                                        vself.vtotdesc                   = parseFloat(vself.vtotdesc)    + parseFloat(vself.vvdesconto);
                                        vself.mtdlimparedicaoitem();
                                        $('#edidprodutoedicao').focus();                                    
                                    },
                                },
                                nao: {
                                    text: '<u>N</u>ão',
                                    keys: ['n', 'N'],
                                    action: function () {
                                        $('#edidprodutoedicao').focus();
                                    }
                                }
                            }
                        });                    
                    }else{
                        vself.lstitensnota.push(itemtmp);
                        vself.vtotvicms                  = parseFloat(vself.vtotvicms)  + parseFloat(vself.vvicms);
                        vself.vtotvipi                   = parseFloat(vself.vtotvipi)   + parseFloat(vself.vvipi);
                        vself.vtotvfrete                 = parseFloat(vself.vtotvfrete) + parseFloat(vself.vvfrete);
                        vself.vtotvoutros                = parseFloat(vself.vtotvoutros)+ parseFloat(vself.vvoutros);
                        vself.vtotbcst                   = parseFloat(vself.vtotbcst)   + parseFloat(vself.vvbcst);
                        vself.vtotst                     = parseFloat(vself.vtotst)     + parseFloat(vself.vvicmsst);                                                                
                        vself.vtotvpis                   = parseFloat(vself.vtotvpis)   + parseFloat(vself.vvpis);
                        vself.vtotvcofins                = parseFloat(vself.vtotvcofins)+ parseFloat(vself.vvcofins);
                        vself.vtotvtotal                 = parseFloat(vself.vtotvtotal) + parseFloat(vself.vvtotal) + parseFloat(vself.vvdesconto);
                        vself.vtotvcusto                 = parseFloat(vself.vtotvcusto) + parseFloat(vself.vvtotalcusto);                    
                        vself.vtotdesc                   = parseFloat(vself.vtotdesc)   + parseFloat(vself.vvdesconto);
                        vself.mtdlimparedicaoitem();
                        $('#edidprodutoedicao').focus();
                    }
                }else{
                    let inditem = util.getArrayIndexForKey(vself.lstitensnota, 'item', vself.iditemalt);                    
                    //subtrai os valores anteriores do total da nota
                    vself.vtotvicms                  = parseFloat(vself.vtotvicms)   - parseFloat(vself.lstitensnota[inditem].vvicms);
                    vself.vtotvipi                   = parseFloat(vself.vtotvipi)    - parseFloat(vself.lstitensnota[inditem].vvipi);
                    vself.vtotvfrete                 = parseFloat(vself.vtotvfrete)  - parseFloat(vself.lstitensnota[inditem].vvfrete);
                    vself.vtotvoutros                = parseFloat(vself.vtotvoutros) - parseFloat(vself.lstitensnota[inditem].vvoutros);
                    vself.vtotbcst                   = parseFloat(vself.vtotbcst)    - parseFloat(vself.lstitensnota[inditem].vvbcst);
                    vself.vtotst                     = parseFloat(vself.vtotst)      - (parseFloat(vself.lstitensnota[inditem].vvicmsst) * parseFloat(vself.lstitensnota[inditem].qtditem));
                    vself.vtotvpis                   = parseFloat(vself.vtotvpis)    - parseFloat(vself.lstitensnota[inditem].vvpis);
                    vself.vtotvcofins                = parseFloat(vself.vtotvcofins) - parseFloat(vself.lstitensnota[inditem].vvcofins);
                    vself.vtotvtotal                 = parseFloat(vself.vtotvtotal)  - parseFloat(vself.lstitensnota[inditem].vvtotal);
                    vself.vtotvcusto                 = parseFloat(vself.vtotvcusto)  - parseFloat(vself.lstitensnota[inditem].vvtotalcusto);
                    vself.vtotdesc                   = parseFloat(vself.vtotdesc)    - parseFloat(vself.lstitensnota[inditem].vdesconto);
                    ////////////////////////////////
                    vself.lstitensnota[inditem].qtditem       = parseFloat(vself.vqtditemedicao);
                    vself.lstitensnota[inditem].prcompra      = parseFloat(vself.vprcompra);
                    vself.lstitensnota[inditem].vdesconto     = parseFloat(vself.vvdesconto);
                    vself.lstitensnota[inditem].idestoque     = vself.videstoqueedicao;
                    vself.lstitensnota[inditem].descestoque   = $('#cbestoqueedicao').select2('data')[0]['text'];
                    vself.lstitensnota[inditem].vpicms        = parseFloat(vself.vpicms);
                    vself.lstitensnota[inditem].vvicms        = parseFloat(vself.vvicms);
                    vself.lstitensnota[inditem].vpipi         = parseFloat(vself.vpipi);
                    vself.lstitensnota[inditem].vvipi         = parseFloat(vself.vvipi);
                    vself.lstitensnota[inditem].vpfrete       = parseFloat(vself.vpfrete);
                    vself.lstitensnota[inditem].vvfrete       = parseFloat(vself.vvfrete);
                    vself.lstitensnota[inditem].vpoutros      = parseFloat(vself.vpoutros);
                    vself.lstitensnota[inditem].vvoutros      = parseFloat(vself.vvoutros);
                    vself.lstitensnota[inditem].cfop          = vself.vidcfop;
                    vself.lstitensnota[inditem].desccefop     = $('#cbcfopedicao').select2('data')[0]['text'];

                    vself.lstitensnota[inditem].vpmvast       = parseFloat(vself.vpmvast);
                    vself.lstitensnota[inditem].vbcst         = parseFloat(vself.vvbcst);
                    vself.lstitensnota[inditem].vpicmsst      = parseFloat(vself.vpicmsst);
                    vself.lstitensnota[inditem].vvicmsst      = parseFloat(vself.vvicmsst);
                    vself.lstitensnota[inditem].vppis         = parseFloat(vself.vppis);
                    vself.lstitensnota[inditem].vvpis         = parseFloat(vself.vvpis);
                    vself.lstitensnota[inditem].vpcofins      = parseFloat(vself.vpcofins);
                    vself.lstitensnota[inditem].vvcofins      = parseFloat(vself.vvcofins);
                    vself.lstitensnota[inditem].vprvendamedio = parseFloat(vself.vprvendamedio);
                    vself.lstitensnota[inditem].vcalcularprvendamedio = vself.vcalcularprvendamedio === false ? 0 : 1;
                    vself.lstitensnota[inditem].vprcusto      = parseFloat(vself.vprcusto);
                    vself.lstitensnota[inditem].vvtotal       = parseFloat(vself.vvtotal);
                    vself.lstitensnota[inditem].vvtotalcusto  = parseFloat(vself.vvtotalcusto);
                    vself.lstitensnota[inditem].tabelas       = vself.lstTabelasPrecos;

                    //atualiza o total da nota com os novos valores
                    vself.vtotvicms                  = parseFloat(vself.vtotvicms)   + parseFloat(vself.vvicms);
                    vself.vtotvipi                   = parseFloat(vself.vtotvipi)    + parseFloat(vself.vvipi);
                    vself.vtotvfrete                 = parseFloat(vself.vtotvfrete)  + parseFloat(vself.vvfrete);
                    vself.vtotvoutros                = parseFloat(vself.vtotvoutros) + parseFloat(vself.vvoutros);
                    vself.vtotbcst                   = parseFloat(vself.vtotbcst)    + parseFloat(vself.vvbcst);
                    vself.vtotst                     = parseFloat(vself.vtotst)      + (parseFloat(vself.vvicmsst) * parseFloat(vself.vqtditemedicao));
                    vself.vtotvpis                   = parseFloat(vself.vtotvpis)    + parseFloat(vself.vvpis);
                    vself.vtotvcofins                = parseFloat(vself.vtotvcofins) + parseFloat(vself.vvcofins);
                    vself.vtotvtotal                 = parseFloat(vself.vtotvtotal)  + parseFloat(vself.vvtotal) + parseFloat(vself.vvdesconto);
                    vself.vtotvcusto                 = parseFloat(vself.vtotvcusto)  + parseFloat(vself.vvtotalcusto);
                    vself.vtotdesc                   = parseFloat(vself.vtotdesc)    + parseFloat(vself.vvdesconto);
                    ///////////////////////////////////////////////                    
                    
                    vself.mtdlimparedicaoitem();
                    $('#mdedicaoitem').modal('hide');                 
                }
            },
            mtdverificacfop(idcfop){
                var vself       = this;
                let loader      = this.$loading.show();
                let cfop        = null; 
                let parametros  = [
                    {parametro: 'idclientesac', valor : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor : 'verificacfop'},
                    {parametro: 'cfop',         valor : idcfop},
                ];
                let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadnotasfornecedores.php');
                retorno.then(function (response) {
                    loader.hide();
                    vself.idcfopleg    = response.data.cfop,
                    vself.desccefopleg = response.data.desccfop
                }).catch(function (response) {
                    loader.hide();
                });

                return
            },
            mtdconfirmaredicaoitem(){
                let vself = this;
                if (vself.aitemedicao_xprod === ''){
                    vself.$toastr.w('Descrição deve ser informada!', 'Atenção!');
                    $('#edxprodedicao').focus();
                    return;     
                }
                if (vself.aitemedicao_ucom === null){
                    vself.$toastr.w('Unidade deve ser informada!', 'Atenção!');
                    $('#cbunidadeedicao').focus();
                    return;     
                }                
                if (vself.aitemedicao_idmarca === null){
                    vself.$toastr.w('Marca deve ser informada!', 'Atenção!');
                    $('#cbmarcaedicao').focus();
                    return;     
                }
                if (vself.aitemedicao_idgrupo === null){
                    vself.$toastr.w('Grupo deve ser informado!', 'Atenção!');
                    $('#cbgrupoedicao').focus();
                    return;     
                }
                if (vself.aitemedicao_idsubgrupo === null){
                    vself.$toastr.w('Subgrupo deve ser informado!', 'Atenção!');
                    $('#cbsubgrupoedicao').focus();
                    return;     
                }                  
                let i = util.getArrayIndexForKey(vself.pnotaentrada.itens, 'item', vself.aitemedicao_item);
                vself.pnotaentrada.itens[i]['fator']            = 1;
                vself.pnotaentrada.itens[i]['xprod']            = vself.aitemedicao_xprod;                
                vself.pnotaentrada.itens[i]['ucom']             = vself.aitemedicao_ucom;
                vself.pnotaentrada.itens[i]['descund']          = $('#cbunidadeedicao').select2('data')[0]['text'];
                vself.pnotaentrada.itens[i]['idmarca']          = vself.aitemedicao_idmarca;
                vself.pnotaentrada.itens[i]['descmarca']        = $('#cbmarcaedicao').select2('data')[0]['text'];
                vself.pnotaentrada.itens[i]['idgrupo']          = vself.aitemedicao_idgrupo;
                vself.pnotaentrada.itens[i]['descgrupo']        = $('#cbgrupoedicao').select2('data')[0]['text'];
                vself.pnotaentrada.itens[i]['idsubgrupo']       = vself.aitemedicao_idsubgrupo;
                vself.pnotaentrada.itens[i]['descsubgrupo']     = $('#cbsubgrupoedicao').select2('data')[0]['text'];
                vself.pnotaentrada.itens[i]['dadoscadastro']    = 1;
                $('#mdalteracaodadositem').modal('hide');
            },
            mtdverificarprodutoscadastro(verificarcadastro){
                let vself       = this;
                let resultado   = true;
                vself.lstprodutoscadastrar = [];
                for (let item in vself.pnotaentrada.itens) {
                    if (vself.pnotaentrada.itens.hasOwnProperty(item)) {
                        let elemento = vself.pnotaentrada.itens[item];
                        let passa    = true;
                        if (verificarcadastro){
                            if (parseInt(elemento.idproduto) === 0){
                                passa = false;
                            }
                        }
                        if (parseInt(elemento.dadoscadastro) === 0 || !passa){
                            resultado = false;
                            break;
                        }else{
                            vself.lstprodutoscadastrar.push(elemento);
                        }
                    }
                }
                return resultado;
            },
            mtdcadastroautomatizadoprodutos(){
                let vself = this;
                if (!vself.mtdverificarprodutoscadastro(false)){
                    vself.$toastr.i('Existem alguns itens pendentes de conferência para o cadastro automatiza. Verifique e tente novamente!', 'Informação!');
                }else{
                    let loader  = vself.$loading.show();
                    let parametros      = [
                        {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                        {parametro: 'op',                   valor : 'cadastrarprodutos'},
                        {parametro: 'idfornecedor',         valor : vself.pnotaentrada.idfornecedor},
                        {parametro: 'produtos',             valor : JSON.stringify(vself.lstprodutoscadastrar)}
                    ];  
                    let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadnotasfornecedores.php');
                    retorno.then(function (response) {
                        loader.hide();
                        if (parseInt(response.data.inf) === 0){
                            vself.pnotaentrada.itens = response.data.produtos;
                            // for (let index = 0; index < vself.pnotaentrada.itens.length; index++) {
                            //     vself.pnotaentrada.itens[index].item = index + 1;                                
                            // }
                            vself.$toastr.s('Produtos cadastrados com sucesso!', 'Informação!');
                        }else{
                            vself.$toastr.e(response.data.msg.substring(4), 'Erro!');
                        }                    
                    }).catch(function (response) {
                        loader.hide();
                        vself.$toastr.e('Erro ao tentar cadastrar os produtos. Descrição do erro: '+response.message, 'Erro!');
                    });
                }
            },
            mtdcalculacustoitem(callback){                
                this.vprcusto = util.calculacustoproduto(this, 
                    parseFloat(this.vpipi)/100,
                    parseFloat(this.vpicms)/100,
                    parseFloat(this.vpfrete)/100,
                    parseFloat(this.vvicmsst),//verificar depois o calculo da substituição tributária
                    parseFloat(this.vppis/100),
                    parseFloat(this.vpcofins/100),
                    parseFloat(this.vpoutros/100),
                    parseFloat(this.vprcompra) - parseFloat(this.vvdesconto),
                    parseFloat(this.vprvendamedio),
                    this.vformulacustopro//carregado quando a filial é selecionada
                );
                callback();
            },
            mtdtotalizador(){
                this.vvtotal        = parseFloat(this.vqtditemedicao) * parseFloat(this.vprcompra) - parseFloat(this.vvdesconto);
                this.vvtotalcusto   = parseFloat(this.vqtditemedicao) * parseFloat(this.vprcusto);
            },
            mtdcalculaperc(){
                let vlcalcular = (parseFloat(this.vprcompra) - parseFloat(this.vvdesconto)) * parseFloat(this.vqtditemedicao);

                if (parseFloat(this.vpicms) > 0){
                    this.vvicms = vlcalcular * parseFloat(this.vpicms) / 100 ;
                }else{
                    this.vvicms = 0;
                }

                if (parseFloat(this.vpipi) > 0){
                    this.vvipi = vlcalcular * parseFloat(this.vpipi) / 100 ;
                }else{
                    this.vvipi = 0;
                }

                if (parseFloat(this.vpfrete) > 0){
                    this.vvfrete = vlcalcular * parseFloat(this.vpfrete) / 100 ;
                }else{
                    this.vvfrete = 0;
                }
                
                if (parseFloat(this.vpoutros) > 0){
                    this.vvoutros = vlcalcular * parseFloat(this.vpoutros) / 100 ;
                }else{
                    this.vvoutros = 0;
                }

                if (parseFloat(this.vppis) > 0){
                    this.vvpis = vlcalcular * parseFloat(this.vppis) / 100 ;
                }else{
                    this.vvpis = 0;
                }

                if (parseFloat(this.vpcofins) > 0){
                    this.vvcofins = vlcalcular * parseFloat(this.vpcofins) / 100 ;
                }else{
                    this.vvcofins = 0;
                }
                                
            },
            mtdcalculavalor(){
                let vlcalcular = (parseFloat(this.vprcompra) - parseFloat(this.vvdesconto)) * parseFloat(this.vqtditemedicao);
                
                if (parseFloat(this.vvicms) > 0){
                    this.vpicms = parseFloat(this.vvicms) / vlcalcular * 100;
                }else{
                    this.vpicms = 0;
                }

                if (parseFloat(this.vvipi) > 0){
                    this.vpipi = parseFloat(this.vvipi) / vlcalcular * 100;
                }else{
                    this.vpipi = 0;
                }
                
                if (parseFloat(this.vvfrete) > 0){
                    this.vpfrete = parseFloat(this.vvfrete) / vlcalcular * 100;
                }else{
                    this.vpfrete = 0;
                }

                if (parseFloat(this.vvoutros) > 0){
                    this.vpoutros = parseFloat(this.vvoutros) / vlcalcular * 100;
                }else{
                    this.vpoutros = 0;
                }                

                if (parseFloat(this.vvpis) > 0){
                    this.vppis = parseFloat(this.vvpis) / vlcalcular * 100;
                }else{
                    this.vppis = 0;
                }                

                if (parseFloat(this.vvcofins) > 0){
                    this.vpcofins = parseFloat(this.vvcofins) / vlcalcular * 100;
                }else{
                    this.vpcofins = 0;
                }                                
            },
			mtdefetivarnota(nota){
                if (!util.opcaousuario('010Z.010Z.030Z', this.$store.state.perfilusuario)){
                    this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                }else{
                    if(parseInt(nota.conferida) === 0){
                        if (!util.opcaousuario('010Z.010Z.035Z', this.$store.state.perfilusuario)){
                            this.$toastr.i('Conferência ainda não foi realizada!', 'Informação!');
                            return;
                        }
                    }
                    var vself       = this;
                    let loader      = this.$loading.show();
                    let filtro      = ' AND n.idfornecedor='+nota.idfornecedor+' AND n.idfilial='+nota.idfilial+' AND n.numero='+nota.numero;
                    let parametros  = [
                        {parametro: 'idclientesac', valor : vself.$store.state.filialpadrao.idcliente},
                        {parametro: 'op',           valor : 'listagem'},
                        {parametro: 'filtro',       valor : filtro},
                        {parametro: 'limit',        valor : 1},
                        {parametro: 'offset',       valor : 0}
                    ];
                    let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadnotasfornecedores.php');
                    retorno.then(function (response) {
                        loader.hide();
                        vself.notaefetivar 	= response.data.notas[0];

                        $("#cbtipocobrancagerar").val(null).trigger('change');
                        vself.edtefetivacao         = util.DataAtual(true, false);					
                        vself.lsttitulosefetivar    = [];
                        vself.eqtdtitulosgerar      = 1;
                        vself.eintervaloparcelas    = 30;
                        vself.ecodigoauxiliargerar  = '';
                        if (parseInt(vself.notaefetivar.situacao) !== 0){
                            vself.$toastr.i('Para efetivar a nota, a situação da mesma deve estar em edição!', 'Informação!');
                            vself.notaefetivar = [];
                            return;
                        }
                        $('#mdefetivarnota').modal('show');										
                    }).catch(function (response) {
                        loader.hide();
                    });
                }		
            },
            mtdgerartitulos(){
                if (this.edtefetivacao === null){
                    this.$toastr.w('Data de efetivação deve ser informada!', 'Informação!');
                    $("#eddtefetivacao").focus();
                    return;
                }                
                if (this.eidtipocobrancagerar === null){
                    this.$toastr.w('Tipo de cobrança deve ser informada!', 'Informação!');
                    $("#cbtipocobrancagerar").select2('open');
                    return;
                }
                if (this.eqtdtitulosgerar === ''){
                    this.$toastr.w('Quantidade de parcelas deve ser informada!', 'Informação!');
                    $("#edqtdtitulosgerar").focus();
                    return;
                }
                if (this.eintervaloparcelas === ''){
                    this.$toastr.w('Intervalo das parcelas deve ser informada!', 'Informação!');
                    $("#edintervaloparcelas").focus();
                    return;
                }                
				this.lsttitulosefetivar = [];

				let vlparcela = (parseFloat(this.notaefetivar.vtotvtotal) + parseFloat(this.notaefetivar.vtotvipi) + parseFloat(this.notaefetivar.vst) + parseFloat(this.notaefetivar.vtotvfrete) + parseFloat(this.notaefetivar.vtotvoutros)) / this.eqtdtitulosgerar;

				for (var i = 0; i < this.eqtdtitulosgerar; i++) {
					let titulo = {
						codtit 				: this.notaefetivar.numero + '/' + this.mtdformatarzeros(i + 1, 2) + '-'+this.eqtdtitulosgerar,
						dtventit			: util.somaDias(this.mtdformatadatagravar(this.notaefetivar.dtemissao), parseInt((i + 1) * this.eintervaloparcelas)),
                        vltit				: vlparcela,
                        idfornecedor        : this.notaefetivar.idfornecedor,
                        nomefornecedor      : this.notaefetivar.nomefornecedor,
						idtipocobranca		: this.eidtipocobrancagerar,
						tipocobranca		: this.etipocobrancagerar,// 0 - Normal 1 - Cheque
						descricaocob		: $('#cbtipocobrancagerar').select2('data')[0]['text'],
						numerocheque		: '',
						idbanco				: null,
						descbanco			: '',
						agencia				: '',
						conta				: '',
						praca				: '',
						emitente			: '',
						cnpjcpf				: '',						
                        idsituacaocheque	: null,
                        codauxiliar         : this.ecodigoauxiliargerar,                        
						descsituacaocheque	: ''
					}
					this.lsttitulosefetivar.push(titulo);
				}
				this.etotaltitulos = parseFloat(this.notaefetivar.vtotvtotal) + parseFloat(this.notaefetivar.vtotvipi) + parseFloat(this.notaefetivar.vst) + parseFloat(this.notaefetivar.vtotvfrete) + parseFloat(this.notaefetivar.vtotvoutros);                
            },
            mtdalterartitulo(titulo){
				this.ecodtit 				= titulo.codtit;
				this.edtventit				= titulo.dtventit;
                this.evltit				    = titulo.vltit;
                this.eidfornecedor          = titulo.idfornecedor,
				this.eidtipocobranca		= titulo.idtipocobranca;
				this.etipocobranca			= titulo.tipocobranca;
				this.edescricaocob			= titulo.descricaocob;
				this.enumerocheque			= titulo.numerocheque;
				this.eidbanco				= titulo.idbanco;
				this.edescbanco			    = titulo.descbanco;
				this.eagencia				= titulo.agencia;
				this.econta				    = titulo.conta;
				this.epraca				    = titulo.praca;
				this.eemitente				= titulo.emitente;
                this.ecnpjcpf				= titulo.cnpjcpf;
                this.ecodigoauxiliar        = titulo.codauxiliar;						
				this.eidsituacaocheque		= titulo.idsituacaocheque;
				this.edescsituacaocheque	= titulo.descsituacaocheque;				

				var deffornecedor  = new Option(titulo.nomefornecedor, this.eidfornecedor, true, true);
				$('#cbfornecedor').append(deffornecedor).trigger('change');

				var deftipocobranca  = new Option(this.edescricaocob, this.eidtipocobranca, true, true);
				$('#cbtipocobranca').append(deftipocobranca).trigger('change');

				if (this.eidbanco !== null){
					var defbanco  = new Option(this.edescbanco, this.eidbanco, true, true);
					$('#cbbanco').append(defbanco).trigger('change');
				}else{
					$("#cbbanco").val(null).trigger('change');
				}
				
				if (this.eidsituacaocheque !== null){
					var defsituacaoch  = new Option(this.edescsituacaocheque, this.eidsituacaocheque, true, true);
					$('#cbsituacaocheque').append(defsituacaoch).trigger('change');
				}else{
					$("#cbsituacaocheque").val(null).trigger('change');
				}

				$('#mdalterartitulo').modal('show');
            },
			mtconfirmaralteracaotitulo(){
				if (this.edtventit === ''){
					this.$toastr.w('Data de vencimento deve ser informada!', 'Atenção!');
					$('#eddtventit').focus();
					return;
				}
				if (parseFloat(this.evltit) <= 0){
					this.$toastr.w('Valor do título inválido!', 'Atenção!');
					$('#edvltit').focus();
					return;
				}
				if (this.eidtipocobranca === null){
					this.$toastr.w('Tipo de cobrança deve ser informada!', 'Atenção!');
					$('#cbtipocobranca').focus();
					return;
                }
                if (this.eidfornecedor === null){
                    this.$toastr.w('Fornecedor deve ser informado!', 'Atenção!');
                    $('#cbfornecedor').select2('open');
                    return;
                }
				if (parseInt(this.etipocobranca) === 1){
					if (this.enumerocheque === ''){
						this.$toastr.w('Número do cheque deve ser informado!', 'Atenção!');
						$('#ednumerocheque').focus();
						return;
					}
					if (this.eidbanco === null){
						this.$toastr.w('Banco deve ser informado!', 'Atenção!');
						$('#cbbanco').focus();
						return;
					}
					if (this.eagencia === ''){
						this.$toastr.w('Agência deve ser informada!', 'Atenção!');
						$('#edagencia').focus();
						return;
					}
					if (this.econta === ''){
						this.$toastr.w('Conta deve ser informada!', 'Atenção!');
						$('#edconta').focus();
						return;
					}
					if (this.epraca === ''){
						this.$toastr.w('Praça deve ser informada!', 'Atenção!');
						$('#edpraca').focus();
						return;
					}
					if (this.eemitente === ''){
						this.$toastr.w('Emitente deve ser informado!', 'Atenção!');
						$('#edemitente').focus();
						return;
					}
					if (this.ecnpjcpf === ''){
						this.$toastr.w('CNPJ/CPF deve ser informado!', 'Atenção!');
						$('#edcnpjcpf').focus();
						return;
					}
					if (this.eidsituacaocheque === null){
						this.$toastr.w('Situação do cheque deve ser informada!', 'Atenção!');
						$('#cbsituacaocheque').focus();
						return;
					}					
				}
				let indice = util.getArrayIndexForKey(this.lsttitulosefetivar, 'codtit', this.ecodtit);
				this.etotaltitulos = this.etotaltitulos - this.lsttitulosefetivar[indice].vltit;


				this.lsttitulosefetivar[indice].dtventit 			= this.edtventit;
				this.lsttitulosefetivar[indice].dtventit			= this.edtventit;
				this.lsttitulosefetivar[indice].vltit				= this.evltit;
                this.lsttitulosefetivar[indice].idtipocobranca		= this.eidtipocobranca;
				this.lsttitulosefetivar[indice].idfornecedor		= this.eidfornecedor;
                this.lsttitulosefetivar[indice].nomefornecedor		= $('#cbfornecedor').select2('data')[0]['text'];
				this.lsttitulosefetivar[indice].tipocobranca		= this.etipocobranca;
                this.lsttitulosefetivar[indice].descricaocob		= $('#cbtipocobranca').select2('data')[0]['text'];
                this.lsttitulosefetivar[indice].codauxiliar		    = this.ecodigoauxiliar;

				this.lsttitulosefetivar[indice].numerocheque		= parseInt(this.etipocobranca) === 1 ? this.enumerocheque 	: '';
				this.lsttitulosefetivar[indice].idbanco				= parseInt(this.etipocobranca) === 1 ? this.eidbanco 			: null;
				this.lsttitulosefetivar[indice].descbanco			= parseInt(this.etipocobranca) === 1 ? $('#cbbanco').select2('data')[0]['text'] : '';
				this.lsttitulosefetivar[indice].agencia				= parseInt(this.etipocobranca) === 1 ? this.eagencia 			: '';
				this.lsttitulosefetivar[indice].conta				= parseInt(this.etipocobranca) === 1 ? this.econta 			: '';
				this.lsttitulosefetivar[indice].praca				= parseInt(this.etipocobranca) === 1 ? this.epraca 			: '';
				this.lsttitulosefetivar[indice].emitente			= parseInt(this.etipocobranca) === 1 ? this.eemitente 		: '';
				this.lsttitulosefetivar[indice].cnpjcpf				= parseInt(this.etipocobranca) === 1 ? this.ecnpjcpf 			: '';						
				this.lsttitulosefetivar[indice].idsituacaocheque	= parseInt(this.etipocobranca) === 1 ? this.eidsituacaocheque : null;
				this.lsttitulosefetivar[indice].descsituacaocheque	= parseInt(this.etipocobranca) === 1 ? $('#cbsituacaocheque').select2('data')[0]['text'] : '';				


				this.etotaltitulos = this.etotaltitulos + this.evltit;

				$('#mdalterartitulo').modal('hide');
			},            
			mtdpendenciasparcela(){
				let ret = false;
				for (let titulo of this.lsttitulosefetivar) {
					if (parseInt(titulo.tipocobranca) === 1){
						if (titulo.numerocheque === ''){
							ret = true;
							break;
						}
						if (titulo.idbanco === null){
							ret = true;
							break;
						}
						if (titulo.agencia === ''){
							ret = true;
							break;
						}
						if (titulo.conta === ''){
							ret = true;
							break;
						}
						if (titulo.praca === ''){
							ret = true;
							break;
						}
						if (titulo.emitente === ''){
							ret = true;
							break;
						}
						if (titulo.cnpjcpf === ''){
							ret = true;
							break;
						}
						if (titulo.idsituacaocheque === null){
							ret = true;
							break;
						}																		
					}
				}
				return ret;
			},            
            mtdconfirmarefetivacao(){
				let vself = this;
                if (vself.mtdpendenciasparcela()){//se estiver faltando algum campo do cheque ser preenchido
                    vself.$toastr.w('Algum(ns) título(s) definido(s) como cheque não apresenta(m) todas as informações preenchidas. Verifique e tente novamente!', 'Atenção!');
                    return;					
                }
                if(vself.vhabrelacaopedcompra==true){
                    if(vself.vcodpedcompra==''){
                        vself.$toastr.w('Informe um pedido de compra para efetivação!', 'Atenção!');
                        return;
                    }
                }				
				$.confirm({
					title: 'Confirmação!',
					content: 'Confirma EFETIVAÇÃO da nota?',
					icon: 'fa fa-question-circle',
					escapeKey: true,
					backgroundDismiss: false,
					escapeKey: 'nao',
					type: 'dark',
					typeAnimated: true,
					buttons: {
						sim: {
							text: '<u>S</u>im',
							keys: ['s', 'S'],
							btnClass: 'btn-blue',
							action: function () {
								$('.btn-blue').prop('disabled', true);
								setTimeout(function(){
									vself.mtdfinalizarefetivacao();
								}, 300); 								
							},
						},
						nao: {
							text: '<u>N</u>ão',
							keys: ['n', 'N'],
							action: function () {
							}
						}
					}
				});				
            },
            mtdfinalizarefetivacao(){
                let vself  = this;
                let loader = vself.$loading.show();
                let notaefetivar = {
                    'idfornecedor'      : vself.notaefetivar.idfornecedor,
                    'idfilial'          : vself.notaefetivar.idfilial,
                    'numero'            : vself.notaefetivar.numero,
                    'dtefetivacao'      : vself.edtefetivacao,
                    'titulos'           : vself.lsttitulosefetivar
				};
                let parametros      = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor : 'efetivar'},
                    {parametro: 'nota',         valor : JSON.stringify(notaefetivar)},
                    {parametro: 'idfilial',     valor : vself.$store.state.filialpadrao.codfil},
                    {parametro: 'idusuario',    valor : vself.$store.state.usuario.id},
                    {parametro: 'pedcompra',    valor : vself.vcodpedcompra},
                    {parametro: 'habpedcompra', valor : vself.vhabrelacaopedcompra === true ? 1 : 0 },
                    {parametro: 'codop',        valor : '010Z.010Z.030Z'},
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadnotasfornecedores.php');
                retorno.then(function (response) {
                    loader.hide();
                    $('#mdefetivarnota').modal('hide');	
                    if ($.isNumeric(response.data)){                        
                        vself.$toastr.s('Nota efetivada com sucesso!', 'Informação!');
                    }else{
                        let tpret = response.data.substring(0,1);
                        switch (tpret) {
                            case 'I':
                                vself.$toastr.w(response.data.substring(4), 'Atenção!');
                                break;
                            case 'E': default:
                                vself.$toastr.e(response.data.substring(4), 'Erro!');
                                break;
                        }
                    }
                    vself.pnumero        = vself.notaefetivar.numero;
                    vself.pfiltroperiodo = 0;
                    vself.pefetivadas    = 2;
                    vself.vcodpedcompra  = '';

                    let deffilial = new Option(vself.notaefetivar.fantasiafilial, vself.notaefetivar.idfilial, true, true);
                    $('#cbfilialpesq').append(deffilial).trigger('change');	                        

                    let deffornecedor = new Option(vself.notaefetivar.nomefornecedor, vself.notaefetivar.idfornecedor, true, true);
                    $('#cbfornecedorpesq').append(deffornecedor).trigger('change');	                                                
                    
                    vself.pqtd_paginas  = 1;
                    vself.mtdcancelaredicao();
                    vself.mtdcarreganotas(1);                    
                }).catch(function (response) {
                    loader.hide();
                    vself.$toastr.e('Erro ao efetivar a nota. Descrição do erro: '+response.message, 'Erro!');
                });                
            },
            mtdincluirnotamanifesto(nota){
                let vself = this;
                console.log(nota)
                if (!util.opcaousuario('010Z.010Z.010Z', vself.$store.state.perfilusuario)){
                    vself.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                }else {  
                    if (vself.midestoquemanifesto === null){
                        vself.$toastr.i('Defina o estoque para entrada dos itens!', 'Informação!');
                        $('#cbestoquemanifesto').select2('open');
                        return;
                    }              
                    if (!vself.mtdverificarprodutoscadastro(true)){
                        vself.$toastr.i('Existem alguns itens pendentes. Verifique e tente novamente!', 'Informação!');
                    }else{
                        $('#mdprevisualizacaonf').modal('hide');                        
                        vself.itensbc.item2.titulo  = 'INCLUSÃO DE NOTA DE FORNECEDOR';
                        vself.itensbc.item1.ativo   = true;
                        vself.itensbc.item2.ativo   = true;
                        vself.ativadesativa         = false;

                        vself.opcrud = 1;
                        $('.nav-tabs a[href="#dvitens"]').tab('show');
                        $('#pnlista').hide();
                        $('#pnconferencia').hide();
                        vself.resetarDados();
                        $('#pncadastro').fadeIn(700);

                        setTimeout(() => {//aguarda 1 seg pra atualizar a tela

                            var deffilial  			= new Option($('#cbfilialmanifesto').select2('data')[0]['text'], vself.midfilialmanifesto, true, true);
                            $('#cbfilial').append(deffilial).trigger('change');	

                            vself.vidfornecedor              = nota.idfornecedor;
                            vself.vnomefornecedor            = nota.nomefornecedor;
                            vself.vnumero                    = nota.nnf;
                            vself.vtipo                      = 0;
                            vself.vtipofrete                 = 0;
                            vself.vmodelo                    = nota.mod;
                            vself.vserie                     = nota.serie;
                            vself.vnaturezaoperacao          = nota.natop;
                            vself.vchaveacesso               = nota.chnfe;
                            vself.vxml                       = nota.xml,
                            vself.vobservacoes               = '';
                            vself.vformulacustopro           = vself.mformulacustomanifesto;

                            //zera totalizadores
                            vself.vtotvicms                  = 0;
                            vself.vtotvipi                   = 0;
                            vself.vtotvfrete                 = 0;
                            vself.vtotvoutros                = 0;
                            vself.vtotst                     = 0;
                            vself.vtotvpis                   = 0;
                            vself.vtotvcofins                = 0;
                            vself.vtotvtotal                 = 0;
                            vself.vtotvcusto                 = 0;
                            vself.vtotdesc                   = 0;

                            vself.lstitensnota               = [];
                            vself.iditem                     = 0;
                            for (let item in nota.itens) {
                                vself.iditem++;
                                if (vself.pnotaentrada.itens.hasOwnProperty(item)) {
                                    let elemento = vself.pnotaentrada.itens[item];
                                    console.log(elemento)
                                    let tqtdfat = parseFloat(elemento.fator) * parseFloat(elemento.qcom); 
                                    let vdescunitario = elemento.vdesc / tqtdfat; 
                                    let prcompra = parseFloat(elemento.vuncom) / parseFloat(elemento.fator);
                                    let prconv   = (parseFloat(elemento.vuncom) - parseFloat(vdescunitario)) / parseFloat(elemento.fator);
                                    let prc      = util.calculacustoproduto(this, //preco de custo
                                                            parseFloat(elemento.vpipi)/100,
                                                            parseFloat(elemento.vpicms)/100,
                                                            parseFloat(elemento.vpfrete)/100,
                                                            parseFloat(elemento.vicmsst)/parseFloat(elemento.qcom),//verificar depois o calculo da substituição tributária
                                                            parseFloat(elemento.vppis)/100,
                                                            parseFloat(elemento.vpcofins)/100,
                                                            parseFloat(elemento.vpoutros)/100,
                                                            prconv,
                                                            parseFloat(elemento.prvendamedio),
                                                            vself.mformulacustomanifesto//carregado quando a filial é selecionada
                                                        );                                        
                                    //let tvlunitariofat = parseFloat(elemento.vprod) / tqtdfat;     
                                    
                                    //vself.mtdverificacfop(elemento.cfop)

                                    let loader      = this.$loading.show();
                                    let cfop        = null; 
                                    let parametros  = [
                                        {parametro: 'idclientesac', valor : vself.$store.state.filialpadrao.idcliente},
                                        {parametro: 'op',           valor : 'verificacfop'},
                                        {parametro: 'cfop',         valor : elemento.cfop},
                                    ];
                                    let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadnotasfornecedores.php');
                                    retorno.then(function (response) {
                                        loader.hide();
                                       // vself.idcfopleg    = response.data.cfop,
                                        //vself.desccefopleg = response.data.desccfop

                                        let itemtmp = {
                                        'item'          : elemento.item,
                                        'idproduto'     : elemento.idproduto,
                                        'coddig'        : elemento.idproduto,
                                        'descricao'     : elemento.descricaoproduto,
                                        'und'           : elemento.und,
                                        'qtditem'       : tqtdfat,
                                        'fracionado'    : elemento.fracionado, 
                                        'prcompra'      : prcompra,
                                        'vdesconto'     : parseFloat(elemento.vdesc),
                                        'idestoque'     : vself.midestoquemanifesto,
                                        'descestoque'   : $('#cbestoquemanifesto').select2('data')[0]['text'],
                                        'cfop'          : response.data.cfop,
                                        'desccefop'     : response.data.desccfop,
                                        'cstitem'       : elemento.cstitem,
                                        'cstpiscofins'  : elemento.cstpiscofins,
                                        'vpicms'        : parseFloat(elemento.vpicms),
                                        'vvicms'        : parseFloat(elemento.vvicms),
                                        'vpipi'         : parseFloat(elemento.vpipi),
                                        'vvipi'         : parseFloat(elemento.vvipi),
                                        'vpfrete'       : parseFloat(elemento.vpfrete),
                                        'vvfrete'       : parseFloat(elemento.vvfrete),
                                        'vpoutros'      : parseFloat(elemento.vpoutros),
                                        'vpmvast'       : parseFloat(elemento.vpmvast),
                                        'vvbcst'        : parseFloat(elemento.vbcst) / tqtdfat,
                                        'vpicmsst'      : parseFloat(elemento.vpicmsst),
                                        'vvicmsst'      : parseFloat(elemento.vicmsst) / tqtdfat,                                            
                                        'vvoutros'      : parseFloat(elemento.vvoutros),
                                        'vppis'         : parseFloat(elemento.vppis),
                                        'vvpis'         : parseFloat(elemento.vvpis),
                                        'vpcofins'      : parseFloat(elemento.vpcofins),
                                        'vvcofins'      : parseFloat(elemento.vvcofins),
                                        'vprvendamedio' : parseFloat(elemento.prvendamedio),
                                        'vcalcularprvendamedio' : 0,
                                        'tabelas'       : elemento.tabelas,
                                        'vprcusto'      : util.arredondaValores(parseFloat(prc), 3, 'round'),
                                        'vvtotal'       : util.arredondaValores(parseFloat(prcompra * parseFloat(elemento.qcom) * parseFloat(elemento.fator)), 3, 'round'),
                                        'vvtotalcusto'  : util.arredondaValores((parseFloat(prc) / parseFloat(elemento.fator) * (parseFloat(elemento.qcom) * parseFloat(elemento.fator))), 3, 'round'),//(parseFloat(elemento.vuncom) / parseFloat(elemento.fator) * (parseFloat(elemento.qcom) * parseFloat(elemento.fator))),
                                    };
                                    vself.lstitensnota.push(itemtmp);
                                    //soma os valores dos itens nos totalizadores
                                    vself.vtotvicms                  = vself.vtotvicms   + parseFloat(itemtmp.vvicms);
                                    vself.vtotvipi                   = vself.vtotvipi    + parseFloat(itemtmp.vvipi);
                                    vself.vtotvfrete                 = vself.vtotvfrete  + parseFloat(itemtmp.vvfrete);
                                    vself.vtotvoutros                = vself.vtotvoutros + parseFloat(itemtmp.vvoutros);
                                    vself.vtotst                     = vself.vtotst      + parseFloat(itemtmp.vvicmsst) * parseFloat(itemtmp.qtditem);
                                    vself.vtotvpis                   = vself.vtotvpis    + parseFloat(itemtmp.vvpis);
                                    vself.vtotvcofins                = vself.vtotvcofins + parseFloat(itemtmp.vvcofins);
                                    vself.vtotvtotal                 = vself.vtotvtotal  + parseFloat(itemtmp.vvtotal);
                                    vself.vtotvcusto                 = vself.vtotvcusto  + parseFloat(itemtmp.vvtotalcusto);
                                    vself.vtotdesc                   = vself.vtotdesc    + parseFloat(itemtmp.vdesconto);
                                    }).catch(function (response) {
                                        loader.hide();
                                    });

                                }
                            }
                            $('#eddtemissao').focus(); 
                        }, 700);
                    }
                }                
            },
            mtdrotinaatualizacoes(nota){
                if (!util.opcaousuario('010Z.010Z.040Z', this.$store.state.perfilusuario)){
                    this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                }else {             
                    let vself               = this;
                    vself.notaatualizar     = nota;
                    vself.atipoatualizacao  = 0;
                    vself.fatorajuste       = 0;
                    $('#mdatualizacoes').modal('show');
                }
            },
            mtdconfirmaatualizacao(){
                let vself = this;
                if (parseInt(vself.atipoatualizacao) === 2){
                    if (parseFloat(vself.fatorajuste) <= 0){
                        vself.$toastr.w('Fator de ajuste inválido!', 'Atenção!');
                        $('#edfatorajuste').focus();
                        return;
                    }                
                }
                $.confirm({
                    title: 'Confirmação!',
                    content: 'Confirma atualizações da Nota?',
                    icon: 'fa fa-question-circle',
                    escapeKey: true,
                    backgroundDismiss: false,
                    escapeKey: 'nao',
                    type: 'dark',
                    typeAnimated: true,
                    buttons: {
                        sim: {
                            text: '<u>S</u>im',
                            keys: ['s', 'S'],
                            btnClass: 'btn-blue',
                            action: function () {
                                $('.btn-blue').prop('disabled', true);
                                let loader = vself.$loading.show();
                                let notaatz = {
                                    'idfornecedor'      : vself.notaatualizar.idfornecedor,
                                    'idfilial'          : vself.notaatualizar.idfilial,
                                    'numero'            : vself.notaatualizar.numero,
                                    'somentecusto'      : !vself.vatzsomentecusto ? 0 : 1,
                                    'tipoatz'           : vself.atipoatualizacao,
                                    'fatorajuste'       : vself.fatorajuste
                                };
                                let parametros      = [
                                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                                    {parametro: 'op',           valor : 'atualizar'},
                                    {parametro: 'nota',         valor : JSON.stringify(notaatz)},
                                    {parametro: 'idfilial',     valor : vself.$store.state.filialpadrao.codfil},
                                    {parametro: 'idusuario',    valor : vself.$store.state.usuario.id},
                                    {parametro: 'codop',        valor : '010Z.010Z.040Z'},
                                ];
                                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadnotasfornecedores.php');
                                retorno.then(function (response) {
                                    loader.hide();
                                    $('#mdatualizacoes').modal('hide');	
                                    if ($.isNumeric(response.data)){                        
                                        vself.$toastr.s('Nota atualizada com sucesso!', 'Informação!');
                                    }else{
                                        let tpret = response.data.substring(0,1);
                                        switch (tpret) {
                                            case 'I':
                                                vself.$toastr.w(response.data.substring(4), 'Atenção!');
                                                break;
                                            case 'E': default:
                                                vself.$toastr.e(response.data.substring(4), 'Erro!');
                                                break;
                                        }
                                    }
                                    vself.pnumero        = vself.notaatualizar.numero;
                                    vself.pfiltroperiodo = 0;
                                    vself.pefetivadas    = 2;

                                    let deffilial = new Option(vself.notaatualizar.fantasiafilial, vself.notaatualizar.idfilial, true, true);
                                    $('#cbfilialpesq').append(deffilial).trigger('change');	                        

                                    let deffornecedor = new Option(vself.notaatualizar.nomefornecedor, vself.notaatualizar.idfornecedor, true, true);
                                    $('#cbfornecedorpesq').append(deffornecedor).trigger('change');	                                                
                                    
                                    vself.pqtd_paginas  = 1;
                                    vself.mtdcancelaredicao();
                                    vself.mtdcarreganotas(1);                    
                                }).catch(function (response) {
                                    loader.hide();
                                    vself.$toastr.e('Erro ao efetivar a nota. Descrição do erro: '+response.message, 'Erro!');
                                });                                         
                            },
                        },
                        nao: {
                            text: '<u>N</u>ão',
                            keys: ['n', 'N'],
                            action: function () {
                            }
                        }
                    }
                });   
            },
            mtdselecionararquivoxml(event){                
                let vself            = this;                 
                vself.arqselecionado = event.target.files[0];

                let extarq  = vself.arqselecionado.name.substring(vself.arqselecionado.name.lastIndexOf('.') + 1);
                if (extarq.toUpperCase() !== 'XML'){
                    vself.arqselecionado = null;
                    vself.$toastr.w('O arquivo selecionado não possui um formato válido', 'Atenção!');
                    return;
                }

                let loader      = vself.$loading.show();
                let localsalvar = 'controller/xmlimportacaotmp';

                let parametros      = [
                    {parametro: 'arquivo',          valor  : vself.arqselecionado},
                    {parametro: 'localsalvar',      valor  : localsalvar},
                    {parametro: 'nomearquivo',      valor  : vself.arqselecionado.name}
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/uploadfile.php');
                retorno.then(function (response) {
                    if ($.isNumeric(response.data.inf)){
                        //rotina para inclusão da nf
                        vself.midfilialmanifesto     = vself.$store.state.filialpadrao.codfil;
                        var deffilial  			= new Option(vself.$store.state.filialpadrao.fantasia, vself.midfilialmanifesto, true, true);
                        $('#cbfilialmanifesto').append(deffilial).trigger('change');                

                        vself.mtdentradapeloxml('', vself.arqselecionado.name);                        
                    }else{
                        vself.arqselecionado = null;
                        $('#ipselecionararquivo').val('');
                        vself.$toastr.e('Descrição do erro: '+response.data, 'Erro!');
                    }
                    loader.hide();
                }).catch(function (response) {
                    loader.hide();
                    vself.$toastr.e('Descrição do erro: '+response.message, 'Erro!');
                    vself.arqselecionado = null;
                    $('#ipselecionararquivo').val('');
                });                
            },
            mtdcalculaprtabela(){
                if (parseFloat(this.vprcusto) > 0){                
                    let vlcustounitario  = parseFloat(this.vvtotalcusto) / parseFloat(this.vqtditemedicao);
                    //let vladd       = parseFloat(this.vmrgtabela) * parseFloat(this.vprcusto)  / 100;
                    //this.vvltabela  = parseFloat(this.vprcusto) + vladd;                
                    let vladd       = parseFloat(this.vmrgtabela) * parseFloat(vlcustounitario)  / 100;
                    this.vvltabela  = parseFloat(vlcustounitario) + vladd;                
                }else{
                    this.vvltabela  = 0;
                }
            },
            mtdcalculamrgtabela(){
                let dif = parseFloat(this.vvltabela) - parseFloat(this.vprcusto);
                if (dif > 0){                    
                    if(parseFloat(this.vprcusto) > 0){
                        let mrg = dif / parseFloat(this.vprcusto) * 100;
                        this.vmrgtabela = mrg;
                    }else{
                        this.vmrgtabela = 0;
                    }
                }else{
                    this.vmrgtabela = 0;
                }                
            },            
            mtdcalculaprvendamedio(){
                if (!this.vcalcularprvendamedio){
                    if (this.lstTabelasPrecos.length > 0){
                        let vsoma = 0;
                        for (let i = 0; i < this.lstTabelasPrecos.length; i++) {
                            vsoma = vsoma + parseFloat(this.lstTabelasPrecos[i]['prtabela']);                       
                        }
                        this.vprvendamedio = vsoma / this.lstTabelasPrecos.length;
                    }else{
                        this.vprvendamedio = 0;
                    }
                }
                let difpr = this.vprvendamedio - this.vprcusto;
                if (parseFloat(this.vprcusto) > 0){
                    this.vmargemprcusto = (difpr / this.vprcusto * 100).toFixed(2);
                }else{
                    this.vmargemprcusto = 0;
                }   
            },            
            mtdgravartabela(){
                if (parseInt(this.voptabela) === 1){//inclusão da tabela
                    if (this.vidtabelapreco === null) {
                        this.$toastr.w('Tabela de preço deve ser informada!', 'Atenção!');
                        $('#cbtabelapreco').select2('open');
                    }else if (this.vvltabela <= 0) {
                        this.$toastr.w('Preço de venda deve ser informado!', 'Atenção!');
                        $('#edvltabela').focus();
                    }else {
                        if (!util.findValInArray(this.lstTabelasPrecos, 'idtabela', this.vidtabelapreco)) {
                            let tabelapr = {
                                'idtabela'      : this.vidtabelapreco,
                                'desctabela'    : $('#cbtabelapreco').select2('data')[0]['text'],
                                'mrglucro'      : parseFloat(this.vmrgtabela),
                                'prtabela'      : parseFloat(this.vvltabela).toFixed(2),
                                'vlnf'          : parseFloat(this.vvlnf).toFixed(2),
                                'pcomissao'     : parseFloat(this.vcomissaotabela),
                                'qtdminima'     : parseFloat(this.vqtdmintabela),
                                'vlvisualiza'   : parseFloat(this.vvlvizu),
                                'desconto'      : parseFloat(this.vdescontotabela),
                                'vldescpromocional' : parseFloat(this.vvldescpromocional)
                            };                            
                            this.lstTabelasPrecos.push(tabelapr);
                            this.vidtabelapreco  = null;
                            this.vmrgtabela      = 0;
                            this.vvltabela       = 0;
                            this.vvlnf           = 0;
                            this.vcomissaotabela = 0;
                            this.vqtdmintabela   = 0;
                            this.vvlvizu         = 0;
                            this.vdescontotabela = 0;
                            this.vvldescpromocional = 0;
                            this.voptabela       = 1;
                            this.habdestab       = false;                            
                            $('#cbtabelapreco').val(null).trigger('change');
                            this.mtdcalculaprvendamedio();
                            $('#cbtabelapreco').select2('open');
                        } else {
                            this.$toastr.w('Tabela de preço já cadastrada!', 'Atenção!');
                            $('#cbtabelapreco').select2('open');
                        }
                    }
                }else{//alteração da tabela
                    let indt = util.getArrayIndexForKey(this.lstTabelasPrecos, 'idtabela', this.vidtabelapreco);
                    this.lstTabelasPrecos[indt].mrglucro    = parseFloat(this.vmrgtabela);
                    this.lstTabelasPrecos[indt].prtabela    = parseFloat(this.vvltabela).toFixed(2);
                    this.lstTabelasPrecos[indt].vlnf        = parseFloat(this.vvlnf).toFixed(2);
                    this.lstTabelasPrecos[indt].pcomissao   = parseFloat(this.vcomissaotabela);
                    this.lstTabelasPrecos[indt].qtdminima   = parseFloat(this.vqtdmintabela);
                    this.lstTabelasPrecos[indt].vlvisualiza = parseFloat(this.vvlvizu);
                    this.lstTabelasPrecos[indt].desconto    = parseFloat(this.vdescontotabela);
                    this.lstTabelasPrecos[indt].vldescpromocional = parseFloat(this.vvldescpromocional);    
                    this.vidtabelapreco  = null;
                    this.vmrgtabela      = 0;
                    this.vvltabela       = 0;
                    this.vvlnf           = 0;
                    this.vcomissaotabela = 0;
                    this.vqtdmintabela   = 0;
                    this.vdescontotabela = 0;
                    this.vvlvizu         = 0;
                    this.vvldescpromocional = 0;
                    this.voptabela       = 1;
                    this.habdestab       = false;
                    $('#cbtabelapreco').val(null).trigger('change');
                    this.mtdcalculaprvendamedio();
                    $('#cbtabelapreco').select2('open');
                }
            },
            mtdalterartabela(tabela){
                if (!this.ativadesativa) {   
                    this.voptabela  = 2;  
                    this.habdestab  = true;
                    var deftab      = new Option(tabela.desctabela, tabela.idtabela, true, true);
                    $('#cbtabelapreco').append(deftab).trigger('change');
                    this.vmrgtabela         = tabela.mrglucro;
                    this.vvltabela          = tabela.prtabela;
                    this.vvlvizu            = tabela.vlvisualiza;
                    this.vvlnf              = tabela.vlnf;
                    this.vcomissaotabela    = tabela.pcomissao;
                    this.vqtdmintabela      = tabela.qtdminima;
                    this.vdescontotabela    = tabela.desconto;
                    this.vvldescpromocional = tabela.vldescpromocional;
                    $('#edvltabela').focus();
                }
            },
            mtdcancelartabela(){
                this.voptabela          = 1; 
                this.habdestab          = false;
                this.vmrgtabela         = 0;
                this.vvltabela          = 0;
                this.vvlvizu            = 0;
                this.vvlnf              = 0;
                this.vcomissaotabela    = 0;
                this.vqtdmintabela      = 0;
                this.vdescontotabela    = 0;    
                this.vvldescpromocional = 0;            
                $('#cbtabelapreco').val(null).trigger('change');
                $('#cbtabelapreco').select2('open');                  
            },
            mtddeletatabela(index) {
                this.lstTabelasPrecos.splice(index, 1);
                this.mtdcalculaprvendamedio();
            },
            mtdsalvartabelasdeprecos(){
                let vself = this;                
                $.confirm({
                    title: 'Confirmação!',
                    content: 'Confirma alterações da(s) tabela(s) de preço(s) do item?',
                    icon: 'fa fa-question-circle',
                    escapeKey: true,
                    backgroundDismiss: false,
                    escapeKey: 'nao',
                    type: 'dark',
                    typeAnimated: true,
                    buttons: {
                        sim: {
                            text: '<u>S</u>im',
                            keys: ['s', 'S'],
                            btnClass: 'btn-blue',
                            action: function () {
                                $('.btn-blue').prop('disabled', true);
                                let loader = vself.$loading.show();
                                let parametros      = [
                                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                                    {parametro: 'op',           valor : 'salvartabelasprecos'},
                                    {parametro: 'idproduto',    valor : vself.vidprodutoedicao},
                                    {parametro: 'descricao',    valor : vself.vdescricaoprodutoedicao},
                                    {parametro: 'tabelas',      valor : JSON.stringify(vself.lstTabelasPrecos)},
                                    {parametro: 'idfilial',     valor : vself.$store.state.filialpadrao.codfil},
                                    {parametro: 'idusuario',    valor : vself.$store.state.usuario.id},
                                    {parametro: 'codop',        valor : '010Z.010Z.025Z'},
                                ];
                                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadnotasfornecedores.php');
                                retorno.then(function (response) {
                                    loader.hide();
                                    $('#mdatualizacoes').modal('hide');	
                                    if ($.isNumeric(response.data)){                        
                                        vself.$toastr.s('Tabelas de preços salvas com sucesso!', 'Informação!');
                                    }else{
                                        let tpret = response.data.substring(0,1);
                                        switch (tpret) {
                                            case 'I':
                                                vself.$toastr.w(response.data.substring(4), 'Atenção!');
                                                break;
                                            case 'E': default:
                                                vself.$toastr.e(response.data.substring(4), 'Erro!');
                                                break;
                                        }
                                    }
                                }).catch(function (response) {
                                    loader.hide();
                                    vself.$toastr.e('Erro ao tentar salvar as tabelas de preços. Descrição do erro: '+response.message, 'Erro!');
                                });                                         
                            },
                        },
                        nao: {
                            text: '<u>N</u>ão',
                            keys: ['n', 'N'],
                            action: function () {
                            }
                        }
                    }
                }); 
            },
            mtdsalvarclasses(){
                let vself = this;                
                $.confirm({
                    title: 'Confirmação!',
                    content: 'Confirma alterações da(s) classe(s) do item?',
                    icon: 'fa fa-question-circle',
                    escapeKey: true,
                    backgroundDismiss: false,
                    escapeKey: 'nao',
                    type: 'dark',
                    typeAnimated: true,
                    buttons: {
                        sim: {
                            text: '<u>S</u>im',
                            keys: ['s', 'S'],
                            btnClass: 'btn-blue',
                            action: function () {
                                $('.btn-blue').prop('disabled', true);
                                let loader = vself.$loading.show();
                                let parametros      = [
                                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                                    {parametro: 'op',           valor : 'salvarclasses'},
                                    {parametro: 'idproduto',    valor : vself.vidprodutoedicao},
                                    {parametro: 'descricao',    valor : vself.vdescricaoprodutoedicao},
                                    {parametro: 'classes',      valor : JSON.stringify(vself.lstClassesProduto)},
                                    {parametro: 'idfilial',     valor : vself.$store.state.filialpadrao.codfil},
                                    {parametro: 'idusuario',    valor : vself.$store.state.usuario.id},
                                    {parametro: 'codop',        valor : '010Z.010Z.050Z'},
                                ];
                                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadnotasfornecedores.php');
                                retorno.then(function (response) {
                                    loader.hide();
                                    $('#mdatualizacoes').modal('hide');	
                                    if ($.isNumeric(response.data)){                        
                                        vself.$toastr.s('Classe(s) de preço(s) salva(s) com sucesso!', 'Informação!');
                                    }else{
                                        let tpret = response.data.substring(0,1);
                                        switch (tpret) {
                                            case 'I':
                                                vself.$toastr.w(response.data.substring(4), 'Atenção!');
                                                break;
                                            case 'E': default:
                                                vself.$toastr.e(response.data.substring(4), 'Erro!');
                                                break;
                                        }
                                    }
                                }).catch(function (response) {
                                    loader.hide();
                                    vself.$toastr.e('Erro ao tentar salvar as tabelas de preços. Descrição do erro: '+response.message, 'Erro!');
                                });                                         
                            },
                        },
                        nao: {
                            text: '<u>N</u>ão',
                            keys: ['n', 'N'],
                            action: function () {
                            }
                        }
                    }
                }); 
            },
            mtddetalhesnota(nota){
                let vself = this;
                vself.lstitensexportar  = [];
                vself.detnota           = nota;
                $('#mddetalhesnf').modal('show');
            },
            mtddefinirconferida(nota){
                let vself  = this;
                let loader = vself.$loading.show();
                let parametros      = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor : 'conferida'},
                    
                    {parametro: 'idfilialnota', valor : nota.idfilial},
                    {parametro: 'numero',       valor : nota.numero},
                    {parametro: 'idfornecedor', valor : nota.idfornecedor},
                    {parametro: 'conferida',    valor : nota.conferida},

                    {parametro: 'idfilial',     valor : vself.$store.state.filialpadrao.codfil},
                    {parametro: 'idusuario',    valor : vself.$store.state.usuario.id},
                    {parametro: 'codop',        valor : '010Z.010Z.050Z'},//gerar o id
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadnotasfornecedores.php');
                retorno.then(function (response) {
                    loader.hide();
                    $('#mddetalhesnf').modal('hide');	
                    if ($.isNumeric(response.data)){                        
                        vself.$toastr.s('Status da conferência alterado com sucesso!', 'Informação!');
                    }else{
                        let tpret = response.data.substring(0,1);
                        switch (tpret) {
                            case 'I':
                                vself.$toastr.w(response.data.substring(4), 'Atenção!');
                                break;
                            case 'E': default:
                                vself.$toastr.e(response.data.substring(4), 'Erro!');
                                break;
                        }
                    }
                    vself.pnumero        = nota.numero;
                    vself.pfiltroperiodo = 0;
                    vself.pefetivadas    = 2;

                    let deffilial = new Option(nota.fantasiafilial, nota.idfilial, true, true);
                    $('#cbfilialpesq').append(deffilial).trigger('change');	                        

                    let deffornecedor = new Option(nota.nomefornecedor, nota.idfornecedor, true, true);
                    $('#cbfornecedorpesq').append(deffornecedor).trigger('change');	                                                
                    
                    vself.pqtd_paginas  = 1;
                    vself.mtdcancelaredicao();
                    vself.mtdcarreganotas(1);                    
                }).catch(function (response) {
                    loader.hide();
                    vself.$toastr.e('Erro ao alterar status da conferência. Descrição do erro: '+response.message, 'Erro!');
                });                
            },
            mtdalterartotalizadores(){
                this.ttotalizadoraplicar     = 0;
                this.tvaloraplicar           = 0;
                $('#mdlalterartotalizadores').modal('show');
            },
            mtddistribuirtotalizador(){
                let vself = this;

                let loader = vself.$loading.show();
                let vtotcalc                     = vself.vtotvtotal;
                vself.vtotvicms                  = 0;
                vself.vtotvipi                   = 0;
                vself.vtotvfrete                 = 0;
                vself.vtotvoutros                = 0;
                vself.vtotbcst                   = 0;
                vself.vtotst                     = 0;
                vself.vtotvpis                   = 0;
                vself.vtotvcofins                = 0;
                vself.vtotvtotal                 = 0;
                vself.vtotvcusto                 = 0;                
                vself.vtotdesc                   = 0;

                
                if (vself.lstitensnota.length > 0){
                    for (let inditem = 0; inditem < vself.lstitensnota.length; inditem++){
                        let prci        = parseFloat(vself.lstitensnota[inditem].vvtotal) / parseFloat(vtotcalc) * 100;
                        let vlcalcular  = (parseFloat(vself.lstitensnota[inditem].prcompra) - parseFloat(vself.lstitensnota[inditem].vdesconto)) * parseFloat(vself.lstitensnota[inditem].qtditem);

                        switch (parseInt(vself.ttotalizadoraplicar)) {
                            case 0: vself.lstitensnota[inditem].vvicms        = parseFloat(vself.tvaloraplicar) * prci / 100;
                                    if (parseFloat(vself.lstitensnota[inditem].vvicms) > 0){
                                        vself.lstitensnota[inditem].vpicms = parseFloat(vself.lstitensnota[inditem].vvicms) / vlcalcular * 100;
                                    }else{
                                        vself.lstitensnota[inditem].vpicms = 0;
                                    }                            
                                break;
                            case 1: vself.lstitensnota[inditem].vvfrete       = parseFloat(vself.tvaloraplicar) * prci / 100;
                                    if (parseFloat(vself.lstitensnota[inditem].vvfrete) > 0){
                                        vself.lstitensnota[inditem].vpfrete = parseFloat(vself.lstitensnota[inditem].vvfrete) / vlcalcular * 100;
                                    }else{
                                        vself.lstitensnota[inditem].vpfrete = 0;
                                    }
                                break;
                            case 2: vself.lstitensnota[inditem].vvpis         = parseFloat(vself.tvaloraplicar) * prci / 100;
                                    if (parseFloat(vself.lstitensnota[inditem].vvpis) > 0){
                                        vself.lstitensnota[inditem].vppis = parseFloat(vself.lstitensnota[inditem].vvpis) / vlcalcular * 100;
                                    }else{
                                        vself.lstitensnota[inditem].vppis = 0;
                                    }                            
                                break;                        
                            case 3: vself.lstitensnota[inditem].vvipi         = parseFloat(vself.tvaloraplicar) * prci / 100;
                                    if (parseFloat(vself.lstitensnota[inditem].vvipi) > 0){
                                        vself.lstitensnota[inditem].vpipi = parseFloat(vself.lstitensnota[inditem].vvipi) / vlcalcular * 100;
                                    }else{
                                        vself.lstitensnota[inditem].vpipi = 0;
                                    }                            
                                break;                        
                            case 4: vself.lstitensnota[inditem].vvoutros      = parseFloat(vself.tvaloraplicar) * prci / 100;
                                    if (parseFloat(vself.lstitensnota[inditem].vvoutros) > 0){
                                        vself.lstitensnota[inditem].vpoutros = parseFloat(vself.lstitensnota[inditem].vvoutros) / vlcalcular * 100;
                                    }else{
                                        vself.lstitensnota[inditem].vpoutros = 0;
                                    }
                                break;                        
                            case 5: vself.lstitensnota[inditem].vvcofins      = parseFloat(vself.tvaloraplicar) * prci / 100;
                                    if (parseFloat(vself.lstitensnota[inditem].vvcofins) > 0){
                                        vself.lstitensnota[inditem].vpcofins = parseFloat(vself.lstitensnota[inditem].vvcofins) / vlcalcular * 100;
                                    }else{
                                        vself.lstitensnota[inditem].vpcofins = 0;
                                    }                            
                                break;                        
                            case 6: vself.lstitensnota[inditem].vvicmsst       = (parseFloat(vself.tvaloraplicar) * prci / 100) / vself.lstitensnota[inditem].qtditem;
                                    if (parseFloat(vself.lstitensnota[inditem].vvicmsst) > 0){
                                        vself.lstitensnota[inditem].vpicmsst = parseFloat(vself.lstitensnota[inditem].vvicmsst) / vlcalcular * 100;
                                    }else{
                                        vself.lstitensnota[inditem].vpicmsst = 0;
                                    }                            
                                break;                        
                        }
                        let totalcustoitem = util.calculacustoproduto(this, 
                                                parseFloat(vself.lstitensnota[inditem].vpipi)/100,
                                                parseFloat(vself.lstitensnota[inditem].vpicms)/100,
                                                parseFloat(vself.lstitensnota[inditem].vpfrete)/100,
                                                parseFloat(vself.lstitensnota[inditem].vpicmsst),//verificar depois o calculo da substituição tributária
                                                parseFloat(vself.lstitensnota[inditem].vppis/100),
                                                parseFloat(vself.lstitensnota[inditem].vpcofins/100),
                                                parseFloat(vself.lstitensnota[inditem].vpoutros/100),
                                                parseFloat(vself.lstitensnota[inditem].prcompra) - parseFloat(vself.lstitensnota[inditem].vdesconto),
                                                parseFloat(vself.lstitensnota[inditem].vprvendamedio),
                                                vself.vformulacustopro//carregado quando a filial é selecionada
                                            );
                        vself.lstitensnota[inditem].vprcusto      = totalcustoitem;
                        vself.lstitensnota[inditem].vvtotalcusto  = totalcustoitem * vself.lstitensnota[inditem].qtditem;                        
                        //atualiza o total da nota com os novos valores
                        vself.vtotvicms                  = parseFloat(vself.vtotvicms)   + parseFloat(vself.lstitensnota[inditem].vvicms);
                        vself.vtotvipi                   = parseFloat(vself.vtotvipi)    + parseFloat(vself.lstitensnota[inditem].vvipi);
                        vself.vtotvfrete                 = parseFloat(vself.vtotvfrete)  + parseFloat(vself.lstitensnota[inditem].vvfrete);
                        vself.vtotvoutros                = parseFloat(vself.vtotvoutros) + parseFloat(vself.lstitensnota[inditem].vvoutros);
                        vself.vtotbcst                   = parseFloat(vself.vtotbcst)    + parseFloat(vself.lstitensnota[inditem].vvbcst);
                        vself.vtotst                     = parseFloat(vself.vtotst)      + (parseFloat(vself.lstitensnota[inditem].vvicmsst) * parseFloat(vself.lstitensnota[inditem].qtditem));
                        vself.vtotvpis                   = parseFloat(vself.vtotvpis)    + parseFloat(vself.lstitensnota[inditem].vvpis);
                        vself.vtotvcofins                = parseFloat(vself.vtotvcofins) + parseFloat(vself.lstitensnota[inditem].vvcofins);
                        vself.vtotvtotal                 = parseFloat(vself.vtotvtotal)  + parseFloat(vself.lstitensnota[inditem].vvtotal);
                        vself.vtotvcusto                 = parseFloat(vself.vtotvcusto)  + parseFloat(vself.lstitensnota[inditem].vvtotalcusto);                        
                        vself.vtotdesc                   = parseFloat(vself.vtotdesc)    + parseFloat(vself.lstitensnota[inditem].vdesconto);
                    }
                }
                loader.hide();
                $('#mdlalterartotalizadores').modal('hide');
            },
            mtdincluirclasse(){
                if (this.vidclasse == null) {
                    this.$toastr.w('Classe deve ser informada!', 'Atenção!');
                    $("#cbclasse").focus();
                    return;
                }
                if (this.vidfilialclasse == null) {
                    this.$toastr.w('Filial deve ser informada!', 'Atenção!');
                    $("#cbfilialclasse").focus();
                    return false;
                }
                let classeproduto = {
                    'idclasse'     : this.vidclasse,
                    'descclasse'   : $('#cbclasse').select2('data')[0]['text'],
                    'idfilial'     : this.vidfilialclasse,
                    'fantasia'     : $('#cbfilialclasse').select2('data')[0]['text']
                }
                if (!this.AchaClasseFil(this.lstClassesProduto, classeproduto.idclasse, classeproduto.idfilial)){
                    this.lstClassesProduto.push(classeproduto);
                    this.vidclasse       = null;
                    this.vidfilialclasse = null;
                    $('#cbclasse').val(null).trigger('change');
                    $('#cbfilialclasse').val(null).trigger('change');
                    $('#cbclasse').focus();
                }else{
                    this.$toastr.w('Classe já inclusa para a filial!', 'Atenção!');
                    $('#cbclasse').focus();
                }                
            },
            mtdexcluirclasse(index){
                this.lstClassesProduto.splice(index, 1);
            },
            AchaClasseFil(arr, idclasse, idfilial) {
                if (arr){
                    for (var i = 0; i < arr.length; i++) {
                        if (arr[i]['idclasse'] == idclasse && arr[i]['idfilial'] == idfilial) return true;
                    }
                }
                return false;
            },
            mtdexportarexcel(){
				this.lstitensexportar = JSON.parse(JSON.stringify(this.detnota.itens));
                setTimeout(() => {
                    $('#btexportarexcel').click();                    
                }, 200);                
            },
            mtdcalculavalorimpostoclasse(){
                let vself   = this;
                let ret     = util.itemcomimposto(vself.iclasse, parseFloat(vself.ivalorbase), 1, 0, 0);

                vself.ivalorimposto    = ret.totalimpostoitem;
                vself.ivalorcomimposto = ret.vltotalitem;	                
            },
            mtdvisualizarimpostovalor(){
                this.ivalorbase              = 0;
                this.iidclasse               = null;
                this.iclasse                 = [];
                this.ivalorimposto           = 0;
                this.ivalorcomimposto        = 0; 
                $('#cbiclasse').val(null).trigger('change');            
                $('#mdimpostovalor').modal('show');
            },
            mtdselecionavalorbase(){
                this.vvltabela = this.ivalorbase;
                this.mtdcalculamrgtabela();
                this.iclasse   = [];
                this.vvlvizu   = this.vvltabela;                
                $('#mdimpostovalor').modal('hide');                
            },
            mtdinformarvalordescpromocional(){
                if (parseFloat(this.vvltabela) > 0){
                    $('#mdinformarvalordescpromocional').modal('show');                
                }
            },
            mtdcalcularvalordescpromocional(){
                let dif = parseFloat(this.avalorsemdescpromocional) - parseFloat(this.avalorcomdescpromocional);
                if (parseFloat(this.avalorsemdescpromocional) > 0){
                    this.amargemdescpromocional = (parseFloat(dif) / parseFloat(this.avalorsemdescpromocional) * 100).toFixed(2);                
                }else{
                    this.amargemdescpromocional = 0;
                }
            },
            mtdaplicarpercentualdescpromocional(){
                if (parseFloat(this.amargemdescpromocional) > 0){
                    this.vvldescpromocional = this.amargemdescpromocional;
                    $('#mdinformarvalordescpromocional').modal('hide');
                }else{
                    this.$toastr.w('Margem deve ser maior que 0(zero)!', 'Informação!');
                    $('#edvalorcomdescpromocional').focus(); 
                }
            }
        },
        mounted: function () {
            if (util.verificasessao(this)) {
                let vself = this;
                let loader = vself.$loading.show();
                let parametros = [
                    {parametro: 'op', valor: 'dadosusuario'},
                    {parametro: 'idclientesac', valor  : vself.$store.state.usuario.idclientesac},
                    {parametro: 'idusuario', valor: vself.$store.state.usuario.id}
                ];
                let retorno = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rotinasusuario.php');
                retorno.then(function (response) {
                    loader.hide();
                    vself.$store.commit('MUDAR_PERFIL_USUARIO', response.data.perfilusu);
                    if (util.opcaousuario('010Z.010Z', vself.$store.state.perfilusuario)) {
                        vself.vhabilitaedicaotabelas = util.opcaousuario('010Z.010Z.025Z', vself.$store.state.perfilusuario);
                        vself.vhabilitaedicaoclasses = util.opcaousuario('010Z.010Z.050Z', vself.$store.state.perfilusuario);
                        vself.vhabrelacaopedcompra   = util.opcaousuario('010Z.010Z.038Z', vself.$store.state.perfilusuario);
                        $('#pnlista').fadeIn(700);
                        vself.mtdselect2_def();
                        vself.mtdexecutapesquisa();
                    } else {
                        vself.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                        setTimeout(function(){
                            util.gotoprincipal();
                        },1000);
                    }
                }).catch(function (response) {
                    loader.hide();
                    console.log(response.message);
                });

                //informar o valor para o cálculo do percentual do desconto promocional
                $('#mdinformarvalordescpromocional').on('shown.bs.modal', function(e){
                    vself.avalorsemdescpromocional = vself.vvltabela;
                    vself.avalorcomdescpromocional = vself.vvltabela - (parseFloat(vself.vvltabela) * parseFloat(vself.vvldescpromocional) / 100);
                    vself.mtdcalcularvalordescpromocional();
                    $('#edvalorcomdescpromocional').focus();
                }); 
            }
        },
        computed:{
            validou() {
                return this.vidfornecedor === null || this.vidfilial === null || this.vnumero === '' || this.vidfornecedor === '' ||
                       this.vdtemissao === null || this.vdtentrada === null || this.lstitensnota.length === 0;
            },
            idfornecedorretorno(){
                return this.$store.state.fornecedorretornoconsulta.idfornecedor;
			},
            idprodutoretorno(){
                return this.$store.state.produtoretornoconsulta.idproduto;
            },
            calculavaloresitem(){                         
                this.mtdcalculacustoitem(this.mtdtotalizador);
            },            
			selecionaperiodo(){
				if(parseInt(this.pfiltroperiodo) === 0){
					this.hab_desab_periodo = true;
				}else{
					this.hab_desab_periodo = false;
				}
            },
            camposnf(){
                if (parseInt(this.opcrud) > 2){
                    this.hab_desab_camposnf = true;
                }else{
                    if (parseInt(this.vtipo) === 0){
                        this.hab_desab_camposnf = false;
                    }else{
                        this.hab_desab_camposnf = true;
                    }
                }
            },
            temItens(){
                return this.lstitensnotas.length === 0
            }                                    
        },
        watch:{
            pagina_atual(val){
                this.mtdcarreganotas(val);
            },
            idfornecedorretorno(val){
                if (val !== null || val !== ''){
					this.vidfornecedor = val;
					this.mtdlocalizarfornecedor(this.vidfornecedor);					
                }
			},
            idprodutoretorno(val){
                if (val !== null || val !== ''){
                    switch (parseInt(this.origempesqpro)) {
                        case 0:
                            this.vcoddigedicao = val;
                            this.mtdlocalizarproduto(this.vcoddigedicao, this.origempesqpro);
                            break;
                        case 1:
                            this.mtdlocalizarproduto(val, this.origempesqpro);
                            break;
                    }					
                }
            },
            mtpevento(val){
                this.mxjust = '';
            },
            vtipo(){
                this.vmodelo            = '';
                this.vserie             = '';
                this.vnaturezaoperacao  = '';
                this.vchaveacesso       = '';
            },
            vatzsomentecusto(val){
                this.atipoatualizacao = 0;
            },
			vachouPro(){
                this.vfaltaitens = true

                for (var i = 0; i < this.lstitensnotas.length; i++) {									
                    if(this.lstitensnotas[i]['qtdfalta'] > 0){
                        this.vfaltaitens = false
                        break
                    }
                }
                if(this.vfaltaitens){
                    this.vfinalizado = true
                    this.ativadesativacod = true
                    this.videscpro = ''
                    this.$nextTick(function () {
                        $("#btngravar").focus()
                    })              
                }
			}            			            
        },
        setup() {
            // //Obs, o audio possui 3 sons diferentes, o sprite abaixo, pega cada posição
            const { play } = useSound(conferenciaSfx, {
                sprite: {
                    concluido: [0, 350],    
                    faltando: [374, 540],
                    alerta: [998, 350]
                },
            })

            return {
                play,
            }
        }        
    }
</script>
<style>
    .def-col-cod{
        width: 80px !important;
    }
    .def-col-item{
        width: 60px !important;
    }
    .def-col-valores{
        width: 100px !important;
    }
    .def-col-estoque{
        width: 150px !important;
    }
    .def-col-vtotvtotal{
        width: 150px;
    }   
    .def-col-situacao{
        width: 90px !important;
    }
    .def-col-conferida{
       width: 60px !important; 
    }
    #pinfprocedimento{
        background: #f7f7f7;
        text-indent: 1.5em;
        padding: 15px;
        border: 1px solid #ced4da;
        border-radius: 5px; 
    }
	.def-col-marca{
		min-width: 80px !important
    }
	.def-col-und{
		min-width: 80px !important
    }
    .def-col-qtd{
        min-width: 90px !important
    }
    .def-col-qtdconf{
        min-width: 90px !important
    }
    .def-col-qtdfalta{
        min-width: 90px !important
    }
    .bdg-alerta {
        border-radius: 8px !important;
        font-size: 14px !important;
        background-color: #c91212 !important;
        width: 100px;
    }
    .bdg-success {
        border-radius: 8px !important;
        font-size: 14px !important;
        background-color: #d7a519 !important;
        width: 100px;
    }
    .bdg-finalizado {
        border-radius: 8px !important;
        font-size: 14px !important;
        background-color: #28a745 !important;      
        width: 100px;
    }   
    .slot_detalhes{
        width: 50px;
    }
    .icon-detalhes{
        cursor: pointer;
        font-size: 22px;
        color: #d7a519;
    }  
    .def-col-slot-precos-nf-for{
        width: 140px !important;
    }            
</style>